/*! License details at fancyapps.com/license */ /*! License details at fancyapps.com/license */ /*! License details at fancyapps.com/license */ const $c7ba36523489ae88$export$844ec244b1367d54 = (t)=>"string" == typeof t;


/*! License details at fancyapps.com/license */ const $eb5b53ddd8b73bd7$export$8ee0fc9ee280b4ee = (n)=>n && null !== n && n instanceof Element && "nodeType" in n;


/*! License details at fancyapps.com/license */ const $ca2529f528ef56ef$export$2bb74740c4e19def = function(e) {
    if (!(e && e instanceof Element && e.offsetParent)) return !1;
    let n = !1, i = !1;
    if (e.scrollWidth > e.clientWidth) {
        const i = window.getComputedStyle(e).overflowX, t = -1 !== i.indexOf("hidden"), o = -1 !== i.indexOf("clip"), d = -1 !== i.indexOf("visible");
        n = !t && !o && !d;
    }
    if (e.scrollHeight > e.clientHeight) {
        const n = window.getComputedStyle(e).overflowY, t = -1 !== n.indexOf("hidden"), o = -1 !== n.indexOf("clip"), d = -1 !== n.indexOf("visible");
        i = !t && !o && !d;
    }
    return n || i;
}, $ca2529f528ef56ef$export$e41e80160bed5714 = function(i, t) {
    return !i || i === document.body || t && i === t ? null : $ca2529f528ef56ef$export$2bb74740c4e19def(i) ? i : $ca2529f528ef56ef$export$e41e80160bed5714(i.parentElement, t);
};


/*! License details at fancyapps.com/license */ const $b8a64cd90ff0bd86$export$b368690db5627d91 = function(e) {
    var t = (new DOMParser).parseFromString(e, "text/html").body;
    if (t.childElementCount > 1) {
        for(var n = document.createElement("div"); t.firstChild;)n.appendChild(t.firstChild);
        return n;
    }
    let r = t.firstChild;
    return !r || r instanceof HTMLElement ? r : ((n = document.createElement("div")).appendChild(r), n);
};


/*! License details at fancyapps.com/license */ const $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4 = function(t = 0, n = 0, a = 0) {
    return Math.max(Math.min(n, a), t);
};


/*! License details at fancyapps.com/license */ 
/*! License details at fancyapps.com/license */ /*! License details at fancyapps.com/license */ const $1e899da006e724cc$export$53b83ca8eaab0383 = (t)=>"object" == typeof t && null !== t && t.constructor === Object && "[object Object]" === Object.prototype.toString.call(t);


function $9ed3f50d5263ead5$var$e(e) {
    return (0, $1e899da006e724cc$export$53b83ca8eaab0383)(e) || Array.isArray(e);
}
function $9ed3f50d5263ead5$export$248d38f6296296c5(t, r) {
    const o = Object.keys(t), c = Object.keys(r);
    return o.length === c.length && o.every((o)=>{
        const c = t[o], i = r[o];
        return "function" == typeof c ? `${c}` == `${i}` : $9ed3f50d5263ead5$var$e(c) && $9ed3f50d5263ead5$var$e(i) ? $9ed3f50d5263ead5$export$248d38f6296296c5(c, i) : c === i;
    });
}


const $04c8ca71f19bc6bc$var$e = function(n) {
    for (const t of $04c8ca71f19bc6bc$var$s)t.getState() === $04c8ca71f19bc6bc$export$7f967bab4408cae2.Running && t.tick($04c8ca71f19bc6bc$var$a ? n - $04c8ca71f19bc6bc$var$a : 0);
    $04c8ca71f19bc6bc$var$a = n, $04c8ca71f19bc6bc$var$u = window.requestAnimationFrame($04c8ca71f19bc6bc$var$e);
};
var $04c8ca71f19bc6bc$export$7f967bab4408cae2, $04c8ca71f19bc6bc$var$o, $04c8ca71f19bc6bc$export$b4fa0e08d7ac6a23;
!function(n) {
    n[n.Initializing = 0] = "Initializing", n[n.Running = 1] = "Running", n[n.Paused = 2] = "Paused", n[n.Completed = 3] = "Completed", n[n.Destroyed = 4] = "Destroyed";
}($04c8ca71f19bc6bc$export$7f967bab4408cae2 || ($04c8ca71f19bc6bc$export$7f967bab4408cae2 = {})), function(n) {
    n[n.Spring = 0] = "Spring", n[n.Ease = 1] = "Ease";
}($04c8ca71f19bc6bc$var$o || ($04c8ca71f19bc6bc$var$o = {})), function(n) {
    n[n.Loop = 0] = "Loop", n[n.Reverse = 1] = "Reverse";
}($04c8ca71f19bc6bc$export$b4fa0e08d7ac6a23 || ($04c8ca71f19bc6bc$export$b4fa0e08d7ac6a23 = {}));
const $04c8ca71f19bc6bc$var$s = new Set;
let $04c8ca71f19bc6bc$var$u = null, $04c8ca71f19bc6bc$var$a = 0;
function $04c8ca71f19bc6bc$export$208a41d6b4e37b97() {
    let a = $04c8ca71f19bc6bc$export$7f967bab4408cae2.Initializing, f = $04c8ca71f19bc6bc$var$o.Ease, l = 0, g = 0, p = $04c8ca71f19bc6bc$export$208a41d6b4e37b97.Easings.Linear, m = 500, d = 0, b = 0, S = 0, h = 0, y = 1 / 0, E = .01, R = .01, M = !1, j = {}, w = null, v = {}, O = {}, C = {}, L = 0, I = 0, D = $04c8ca71f19bc6bc$export$b4fa0e08d7ac6a23.Loop, z = $04c8ca71f19bc6bc$export$208a41d6b4e37b97.Easings.Linear;
    const N = new Map;
    function V(n, ...t) {
        for (const e of N.get(n) || [])e(...t);
    }
    function q(n) {
        return g = 0, n ? w = setTimeout(()=>{
            x();
        }, n) : x(), F;
    }
    function x() {
        a = $04c8ca71f19bc6bc$export$7f967bab4408cae2.Running, V("start", v, O);
    }
    function A() {
        if (a = $04c8ca71f19bc6bc$export$7f967bab4408cae2.Completed, C = {}, V("end", v), a === $04c8ca71f19bc6bc$export$7f967bab4408cae2.Completed) {
            if (l < L) {
                if (l++, D === $04c8ca71f19bc6bc$export$b4fa0e08d7ac6a23.Reverse) {
                    const n = Object.assign({}, j);
                    j = Object.assign({}, O), O = n;
                }
                q(I);
            } else l = 0;
        }
        return F;
    }
    const F = {
        getState: function() {
            return a;
        },
        easing: function(n) {
            return p = n, f = $04c8ca71f19bc6bc$var$o.Ease, C = {}, F;
        },
        duration: function(n) {
            return m = n, F;
        },
        spring: function(n = {}) {
            f = $04c8ca71f19bc6bc$var$o.Spring;
            const t = {
                velocity: 0,
                mass: 1,
                tension: 170,
                friction: 26,
                restDelta: .1,
                restSpeed: .1,
                maxSpeed: 1 / 0,
                clamp: !0
            }, { velocity: e, mass: i, tension: r, friction: s, restDelta: u, restSpeed: a, maxSpeed: c, clamp: l } = Object.assign(Object.assign({}, t), n);
            return d = e, b = i, S = r, h = s, R = u, E = a, y = c, M = l, C = {}, F;
        },
        isRunning: function() {
            return a === $04c8ca71f19bc6bc$export$7f967bab4408cae2.Running;
        },
        isSpring: function() {
            return f === $04c8ca71f19bc6bc$var$o.Spring;
        },
        from: function(n) {
            return v = Object.assign({}, n), F;
        },
        to: function(n) {
            return O = n, F;
        },
        repeat: function(n, t = 0, e = $04c8ca71f19bc6bc$export$b4fa0e08d7ac6a23.Loop, i) {
            return L = n, I = t, D = e, z = i || p, F;
        },
        on: function(n, t) {
            var e, i;
            return e = n, i = t, N.set(e, [
                ...N.get(e) || [],
                i
            ]), F;
        },
        off: function(n, t) {
            var e, i;
            return e = n, i = t, N.has(e) && N.set(e, N.get(e).filter((n)=>n !== i)), F;
        },
        start: function(n) {
            return (0, $9ed3f50d5263ead5$export$248d38f6296296c5)(v, O) || (a = $04c8ca71f19bc6bc$export$7f967bab4408cae2.Initializing, j = Object.assign({}, v), $04c8ca71f19bc6bc$var$s.add(this), $04c8ca71f19bc6bc$var$u || ($04c8ca71f19bc6bc$var$u = window.requestAnimationFrame($04c8ca71f19bc6bc$var$e)), q(n)), F;
        },
        pause: function() {
            return w && (clearTimeout(w), w = null), a === $04c8ca71f19bc6bc$export$7f967bab4408cae2.Running && (a = $04c8ca71f19bc6bc$export$7f967bab4408cae2.Paused, V("pause", v)), F;
        },
        end: A,
        tick: function(e) {
            e > 50 && (e = 50), g += e;
            let s = 0, u = !1;
            if (a !== $04c8ca71f19bc6bc$export$7f967bab4408cae2.Running) return F;
            if (f === $04c8ca71f19bc6bc$var$o.Ease) {
                s = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(0, g / m, 1), u = 1 === s;
                const t = D === $04c8ca71f19bc6bc$export$b4fa0e08d7ac6a23.Reverse ? z : p;
                for(const n in v)v[n] = j[n] + (O[n] - j[n]) * t(s);
            }
            if (f === $04c8ca71f19bc6bc$var$o.Spring) {
                const t = .001 * e;
                let i = 0;
                for(const e in v){
                    const o = O[e];
                    let r = v[e];
                    if ("number" != typeof o || isNaN(o) || "number" != typeof r || isNaN(r)) continue;
                    if (Math.abs(o - r) <= R) {
                        v[e] = o, C[e] = 0;
                        continue;
                    }
                    C[e] || ("object" == typeof d && "number" == typeof d[e] ? C[e] = d[e] : C[e] = "number" == typeof d ? d : 0);
                    let s = C[e];
                    s = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(-1 * Math.abs(y), s, Math.abs(y));
                    const u = s * b * h;
                    s += ((r > o ? -1 : 1) * (Math.abs(o - r) * S) - u) / b * t, r += s * t;
                    const a = v[e] > o ? r < o : r > o;
                    let c = Math.abs(s) < E && Math.abs(o - r) <= R;
                    M && a && (c = !0), c ? (r = o, s = 0) : i++, v[e] = r, C[e] = s;
                }
                u = !i;
            }
            const c = Object.assign({}, O);
            return V("step", v, j, O, s), u && a === $04c8ca71f19bc6bc$export$7f967bab4408cae2.Running && (0, $9ed3f50d5263ead5$export$248d38f6296296c5)(O, c) && (a = $04c8ca71f19bc6bc$export$7f967bab4408cae2.Completed, A()), F;
        },
        getStartValues: function() {
            return j;
        },
        getCurrentValues: function() {
            return v;
        },
        getCurrentVelocities: function() {
            return C;
        },
        getEndValues: function() {
            return O;
        },
        destroy: function() {
            a = $04c8ca71f19bc6bc$export$7f967bab4408cae2.Destroyed, w && (clearTimeout(w), w = null), j = v = O = {}, $04c8ca71f19bc6bc$var$s.delete(this);
        }
    };
    return F;
}
$04c8ca71f19bc6bc$export$208a41d6b4e37b97.destroy = ()=>{
    for (const n of $04c8ca71f19bc6bc$var$s)n.destroy();
    $04c8ca71f19bc6bc$var$u && (cancelAnimationFrame($04c8ca71f19bc6bc$var$u), $04c8ca71f19bc6bc$var$u = null);
}, $04c8ca71f19bc6bc$export$208a41d6b4e37b97.Easings = {
    Linear: function(n) {
        return n;
    },
    EaseIn: function(n) {
        return 0 === n ? 0 : Math.pow(2, 10 * n - 10);
    },
    EaseOut: function(n) {
        return 1 === n ? 1 : 1 - Math.pow(2, -10 * n);
    },
    EaseInOut: function(n) {
        return 0 === n ? 0 : 1 === n ? 1 : n < .5 ? Math.pow(2, 20 * n - 10) / 2 : (2 - Math.pow(2, -20 * n + 10)) / 2;
    }
};


/*! License details at fancyapps.com/license */ function $d26b20f49452df26$export$c4dfce035d43d1e0(e) {
    return "undefined" != typeof TouchEvent && e instanceof TouchEvent;
}
function $d26b20f49452df26$var$t(t, n) {
    const o = [], s = $d26b20f49452df26$export$c4dfce035d43d1e0(t) ? t[n] : t instanceof MouseEvent && ("changedTouches" === n || "mouseup" !== t.type) ? [
        t
    ] : [];
    for (const e of s)o.push({
        x: e.clientX,
        y: e.clientY,
        ts: Date.now()
    });
    return o;
}
function $d26b20f49452df26$export$6385f9b89f59465f(e) {
    return $d26b20f49452df26$var$t(e, "touches");
}
function $d26b20f49452df26$export$2952c3b2d86d9aa2(e) {
    return $d26b20f49452df26$var$t(e, "targetTouches");
}
function $d26b20f49452df26$export$1ae15396032099be(e) {
    return $d26b20f49452df26$var$t(e, "changedTouches");
}
function $d26b20f49452df26$export$b820caf342892892(e) {
    const t = e[0], n = e[1] || t;
    return {
        x: (t.x + n.x) / 2,
        y: (t.y + n.y) / 2,
        ts: n.ts
    };
}
function $d26b20f49452df26$export$79376507b09a66f(e) {
    const t = e[0], n = e[1] || e[0];
    return t && n ? -1 * Math.sqrt((n.x - t.x) * (n.x - t.x) + (n.y - t.y) * (n.y - t.y)) : 0;
}
const $d26b20f49452df26$var$c = (e)=>{
    e.cancelable && e.preventDefault();
}, $d26b20f49452df26$var$a = {
    passive: !1
}, $d26b20f49452df26$var$u = {
    panThreshold: 5,
    swipeThreshold: 3,
    ignore: [
        "textarea",
        "input",
        "select",
        "[contenteditable]",
        "[data-selectable]",
        "[data-draggable]"
    ]
};
let $d26b20f49452df26$var$d = !1, $d26b20f49452df26$var$l = !0;
const $d26b20f49452df26$export$1f911e2d31b2843e = (e, t)=>{
    let f, h, v, g, p, m = Object.assign(Object.assign({}, $d26b20f49452df26$var$u), t), E = [], w = [], y = [], T = !1, b = !1, M = !1, L = !1, x = 0, P = 0, D = 0, X = 0, Y = 0, j = 0, k = 0, R = 0, z = 0, A = [];
    const O = new Map;
    function S(e) {
        const t = $d26b20f49452df26$export$79376507b09a66f(w), n = $d26b20f49452df26$export$79376507b09a66f(y), o = t && n ? t / n : 0, s = Math.abs(k) > Math.abs(R) ? k : R, i = {
            srcEvent: f,
            isPanRecognized: T,
            isSwipeRecognized: b,
            firstTouch: E,
            previousTouch: y,
            currentTouch: w,
            deltaX: D,
            deltaY: X,
            offsetX: Y,
            offsetY: j,
            velocityX: k,
            velocityY: R,
            velocity: s,
            angle: z,
            axis: v,
            scale: o,
            center: h
        };
        for (const t of O.get(e) || [])t(i);
    }
    function q(e) {
        const t = e.target, n = e.composedPath()[0], o = m.ignore.join(","), s = (e)=>e && e instanceof HTMLElement && (e.matches(o) || e.closest(o));
        if (s(t) || s(n)) return !1;
    }
    function C(e) {
        const t = Date.now();
        if (A = A.filter((e)=>!e.ts || e.ts > t - 100), e && A.push(e), k = 0, R = 0, A.length > 3) {
            const e = A[0], t = A[A.length - 1];
            if (e && t) {
                const n = t.x - e.x, o = t.y - e.y, s = e.ts && t.ts ? t.ts - e.ts : 0;
                s > 0 && (k = Math.abs(n) > 3 ? n / (s / 30) : 0, R = Math.abs(o) > 3 ? o / (s / 30) : 0);
            }
        }
    }
    function H(e) {
        if (!1 === q(e)) return;
        if ("undefined" != typeof MouseEvent && e instanceof MouseEvent) {
            if ($d26b20f49452df26$var$d) return;
        } else $d26b20f49452df26$var$d = !0;
        if ("undefined" != typeof MouseEvent && e instanceof MouseEvent) {
            if (!e.buttons || 0 !== e.button) return;
            $d26b20f49452df26$var$c(e);
        }
        e instanceof MouseEvent && (window.addEventListener("mousemove", I), window.addEventListener("mouseup", B)), window.addEventListener("blur", F), f = e, w = $d26b20f49452df26$export$2952c3b2d86d9aa2(e), E = [
            ...w
        ], y = [], P = w.length, h = $d26b20f49452df26$export$b820caf342892892(w), 1 === P && (T = !1, b = !1, M = !1), P && C($d26b20f49452df26$export$b820caf342892892(w));
        const t = Date.now(), n = t - (x || t);
        L = n > 0 && n <= 250 && 1 === P, x = t, clearTimeout(g), S("start");
    }
    function I(e) {
        var t;
        if (!E.length) return;
        if (e.defaultPrevented) return;
        if (!1 === q(e)) return;
        f = e, y = [
            ...w
        ], w = $d26b20f49452df26$export$6385f9b89f59465f(e);
        const o = $d26b20f49452df26$export$b820caf342892892(y), s = $d26b20f49452df26$export$b820caf342892892($d26b20f49452df26$export$6385f9b89f59465f(e));
        if (C(s), P = w.length, h = s, y.length === w.length ? (D = s.x - o.x, X = s.y - o.y) : (D = 0, X = 0), E.length) {
            const e = $d26b20f49452df26$export$b820caf342892892(E);
            Y = s.x - e.x, j = s.y - e.y;
        }
        if (w.length > 1) {
            const e = $d26b20f49452df26$export$79376507b09a66f(w), t = $d26b20f49452df26$export$79376507b09a66f(y);
            Math.abs(e - t) >= .1 && (M = !0, S("pinch"));
        }
        T || (T = Math.abs(Y) >= m.panThreshold || Math.abs(j) >= m.panThreshold, T && ($d26b20f49452df26$var$l = !1, clearTimeout(p), p = void 0, z = Math.abs(180 * Math.atan2(j, Y) / Math.PI), v = z > 45 && z < 135 ? "y" : "x", E = [
            ...w
        ], y = [
            ...w
        ], Y = 0, j = 0, D = 0, X = 0, null === (t = window.getSelection()) || void 0 === t || t.removeAllRanges(), S("panstart"))), T && (D || X) && S("pan"), S("move");
    }
    function B(e) {
        if (f = e, !E.length) return;
        const t = $d26b20f49452df26$export$2952c3b2d86d9aa2(e), n = $d26b20f49452df26$export$1ae15396032099be(e);
        if (P = t.length, h = $d26b20f49452df26$export$b820caf342892892(n), n.length && C($d26b20f49452df26$export$b820caf342892892(n)), y = [
            ...w
        ], w = [
            ...t
        ], E = [
            ...t
        ], P > 0) S("end"), T = !1, b = !1, A = [];
        else {
            const e = m.swipeThreshold;
            (Math.abs(k) > e || Math.abs(R) > e) && (b = !0), T && S("panend"), b && S("swipe"), T || b || M || (S("tap"), L ? S("doubleTap") : g = setTimeout(function() {
                S("singleTap");
            }, 250)), S("end"), G();
        }
    }
    function F() {
        clearTimeout(g), G(), T && S("panend"), S("end");
    }
    function G() {
        $d26b20f49452df26$var$d = !1, T = !1, b = !1, L = !1, P = 0, A = [], w = [], y = [], E = [], D = 0, X = 0, Y = 0, j = 0, k = 0, R = 0, z = 0, v = void 0, window.removeEventListener("mousemove", I), window.removeEventListener("mouseup", B), window.removeEventListener("blur", F), $d26b20f49452df26$var$l || p || (p = setTimeout(()=>{
            $d26b20f49452df26$var$l = !0, p = void 0;
        }, 100));
    }
    function J(e) {
        const t = e.target;
        $d26b20f49452df26$var$d = !1, t && !e.defaultPrevented && ($d26b20f49452df26$var$l || ($d26b20f49452df26$var$c(e), e.stopPropagation()));
    }
    const K = {
        init: function() {
            return e && (e.addEventListener("click", J, $d26b20f49452df26$var$a), e.addEventListener("mousedown", H, $d26b20f49452df26$var$a), e.addEventListener("touchstart", H, $d26b20f49452df26$var$a), e.addEventListener("touchmove", I, $d26b20f49452df26$var$a), e.addEventListener("touchend", B), e.addEventListener("touchcancel", B)), K;
        },
        on: function(e, t) {
            return function(e, t) {
                O.set(e, [
                    ...O.get(e) || [],
                    t
                ]);
            }(e, t), K;
        },
        off: function(e, t) {
            return O.has(e) && O.set(e, O.get(e).filter((e)=>e !== t)), K;
        },
        isPointerDown: ()=>P > 0,
        destroy: function() {
            clearTimeout(g), clearTimeout(p), p = void 0, e && (e.removeEventListener("click", J, $d26b20f49452df26$var$a), e.removeEventListener("mousedown", H, $d26b20f49452df26$var$a), e.removeEventListener("touchstart", H, $d26b20f49452df26$var$a), e.removeEventListener("touchmove", I, $d26b20f49452df26$var$a), e.removeEventListener("touchend", B), e.removeEventListener("touchcancel", B)), e = null, G();
        }
    };
    return K;
};
$d26b20f49452df26$export$1f911e2d31b2843e.isClickAllowed = ()=>$d26b20f49452df26$var$l;


/*! License details at fancyapps.com/license */ const $77c0c4b6415a52c3$export$30568d076ec2f42 = {
    IMAGE_ERROR: "This image couldn't be loaded. <br /> Please try again later.",
    MOVE_UP: "Move up",
    MOVE_DOWN: "Move down",
    MOVE_LEFT: "Move left",
    MOVE_RIGHT: "Move right",
    ZOOM_IN: "Zoom in",
    ZOOM_OUT: "Zoom out",
    TOGGLE_FULL: "Toggle zoom level",
    TOGGLE_1TO1: "Toggle zoom level",
    ITERATE_ZOOM: "Toggle zoom level",
    ROTATE_CCW: "Rotate counterclockwise",
    ROTATE_CW: "Rotate clockwise",
    FLIP_X: "Flip horizontally",
    FLIP_Y: "Flip vertically",
    RESET: "Reset",
    TOGGLE_FS: "Toggle fullscreen"
};


/*! License details at fancyapps.com/license */ const $388a9fa95929b219$export$d2cf6cd1dc7067d3 = (s, t = "")=>{
    s && s.classList && t.split(" ").forEach((t)=>{
        t && s.classList.add(t);
    });
};


/*! License details at fancyapps.com/license */ const $a4c70e77d1c194a1$export$c2255604a80b4506 = (s, t = "")=>{
    s && s.classList && t.split(" ").forEach((t)=>{
        t && s.classList.remove(t);
    });
};


/*! License details at fancyapps.com/license */ const $98c82c03f7f08e20$export$4a80062ca50b57c7 = (s, t = "", c)=>{
    s && s.classList && t.split(" ").forEach((t)=>{
        t && s.classList.toggle(t, c || !1);
    });
};



const $de7268de96c5ce00$var$h = (e)=>{
    e.cancelable && e.preventDefault();
}, $de7268de96c5ce00$var$m = (e, t = 1e4)=>(e = parseFloat(e + "") || 0, Math.round((e + Number.EPSILON) * t) / t), $de7268de96c5ce00$var$p = (e)=>e instanceof HTMLImageElement;
var $de7268de96c5ce00$export$9520bccbaf78266, $de7268de96c5ce00$export$97fb49bddd4ef65d;
!function(e) {
    e.Reset = "reset", e.Zoom = "zoom", e.ZoomIn = "zoomIn", e.ZoomOut = "zoomOut", e.ZoomTo = "zoomTo", e.ToggleCover = "toggleCover", e.ToggleFull = "toggleFull", e.ToggleMax = "toggleMax", e.IterateZoom = "iterateZoom", e.Pan = "pan", e.Swipe = "swipe", e.Move = "move", e.MoveLeft = "moveLeft", e.MoveRight = "moveRight", e.MoveUp = "moveUp", e.MoveDown = "moveDown", e.RotateCCW = "rotateCCW", e.RotateCW = "rotateCW", e.FlipX = "flipX", e.FlipY = "flipY", e.ToggleFS = "toggleFS";
}($de7268de96c5ce00$export$9520bccbaf78266 || ($de7268de96c5ce00$export$9520bccbaf78266 = {})), function(e) {
    e.Cover = "cover", e.Full = "full", e.Max = "max";
}($de7268de96c5ce00$export$97fb49bddd4ef65d || ($de7268de96c5ce00$export$97fb49bddd4ef65d = {}));
const $de7268de96c5ce00$export$15463f5204f2871f = {
    x: 0,
    y: 0,
    scale: 1,
    angle: 0,
    flipX: 1,
    flipY: 1
}, $de7268de96c5ce00$var$x = {
    bounds: !0,
    classes: {
        container: "f-panzoom",
        wrapper: "f-panzoom__wrapper",
        content: "f-panzoom__content",
        viewport: "f-panzoom__viewport"
    },
    clickAction: $de7268de96c5ce00$export$9520bccbaf78266.ToggleFull,
    dblClickAction: !1,
    gestures: {},
    height: "auto",
    l10n: (0, $77c0c4b6415a52c3$export$30568d076ec2f42),
    maxScale: 4,
    minScale: 1,
    mouseMoveFactor: 1,
    panMode: "drag",
    protected: !1,
    singleClickAction: !1,
    spinnerTpl: '<div class="f-spinner"></div>',
    wheelAction: $de7268de96c5ce00$export$9520bccbaf78266.Zoom,
    width: "auto"
};
let $de7268de96c5ce00$var$w, $de7268de96c5ce00$var$M = 0, $de7268de96c5ce00$var$j = 0, $de7268de96c5ce00$var$E = 0;
const $de7268de96c5ce00$export$b704d075ddd20210 = (c, b = {}, S = {})=>{
    let k, O, T, A, C, F, Z, L, P = 0, X = Object.assign(Object.assign({}, $de7268de96c5ce00$var$x), b), Y = {}, R = Object.assign({}, $de7268de96c5ce00$export$15463f5204f2871f), z = Object.assign({}, $de7268de96c5ce00$export$15463f5204f2871f);
    const D = [];
    function I(e) {
        let t = X[e];
        return t && "function" == typeof t ? t(je) : t;
    }
    function W() {
        return c && c.parentElement && k && 3 === P;
    }
    const $ = new Map;
    function q(e, ...t) {
        const n = [
            ...$.get(e) || []
        ];
        X.on && n.push(X.on[e]);
        for (const e of n)e && e instanceof Function && e(je, ...t);
        "*" !== e && q("*", e, ...t);
    }
    function H(e) {
        if (!W()) return;
        const t = e.target;
        if ((0, $ca2529f528ef56ef$export$e41e80160bed5714)(t)) return;
        const o = Date.now(), s = [
            -e.deltaX || 0,
            -e.deltaY || 0,
            -e.detail || 0
        ].reduce(function(e, t) {
            return Math.abs(t) > Math.abs(e) ? t : e;
        }), a = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(-1, s, 1);
        q("wheel", e, a);
        const r = I("wheelAction");
        if (!r) return;
        if (e.defaultPrevented) return;
        const l = z.scale;
        let c = l * (a > 0 ? 1.5 : .5);
        if (r === $de7268de96c5ce00$export$9520bccbaf78266.Zoom) {
            const t = Math.abs(e.deltaY) < 100 && Math.abs(e.deltaX) < 100;
            if (o - $de7268de96c5ce00$var$j < (t ? 200 : 45)) return void $de7268de96c5ce00$var$h(e);
            $de7268de96c5ce00$var$j = o;
            const n = ne(), s = se();
            if ($de7268de96c5ce00$var$m(c) < $de7268de96c5ce00$var$m(n) && $de7268de96c5ce00$var$m(l) <= $de7268de96c5ce00$var$m(n) ? ($de7268de96c5ce00$var$E += Math.abs(a), c = n) : $de7268de96c5ce00$var$m(c) > $de7268de96c5ce00$var$m(s) && $de7268de96c5ce00$var$m(l) >= $de7268de96c5ce00$var$m(s) ? ($de7268de96c5ce00$var$E += Math.abs(a), c = s) : ($de7268de96c5ce00$var$E = 0, c = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(n, c, s)), $de7268de96c5ce00$var$E > 7) return;
        }
        switch($de7268de96c5ce00$var$h(e), r){
            case $de7268de96c5ce00$export$9520bccbaf78266.Pan:
                ce(r, {
                    srcEvent: e,
                    deltaX: 2 * -e.deltaX,
                    deltaY: 2 * -e.deltaY
                });
                break;
            case $de7268de96c5ce00$export$9520bccbaf78266.Zoom:
                ce($de7268de96c5ce00$export$9520bccbaf78266.ZoomTo, {
                    srcEvent: e,
                    scale: c,
                    center: {
                        x: e.clientX,
                        y: e.clientY
                    }
                });
                break;
            default:
                ce(r, {
                    srcEvent: e
                });
        }
    }
    function _(e) {
        var n, o;
        const i = e.composedPath()[0];
        if (!(0, $d26b20f49452df26$export$1f911e2d31b2843e).isClickAllowed()) return;
        if (!(0, $eb5b53ddd8b73bd7$export$8ee0fc9ee280b4ee)(i) || e.defaultPrevented) return;
        if (!(null == c ? void 0 : c.contains(i))) return;
        if (i.hasAttribute("disabled") || i.hasAttribute("aria-disabled") || i.hasAttribute("data-carousel-go-prev") || i.hasAttribute("data-carousel-go-next")) return;
        const s = i.closest("[data-panzoom-action]"), a = null === (n = null == s ? void 0 : s.dataset) || void 0 === n ? void 0 : n.panzoomAction, r = (null === (o = null == s ? void 0 : s.dataset) || void 0 === o ? void 0 : o.panzoomValue) || "";
        if (a) {
            switch($de7268de96c5ce00$var$h(e), a){
                case $de7268de96c5ce00$export$9520bccbaf78266.ZoomTo:
                case $de7268de96c5ce00$export$9520bccbaf78266.ZoomIn:
                case $de7268de96c5ce00$export$9520bccbaf78266.ZoomOut:
                    ce(a, {
                        scale: parseFloat(r || "") || void 0
                    });
                    break;
                case $de7268de96c5ce00$export$9520bccbaf78266.MoveLeft:
                case $de7268de96c5ce00$export$9520bccbaf78266.MoveRight:
                    ce(a, {
                        deltaX: parseFloat(r || "") || void 0
                    });
                    break;
                case $de7268de96c5ce00$export$9520bccbaf78266.MoveUp:
                case $de7268de96c5ce00$export$9520bccbaf78266.MoveDown:
                    ce(a, {
                        deltaY: parseFloat(r || "") || void 0
                    });
                    break;
                case $de7268de96c5ce00$export$9520bccbaf78266.ToggleFS:
                    we();
                    break;
                default:
                    ce(a);
            }
            return;
        }
        if (!(null == k ? void 0 : k.contains(i))) return;
        const u = {
            srcEvent: e
        };
        if (ce(I("clickAction"), u), I("dblClickAction")) {
            const e = Date.now(), t = e - ($de7268de96c5ce00$var$M || e);
            $de7268de96c5ce00$var$M = e, t > 0 && t <= 250 ? ($de7268de96c5ce00$var$w && (clearTimeout($de7268de96c5ce00$var$w), $de7268de96c5ce00$var$w = void 0), ce(I("dblClickAction"), u)) : $de7268de96c5ce00$var$w = setTimeout(()=>{
                ce(I("singleClickAction"), u);
            }, 250);
        }
    }
    function B(e) {
        if (L = e, !W() || !Q()) return;
        if (R.scale <= 1 || z.scale <= 1) return;
        if (((null == k ? void 0 : k.dataset.animationName) || "").indexOf("zoom") > -1) return;
        const t = ee(z.scale);
        if (!t) return;
        const { x: n, y: o } = t;
        ce($de7268de96c5ce00$export$9520bccbaf78266.Pan, {
            deltaX: n - z.x,
            deltaY: o - z.y
        });
    }
    function N() {
        var e;
        c && ((0, $a4c70e77d1c194a1$export$c2255604a80b4506)(c, "is-loading"), null === (e = c.querySelector(".f-spinner")) || void 0 === e || e.remove());
    }
    function V() {
        if (!c || !O) return;
        if (N(), $de7268de96c5ce00$var$p(O) && (!O.complete || !O.naturalWidth)) return P = 2, null == k || k.classList.add("has-error"), void q("error");
        q("loaded");
        const { width: e, height: t } = J();
        $de7268de96c5ce00$var$p(O) && (O.setAttribute("width", e + ""), O.setAttribute("height", t + "")), k && ((0, $a4c70e77d1c194a1$export$c2255604a80b4506)(k, "has-error"), $de7268de96c5ce00$var$p(O) && (k.setAttribute("width", e + ""), k.setAttribute("height", t + ""), k.style.aspectRatio = `${e / t || ""}`)), F = (0, $04c8ca71f19bc6bc$export$208a41d6b4e37b97)().on("start", (e, t)=>{
            void 0 !== t.angle && (t.angle = 90 * Math.round(t.angle / 90)), void 0 !== t.flipX && (t.flipX = t.flipX > 0 ? 1 : -1), void 0 !== t.flipY && (t.flipY = t.flipY > 0 ? 1 : -1), z = Object.assign(Object.assign({}, $de7268de96c5ce00$export$15463f5204f2871f), t), le(), q("animationStart");
        }).on("pause", (e)=>{
            z = Object.assign(Object.assign({}, $de7268de96c5ce00$export$15463f5204f2871f), e);
        }).on("step", (e)=>{
            if (!W()) return void (null == F || F.end());
            if (R = Object.assign(Object.assign({}, $de7268de96c5ce00$export$15463f5204f2871f), e), Q() || !I("bounds") || be() || z.scale > R.scale || z.scale < oe()) return void ue();
            const t = ae(z.scale);
            let n = !1, o = !1, s = !1, a = !1;
            R.x < t.x[0] && (n = !0), R.x > t.x[1] && (o = !0), R.y < t.y[0] && (a = !0), R.y > t.y[1] && (s = !0);
            let r = !1, l = !1, c = !1, u = !1;
            z.x < t.x[0] && (r = !0), z.x > t.x[1] && (l = !0), z.y < t.y[0] && (u = !0), z.y > t.y[1] && (c = !0);
            let d = !1;
            (o && l || n && r) && (z.x = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(t.x[0], z.x, t.x[1]), d = !0), (s && c || a && u) && (z.y = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(t.y[0], z.y, t.y[1]), d = !0), d && F && F.spring({
                tension: 94,
                friction: 17,
                maxSpeed: 555 * z.scale,
                restDelta: .1,
                restSpeed: .1,
                velocity: F.getCurrentVelocities()
            }).from(R).to(z).start(), ue();
        }).on("end", ()=>{
            (null == C ? void 0 : C.isPointerDown()) || re(), (null == F ? void 0 : F.isRunning()) || (le(), q("animationEnd"));
        }), function() {
            const e = I("gestures");
            if (!e) return;
            if (!A || !O) return;
            let t = !1;
            C = (0, $d26b20f49452df26$export$1f911e2d31b2843e)(A, e).on("start", (e)=>{
                if (!I("gestures")) return;
                if (!F) return;
                if (!W() || Q()) return;
                const n = e.srcEvent;
                (R.scale > 1 || e.currentTouch.length > 1) && (null == n || n.stopPropagation(), F.pause(), t = !0), 1 === e.currentTouch.length && q("touchStart");
            }).on("move", (e)=>{
                var n;
                t && (1 !== z.scale || e.currentTouch.length > 1) && ($de7268de96c5ce00$var$h(e.srcEvent), null === (n = e.srcEvent) || void 0 === n || n.stopPropagation());
            }).on("pan", (e)=>{
                if (!t) return;
                const n = e.srcEvent;
                (1 !== z.scale || e.currentTouch.length > 1) && ($de7268de96c5ce00$var$h(n), ce($de7268de96c5ce00$export$9520bccbaf78266.Pan, e));
            }).on("swipe", (e)=>{
                t && z.scale > 1 && ce($de7268de96c5ce00$export$9520bccbaf78266.Swipe, e);
            }).on("tap", (e)=>{
                q("click", e);
            }).on("singleTap", (e)=>{
                q("singleClick", e);
            }).on("doubleTap", (e)=>{
                q("dblClick", e);
            }).on("pinch", (e)=>{
                t && (e.scale > oe() ? ce($de7268de96c5ce00$export$9520bccbaf78266.ZoomIn, e) : e.scale < oe() ? ce($de7268de96c5ce00$export$9520bccbaf78266.ZoomOut, e) : ce($de7268de96c5ce00$export$9520bccbaf78266.Pan, e));
            }).on("end", (e)=>{
                t && (e.currentTouch.length ? (e.srcEvent.stopPropagation(), $de7268de96c5ce00$var$h(e.srcEvent), null == F || F.end()) : (t = !1, le(), re(), q("touchEnd")));
            }).init();
        }(), A && (A.addEventListener("wheel", H, {
            passive: !1
        }), D.push(()=>{
            null == A || A.removeEventListener("wheel", H, {
                passive: !1
            });
        })), null == c || c.addEventListener("click", _), null === document || void 0 === document || document.addEventListener("mousemove", B), D.push(()=>{
            null == c || c.removeEventListener("click", _), null === document || void 0 === document || document.removeEventListener("mousemove", B);
        });
        const n = U();
        R = Object.assign({}, n), z = Object.assign({}, n), P = 3, ue(), le(), q("ready"), requestAnimationFrame(()=>{
            3 === P && (N(), A && (A.style.visibility = ""));
        });
    }
    function U() {
        const e = Object.assign({}, I("startPos") || {});
        let t = e.scale, n = 1;
        n = "string" == typeof t ? te(t) : "number" == typeof t ? t : oe();
        const o = Object.assign(Object.assign(Object.assign({}, $de7268de96c5ce00$export$15463f5204f2871f), e), {
            scale: n
        }), i = Q() ? ee(n) : void 0;
        if (i) {
            const { x: e, y: t } = i;
            o.x = e, o.y = t;
        }
        return o;
    }
    function G() {
        const e = {
            top: 0,
            left: 0,
            width: 0,
            height: 0
        };
        if (k) {
            const t = k.getBoundingClientRect();
            z.angle % 180 == 90 ? (e.top = t.top + .5 * t.height - .5 * t.width, e.left = t.left + .5 * t.width - .5 * t.height, e.width = t.height, e.height = t.width) : (e.top = t.top, e.left = t.left, e.width = t.width, e.height = t.height);
        }
        return e;
    }
    function J() {
        let t = I("width"), n = I("height");
        if (O && "auto" === t) {
            const e = O.getAttribute("width");
            t = e ? parseFloat(e + "") : void 0 !== O.dataset.width ? parseFloat(O.dataset.width + "") : $de7268de96c5ce00$var$p(A) ? A.naturalWidth : $de7268de96c5ce00$var$p(O) ? O.naturalWidth : (null == k ? void 0 : k.getBoundingClientRect().width) || 0;
        } else t = (0, $c7ba36523489ae88$export$844ec244b1367d54)(t) ? parseFloat(t) : t;
        if (O && "auto" === n) {
            const e = O.getAttribute("height");
            n = e ? parseFloat(e + "") : void 0 !== O.dataset.height ? parseFloat(O.dataset.height + "") : $de7268de96c5ce00$var$p(A) ? A.naturalHeight : $de7268de96c5ce00$var$p(O) ? O.naturalHeight : (null == k ? void 0 : k.getBoundingClientRect().height) || 0;
        } else n = (0, $c7ba36523489ae88$export$844ec244b1367d54)(n) ? parseFloat(n) : n;
        return {
            width: t,
            height: n
        };
    }
    function K() {
        const e = G();
        return {
            width: e.width,
            height: e.height
        };
    }
    function Q() {
        return "mousemove" === I("panMode") && matchMedia("(hover: hover)").matches;
    }
    function ee(e) {
        const t = L || I("event"), n = null == k ? void 0 : k.getBoundingClientRect();
        if (!t || !n || e <= 1) return {
            x: 0,
            y: 0
        };
        const o = (t.clientX || 0) - n.left, s = (t.clientY || 0) - n.top, { width: a, height: r } = K(), l = ae(e);
        if (e > 1) {
            const t = I("mouseMoveFactor");
            t > 1 && (e *= t);
        }
        let c = a * e, u = r * e, d = .5 * (c - a) - o / a * 100 / 100 * (c - a), f = .5 * (u - r) - s / r * 100 / 100 * (u - r);
        return d = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(l.x[0], d, l.x[1]), f = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(l.y[0], f, l.y[1]), {
            x: d,
            y: f
        };
    }
    function te(e) {
        if (!e) return z.scale;
        if (!c) return 1;
        const t = c.getBoundingClientRect(), n = G(), { width: o, height: s } = J(), a = (e)=>{
            if ("number" == typeof e) return e;
            switch(e){
                case "min":
                case "base":
                    return 1;
                case "cover":
                    return Math.max(t.height / n.height, t.width / n.width) || 1;
                case "full":
                case "max":
                    {
                        const e = z.angle % 180 == 90 ? s : o;
                        return e && n.width ? e / n.width : 1;
                    }
            }
        }, r = I("minScale"), l = I("maxScale"), u = Math.min(a("full"), a(r)), d = "number" == typeof l ? a("full") * l : Math.min(a("full"), a(l));
        switch(e){
            case "min":
                return u;
            case "base":
                return (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(u, 1, d);
            case "cover":
                return a("cover");
            case "full":
                return Math.min(d, a("full"));
            case "max":
                return d;
        }
    }
    function ne() {
        return te("min");
    }
    function oe() {
        return te("base");
    }
    function ie() {
        return te("full");
    }
    function se() {
        return te("max");
    }
    function ae(e) {
        const t = {
            x: [
                0,
                0
            ],
            y: [
                0,
                0
            ]
        }, n = null == c ? void 0 : c.getBoundingClientRect();
        if (!n) return t;
        const o = G(), i = n.width, s = n.height;
        let a = o.width, r = o.height, l = e = void 0 === e ? z.scale : e, u = e;
        if (Q() && e > 1) {
            const t = I("mouseMoveFactor");
            t > 1 && (a * e > i + .01 && (l *= t), r * e > s + .01 && (u *= t));
        }
        return a *= l, r *= u, e > 1 && (a > i && (t.x[0] = .5 * (i - a), t.x[1] = .5 * (a - i)), t.x[0] -= .5 * (o.left - n.left), t.x[1] -= .5 * (o.left - n.left), t.x[0] -= .5 * (o.left + o.width - n.right), t.x[1] -= .5 * (o.left + o.width - n.right), r > s && (t.y[0] = .5 * (s - r), t.y[1] = .5 * (r - s)), t.y[0] -= .5 * (o.top - n.top), t.y[1] -= .5 * (o.top - n.top), t.y[0] -= .5 * (o.top + o.height - n.bottom), t.y[1] -= .5 * (o.top + o.height - n.bottom)), t;
    }
    function re() {
        if (!W()) return;
        if (!I("bounds")) return;
        if (!F) return;
        const e = ne(), t = se(), n = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(e, z.scale, t);
        if (z.scale < e - .01 || z.scale > t + .01) return void ce($de7268de96c5ce00$export$9520bccbaf78266.ZoomTo, {
            scale: n
        });
        if (F.isRunning()) return;
        if (be()) return;
        const o = ae(n);
        z.x < o.x[0] || z.x > o.x[1] || z.y < o.y[0] || z.y > o.y[1] ? (z.x = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(o.x[0], z.x, o.x[1]), z.y = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(o.y[0], z.y, o.y[1]), F.spring({
            tension: 170,
            friction: 17,
            restDelta: .001,
            restSpeed: .001,
            maxSpeed: 1 / 0,
            velocity: F.getCurrentVelocities()
        }), F.from(R).to(z).start()) : ue();
    }
    function le(e) {
        var t;
        if (!W()) return;
        const n = ve(), o = be(), i = ye(), s = xe(), a = fe(), r = ge();
        (0, $98c82c03f7f08e20$export$4a80062ca50b57c7)(k, "is-fullsize", s), (0, $98c82c03f7f08e20$export$4a80062ca50b57c7)(k, "is-expanded", i), (0, $98c82c03f7f08e20$export$4a80062ca50b57c7)(k, "is-dragging", o), (0, $98c82c03f7f08e20$export$4a80062ca50b57c7)(k, "can-drag", n), (0, $98c82c03f7f08e20$export$4a80062ca50b57c7)(k, "will-zoom-in", a), (0, $98c82c03f7f08e20$export$4a80062ca50b57c7)(k, "will-zoom-out", r);
        const l = me(), u = pe(), d = he(), g = !W();
        for (const n of (null === (t = e || c) || void 0 === t ? void 0 : t.querySelectorAll("[data-panzoom-action]")) || []){
            const e = n.dataset.panzoomAction;
            let t = !1;
            if (g) t = !0;
            else switch(e){
                case $de7268de96c5ce00$export$9520bccbaf78266.ZoomIn:
                    l || (t = !0);
                    break;
                case $de7268de96c5ce00$export$9520bccbaf78266.ZoomOut:
                    d || (t = !0);
                    break;
                case $de7268de96c5ce00$export$9520bccbaf78266.ToggleFull:
                    {
                        u || d || (t = !0);
                        const e = n.querySelector("g");
                        e && (e.style.display = s && !t ? "none" : "");
                        break;
                    }
                case $de7268de96c5ce00$export$9520bccbaf78266.IterateZoom:
                    {
                        l || d || (t = !0);
                        const e = n.querySelector("g");
                        e && (e.style.display = l || t ? "" : "none");
                        break;
                    }
                case $de7268de96c5ce00$export$9520bccbaf78266.ToggleCover:
                case $de7268de96c5ce00$export$9520bccbaf78266.ToggleMax:
                    l || d || (t = !0);
            }
            t ? (n.setAttribute("aria-disabled", ""), n.setAttribute("tabindex", "-1")) : (n.removeAttribute("aria-disabled"), n.removeAttribute("tabindex"));
        }
    }
    function ce(e, t) {
        var n;
        if (!(e && c && O && F && W())) return;
        if (e === $de7268de96c5ce00$export$9520bccbaf78266.Swipe && Math.abs(F.getCurrentVelocities().scale) > .01) return;
        const o = Object.assign({}, z);
        let s = Object.assign({}, z), l = ae(Q() ? o.scale : R.scale);
        const u = F.getCurrentVelocities(), d = G(), f = ((null === (n = (t = t || {}).currentTouch) || void 0 === n ? void 0 : n.length) || 0) > 1, h = t.velocityX || 0, m = t.velocityY || 0;
        let p = t.center;
        t.srcEvent && (p = (0, $d26b20f49452df26$export$b820caf342892892)((0, $d26b20f49452df26$export$1ae15396032099be)(t.srcEvent)));
        let b = t.deltaX || 0, x = t.deltaY || 0;
        switch(e){
            case $de7268de96c5ce00$export$9520bccbaf78266.MoveRight:
                b = t.deltaX || 100;
                break;
            case $de7268de96c5ce00$export$9520bccbaf78266.MoveLeft:
                b = t.deltaX || -100;
                break;
            case $de7268de96c5ce00$export$9520bccbaf78266.MoveUp:
                x = t.deltaY || -100;
                break;
            case $de7268de96c5ce00$export$9520bccbaf78266.MoveDown:
                x = t.deltaY || 100;
        }
        let w = [];
        if ("number" == typeof e) s.scale = e;
        else switch(e){
            case $de7268de96c5ce00$export$9520bccbaf78266.Reset:
                s = Object.assign({}, $de7268de96c5ce00$export$15463f5204f2871f), s.scale = oe();
                break;
            case $de7268de96c5ce00$export$9520bccbaf78266.ZoomTo:
            case $de7268de96c5ce00$export$9520bccbaf78266.ZoomIn:
            case $de7268de96c5ce00$export$9520bccbaf78266.ZoomOut:
            case $de7268de96c5ce00$export$9520bccbaf78266.ToggleCover:
            case $de7268de96c5ce00$export$9520bccbaf78266.ToggleFull:
            case $de7268de96c5ce00$export$9520bccbaf78266.ToggleMax:
            case $de7268de96c5ce00$export$9520bccbaf78266.IterateZoom:
            case $de7268de96c5ce00$export$9520bccbaf78266.Zoom:
                s.scale = de(e, t);
                break;
            case $de7268de96c5ce00$export$9520bccbaf78266.Pan:
            case $de7268de96c5ce00$export$9520bccbaf78266.Move:
            case $de7268de96c5ce00$export$9520bccbaf78266.MoveLeft:
            case $de7268de96c5ce00$export$9520bccbaf78266.MoveRight:
            case $de7268de96c5ce00$export$9520bccbaf78266.MoveUp:
            case $de7268de96c5ce00$export$9520bccbaf78266.MoveDown:
                if (be()) {
                    let e = 1, t = 1;
                    s.x <= l.x[0] && h <= 0 && (e = Math.max(.01, 1 - Math.abs(1 / d.width * Math.abs(s.x - l.x[0]))), e *= .2), s.x >= l.x[1] && h >= 0 && (e = Math.max(.01, 1 - Math.abs(1 / d.width * Math.abs(s.x - l.x[1]))), e *= .2), s.y <= l.y[0] && m <= 0 && (t = Math.max(.01, 1 - Math.abs(1 / d.height * Math.abs(s.y - l.y[0]))), t *= .2), s.y >= l.y[1] && m >= 0 && (t = Math.max(.01, 1 - Math.abs(1 / d.height * Math.abs(s.y - l.y[1]))), t *= .2), s.x += b * e, s.y += x * t;
                } else s.x = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(l.x[0], s.x + b, l.x[1]), s.y = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(l.y[0], s.y + x, l.y[1]);
                break;
            case $de7268de96c5ce00$export$9520bccbaf78266.Swipe:
                const n1 = (e = 0)=>Math.sign(e) * Math.pow(Math.abs(e), 1.5);
                s.x += (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(-1000, n1(h), 1e3), s.y += (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(-1000, n1(m), 1e3), m && !h && (s.x = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(l.x[0], s.x, l.x[1])), !m && h && (s.y = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(l.y[0], s.y, l.y[1])), u.x = h, u.y = m;
                break;
            case $de7268de96c5ce00$export$9520bccbaf78266.RotateCW:
                s.angle += 90;
                break;
            case $de7268de96c5ce00$export$9520bccbaf78266.RotateCCW:
                s.angle -= 90;
                break;
            case $de7268de96c5ce00$export$9520bccbaf78266.FlipX:
                s.flipX *= -1;
                break;
            case $de7268de96c5ce00$export$9520bccbaf78266.FlipY:
                s.flipY *= -1;
        }
        if (void 0 !== R.angle && Math.abs(R.angle) >= 360 && (s.angle -= 360 * Math.floor(R.angle / 360), R.angle -= 360 * Math.floor(R.angle / 360)), w.length) {
            const e = w.findIndex((e)=>e > s.scale + 1e-4);
            s.scale = w[e] || w[0];
        }
        if (f && (s.scale = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(ne() * (f ? .8 : 1), s.scale, se() * (f ? 1.6 : 1))), Q()) {
            const e = ee(s.scale);
            if (e) {
                const { x: t, y: n } = e;
                s.x = t, s.y = n;
            }
        } else if (Math.abs(s.scale - o.scale) > 1e-4) {
            let e = 0, t = 0;
            if (p) e = p.x, t = p.y;
            else {
                const n = c.getBoundingClientRect();
                e = n.x + .5 * n.width, t = n.y + .5 * n.height;
            }
            let n = e - d.left, a = t - d.top;
            n -= .5 * d.width, a -= .5 * d.height;
            const r = (n - o.x) / o.scale, u = (a - o.y) / o.scale;
            s.x = n - r * s.scale, s.y = a - u * s.scale, !f && I("bounds") && (l = ae(s.scale), s.x = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(l.x[0], s.x, l.x[1]), s.y = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(l.y[0], s.y, l.y[1]));
        }
        if (e === $de7268de96c5ce00$export$9520bccbaf78266.Swipe) {
            let e = 94, t = 17, n = 500 * s.scale, o = u;
            F.spring({
                tension: e,
                friction: t,
                maxSpeed: n,
                restDelta: .1,
                restSpeed: .1,
                velocity: o
            });
        } else e === $de7268de96c5ce00$export$9520bccbaf78266.Pan || f ? F.spring({
            tension: 900,
            friction: 17,
            restDelta: .01,
            restSpeed: .01,
            maxSpeed: 1
        }) : F.spring({
            tension: 170,
            friction: 17,
            restDelta: .001,
            restSpeed: .001,
            maxSpeed: 1 / 0,
            velocity: u
        });
        if (0 === t.velocity || (0, $9ed3f50d5263ead5$export$248d38f6296296c5)(R, s)) R = Object.assign({}, s), z = Object.assign({}, s), F.end(), ue(), le();
        else {
            if ((0, $9ed3f50d5263ead5$export$248d38f6296296c5)(z, s)) return;
            F.from(R).to(s).start();
        }
        q("action", e);
    }
    function ue() {
        if (!O || !k || !A) return;
        const { width: e, height: t } = J();
        Object.assign(k.style, {
            maxWidth: `min(${e}px, 100%)`,
            maxHeight: `min(${t}px, 100%)`
        });
        const n = function() {
            const { width: e, height: t } = J(), { width: n, height: o } = K();
            if (!c) return {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
                scale: 0,
                flipX: 0,
                flipY: 0,
                angle: 0,
                fitWidth: n,
                fitHeight: o,
                fullWidth: e,
                fullHeight: t
            };
            let { x: i, y: s, scale: a, angle: r, flipX: l, flipY: u } = R, d = 1 / ie(), f = e, g = t, h = R.scale * d, m = z.scale * d;
            const p = Math.max(n, o), v = Math.min(n, o);
            e > t ? (f = p, g = v) : (f = v, g = p);
            h = e > t ? p * a / e || 1 : p * a / t || 1;
            let b = f ? e * m : 0, y = g ? t * m : 0, x = f && g ? e * h / b : 0;
            return i = i + .5 * f - .5 * b, s = s + .5 * g - .5 * y, {
                x: i,
                y: s,
                width: b,
                height: y,
                scale: x,
                flipX: l,
                flipY: u,
                angle: r,
                fitWidth: n,
                fitHeight: o,
                fullWidth: e,
                fullHeight: t
            };
        }(), { x: o, y: i, width: s, height: a, scale: r, angle: l, flipX: u, flipY: d } = n;
        let f = `translate(${$de7268de96c5ce00$var$m(o)}px, ${$de7268de96c5ce00$var$m(i)}px)`;
        f += 1 !== u || 1 !== d ? ` scaleX(${$de7268de96c5ce00$var$m(r * u)}) scaleY(${$de7268de96c5ce00$var$m(r * d)})` : ` scale(${$de7268de96c5ce00$var$m(r)})`, 0 !== l && (f += ` rotate(${l}deg)`), A.style.width = `${$de7268de96c5ce00$var$m(s)}px`, A.style.height = `${$de7268de96c5ce00$var$m(a)}px`, A.style.transform = `${f}`, q("render");
    }
    function de(e = I("clickAction"), t = {}) {
        let n = z.scale, o = oe(), s = [];
        if ("number" == typeof e) o = e;
        else if (e) {
            switch(e){
                case $de7268de96c5ce00$export$9520bccbaf78266.ZoomTo:
                    o = t.scale || 1;
                    break;
                case $de7268de96c5ce00$export$9520bccbaf78266.ZoomIn:
                    o = n * (t.scale || 2);
                    break;
                case $de7268de96c5ce00$export$9520bccbaf78266.ZoomOut:
                    o = n * (t.scale || .5);
                    break;
                case $de7268de96c5ce00$export$9520bccbaf78266.ToggleCover:
                    s = [
                        oe(),
                        te("cover")
                    ];
                    break;
                case $de7268de96c5ce00$export$9520bccbaf78266.ToggleFull:
                    s = [
                        oe(),
                        ie()
                    ];
                    break;
                case $de7268de96c5ce00$export$9520bccbaf78266.ToggleMax:
                    s = [
                        oe(),
                        se()
                    ];
                    break;
                case $de7268de96c5ce00$export$9520bccbaf78266.IterateZoom:
                    s = [
                        oe(),
                        ie(),
                        se()
                    ];
                    break;
                case $de7268de96c5ce00$export$9520bccbaf78266.Zoom:
                    const e1 = ie();
                    o = n >= e1 - .05 ? oe() : Math.min(e1, n * (t.scale || 2));
            }
            if (s.length) {
                const e = s.findIndex((e)=>e > n + 1e-4);
                o = s[e] || oe();
            }
        }
        return e !== $de7268de96c5ce00$export$9520bccbaf78266.ZoomTo && (o = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(ne(), o, se())), o;
    }
    function fe() {
        return !!(W() && de() > z.scale);
    }
    function ge() {
        return !!(W() && de() < z.scale);
    }
    function he() {
        return !!(W() && z.scale > ne());
    }
    function me() {
        return !!(W() && z.scale < se());
    }
    function pe() {
        return !!(W() && z.scale < ie());
    }
    function ve() {
        return !(!(W() && ye() && C) || Q());
    }
    function be() {
        return !(!W() || !(null == C ? void 0 : C.isPointerDown()) || Q());
    }
    function ye() {
        return !!(W() && z.scale > oe());
    }
    function xe() {
        return !!(W() && z.scale >= ie());
    }
    function we() {
        const e = "in-fullscreen", t = "with-panzoom-in-fullscreen";
        null == c || c.classList.toggle(e);
        const n = null == c ? void 0 : c.classList.contains(e);
        n ? (document.documentElement.classList.add(t), document.addEventListener("keydown", Me, !0)) : (document.documentElement.classList.remove(t), document.removeEventListener("keydown", Me, !0)), ue(), q(n ? "enterFS" : "exitFS");
    }
    function Me(e) {
        "Escape" !== e.key || e.defaultPrevented || we();
    }
    const je = {
        canDrag: ve,
        canZoomIn: me,
        canZoomOut: he,
        canZoomToFull: pe,
        destroy: function() {
            q("destroy");
            for (const e of Object.values(Y))null == e || e.destroy(je);
            for (const e of D)e();
            return k && (k.style.aspectRatio = "", k.style.maxWidth = "", k.style.maxHeight = ""), A && (A.style.width = "", A.style.height = "", A.style.transform = ""), k = void 0, O = void 0, A = void 0, R = Object.assign({}, $de7268de96c5ce00$export$15463f5204f2871f), z = Object.assign({}, $de7268de96c5ce00$export$15463f5204f2871f), null == F || F.destroy(), F = void 0, null == C || C.destroy(), C = void 0, P = 4, je;
        },
        emit: q,
        execute: ce,
        getBoundaries: ae,
        getContainer: function() {
            return c;
        },
        getContent: function() {
            return O;
        },
        getFullDim: J,
        getGestures: function() {
            return C;
        },
        getMousemovePos: ee,
        getOptions: function() {
            return X;
        },
        getPlugins: function() {
            return Y;
        },
        getScale: te,
        getStartPosition: U,
        getState: function() {
            return P;
        },
        getTransform: function(e) {
            return !0 === e ? z : R;
        },
        getTween: function() {
            return F;
        },
        getViewport: function() {
            return A;
        },
        getWrapper: function() {
            return k;
        },
        init: function() {
            return P = 0, q("init"), function() {
                for (const [e, t] of Object.entries(Object.assign(Object.assign({}, S), X.plugins || {})))if (e && !Y[e] && t instanceof Function) {
                    const n = t();
                    n.init(je), Y[e] = n;
                }
                q("initPlugins");
            }(), function() {
                var e, t, n;
                const o = Object.assign(Object.assign({}, $de7268de96c5ce00$var$x.classes), I("classes")), i = null === (e = o.content) || void 0 === e ? void 0 : e.split(" ").shift(), s = null === (t = o.wrapper) || void 0 === t ? void 0 : t.split(" ").shift(), a = null === (n = o.viewport) || void 0 === n ? void 0 : n.split(" ").shift();
                if (!i || !s || !a) return;
                if (!c) return;
                if ((0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(c, o.container), O = c.querySelector(`.${i}:not(.is-clone)`), !O) return;
                O.setAttribute("draggable", "false"), k = c.querySelector(`.${s}`), k || (k = document.createElement("div"), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(k, o.wrapper), O.insertAdjacentElement("beforebegin", k), k.insertAdjacentElement("afterbegin", O));
                A = c.querySelector(`.${a}`), A || (A = document.createElement("div"), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(A, o.viewport), k.insertAdjacentElement("beforeend", A));
                A.contains(O) || A.insertAdjacentElement("afterbegin", O);
                T = c.querySelector(`.${i}.is-clone`), T || (T = O.cloneNode(!0), T.removeAttribute("id"), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(T, "is-clone"), k.insertAdjacentElement("afterbegin", T));
                O instanceof HTMLPictureElement && (O = O.querySelector("img"));
                T instanceof HTMLPictureElement && (T = T.querySelector("img"));
                A instanceof HTMLPictureElement && (A = A.querySelector("img"));
                if (A && (A.style.visibility = "hidden", I("protected"))) {
                    A.addEventListener("contextmenu", (e)=>{
                        $de7268de96c5ce00$var$h(e);
                    });
                    const e = document.createElement("div");
                    (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(e, "f-panzoom__protected"), A.appendChild(e);
                }
                q("initLayout");
            }(), function() {
                if (c && k && !Z) {
                    let e = null;
                    Z = new ResizeObserver(()=>{
                        W() && (e = e || requestAnimationFrame(()=>{
                            W() && (le(), re(), q("refresh")), e = null;
                        }));
                    }), Z.observe(k), D.push(()=>{
                        null == Z || Z.disconnect(), Z = void 0, e && (cancelAnimationFrame(e), e = null);
                    });
                }
            }(), function() {
                if (!c || !O) return;
                if (!$de7268de96c5ce00$var$p(O) || !$de7268de96c5ce00$var$p(T)) return void V();
                const e = ()=>{
                    O && $de7268de96c5ce00$var$p(O) && O.decode().then(()=>{
                        V();
                    }).catch(()=>{
                        V();
                    });
                };
                if (P = 1, c.classList.add("is-loading"), q("loading"), T.src && T.complete) return void e();
                (function() {
                    if (!c) return;
                    if (null == c ? void 0 : c.querySelector(".f-spinner")) return;
                    const e = I("spinnerTpl"), t = (0, $b8a64cd90ff0bd86$export$b368690db5627d91)(e);
                    t && (t.classList.add("f-spinner"), c.classList.add("is-loading"), null == k || k.insertAdjacentElement("afterbegin", t));
                })(), T.addEventListener("load", e, !1), T.addEventListener("error", e, !1), D.push(()=>{
                    null == T || T.removeEventListener("load", e, !1), null == T || T.removeEventListener("error", e, !1);
                });
            }(), je;
        },
        isDragging: be,
        isExpanded: ye,
        isFullsize: xe,
        isMousemoveMode: Q,
        localize: function(e, t = []) {
            const n = I("l10n") || {};
            e = String(e).replace(/\{\{(\w+)\}\}/g, (e, t)=>n[t] || e);
            for(let n = 0; n < t.length; n++)e = e.split(t[n][0]).join(t[n][1]);
            return e = e.replace(/\{\{(.*?)\}\}/g, (e, t)=>t);
        },
        off: function(e, t) {
            for (const n of e instanceof Array ? e : [
                e
            ])$.has(n) && $.set(n, $.get(n).filter((e)=>e !== t));
            return je;
        },
        on: function(e, t) {
            for (const n of e instanceof Array ? e : [
                e
            ])$.set(n, [
                ...$.get(n) || [],
                t
            ]);
            return je;
        },
        toggleFS: we,
        updateControls: le,
        version: "6.1.13",
        willZoomIn: fe,
        willZoomOut: ge
    };
    return je;
};
$de7268de96c5ce00$export$b704d075ddd20210.l10n = {
    en_EN: (0, $77c0c4b6415a52c3$export$30568d076ec2f42)
}, $de7268de96c5ce00$export$b704d075ddd20210.getDefaults = ()=>$de7268de96c5ce00$var$x;


/*! License details at fancyapps.com/license */ 



/*! License details at fancyapps.com/license */ const $9bfae0b36b942e6c$export$2b0209f2592da03b = (e, o)=>{
    let t = [];
    return e.childNodes.forEach((e)=>{
        e.nodeType !== Node.ELEMENT_NODE || o && !e.matches(o) || t.push(e);
    }), t;
};


/*! License details at fancyapps.com/license */ 
const $1b7cd36eed9df61a$export$8b58be045bf06082 = (t, ...e)=>{
    const n = e.length;
    for(let c = 0; c < n; c++){
        const n = e[c] || {};
        Object.entries(n).forEach(([e, n])=>{
            const c = Array.isArray(n) ? [] : {};
            t[e] || Object.assign(t, {
                [e]: c
            }), (0, $1e899da006e724cc$export$53b83ca8eaab0383)(n) ? Object.assign(t[e], $1b7cd36eed9df61a$export$8b58be045bf06082(t[e], n)) : Array.isArray(n) ? Object.assign(t, {
                [e]: [
                    ...n
                ]
            }) : Object.assign(t, {
                [e]: n
            });
        });
    }
    return t;
};


/*! License details at fancyapps.com/license */ 
const $fa17a272154af804$export$871de8747c9eaa88 = function(t = 0, n = 0, r = 0, c = 0, m = 0, p = !1) {
    const s = (t - n) / (r - n) * (m - c) + c;
    return p ? c < m ? (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(c, s, m) : (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(m, s, c) : s;
};









/*! License details at fancyapps.com/license */ 
const $af8c7da03e8ae19f$export$30568d076ec2f42 = Object.assign(Object.assign({}, (0, $77c0c4b6415a52c3$export$30568d076ec2f42)), {
    ERROR: "Something went wrong. <br /> Please try again later.",
    NEXT: "Next page",
    PREV: "Previous page",
    GOTO: "Go to page #%d",
    DOWNLOAD: "Download",
    TOGGLE_FULLSCREEN: "Toggle full-screen mode",
    TOGGLE_EXPAND: "Toggle full-size mode",
    TOGGLE_THUMBS: "Toggle thumbnails",
    TOGGLE_AUTOPLAY: "Toggle slideshow"
});


const $c22e488d48123133$var$m = (t)=>{
    t.cancelable && t.preventDefault();
}, $c22e488d48123133$var$h = {
    adaptiveHeight: !1,
    center: !0,
    classes: {
        container: "f-carousel",
        isEnabled: "is-enabled",
        isLTR: "is-ltr",
        isRTL: "is-rtl",
        isHorizontal: "is-horizontal",
        isVertical: "is-vertical",
        hasAdaptiveHeight: "has-adaptive-height",
        viewport: "f-carousel__viewport",
        slide: "f-carousel__slide",
        isSelected: "is-selected"
    },
    dragFree: !1,
    enabled: !0,
    errorTpl: '<div class="f-html">{{ERROR}}</div>',
    fill: !1,
    infinite: !0,
    initialPage: 0,
    l10n: (0, $af8c7da03e8ae19f$export$30568d076ec2f42),
    rtl: !1,
    slides: [],
    slidesPerPage: "auto",
    spinnerTpl: '<div class="f-spinner"></div>',
    transition: "fade",
    tween: {
        clamp: !0,
        mass: 1,
        tension: 160,
        friction: 25,
        restDelta: 1,
        restSpeed: 1,
        velocity: 0
    },
    vertical: !1
};
let $c22e488d48123133$var$b, $c22e488d48123133$var$y = 0;
const $c22e488d48123133$export$144901db2ea8e967 = (g, x = {}, M = {})=>{
    $c22e488d48123133$var$y++;
    let w, S, j, A, L, P = 0, T = Object.assign({}, $c22e488d48123133$var$h), O = Object.assign({}, $c22e488d48123133$var$h), R = {}, H = null, V = null, C = 0, D = 0, $ = 0, q = !1, I = !1, F = !1, z = "height", k = 0, N = !0, B = 0, _ = 0, G = 0, X = 0, Y = "*", W = [], J = [];
    const K = new Set;
    let Q = [], U = [], Z = 0, tt = 0, et = 0;
    function nt(t, ...e) {
        let n = O[t];
        return n && n instanceof Function ? n(It, ...e) : n;
    }
    function it(t, e = []) {
        const n = nt("l10n") || {};
        t = String(t).replace(/\{\{(\w+)\}\}/g, (t, e)=>n[e] || t);
        for(let n = 0; n < e.length; n++)t = t.split(e[n][0]).join(e[n][1]);
        return t = t.replace(/\{\{(.*?)\}\}/g, (t, e)=>e);
    }
    const ot = new Map;
    function st(t, ...e) {
        const n = [
            ...ot.get(t) || []
        ];
        O.on && n.push(O.on[t]);
        for (const t of n)t && t instanceof Function && t(It, ...e);
        "*" !== t && st("*", t, ...e);
    }
    function rt() {
        var e, n;
        const i = (0, $1b7cd36eed9df61a$export$8b58be045bf06082)({}, $c22e488d48123133$var$h, T);
        (0, $1b7cd36eed9df61a$export$8b58be045bf06082)(i, $c22e488d48123133$var$h, T);
        let r = "";
        const l = T.breakpoints || {};
        if (l) for (const [t, e] of Object.entries(l))window.matchMedia(t).matches && (r += t, (0, $1b7cd36eed9df61a$export$8b58be045bf06082)(i, e));
        if (void 0 === L || r !== L) {
            if (L = r, 0 !== P) {
                let t = null === (n = null === (e = U[B]) || void 0 === e ? void 0 : e.slides[0]) || void 0 === n ? void 0 : n.index;
                void 0 === t && (t = O.initialSlide), i.initialSlide = t, i.slides = [];
                for (const t of W)t.isVirtual && i.slides.push(t);
            }
            Dt(), O = i, !1 !== nt("enabled") && (P = 0, st("init"), function() {
                for (const [t, e] of Object.entries(Object.assign(Object.assign({}, M), O.plugins || {})))if (t && !R[t] && e instanceof Function) {
                    const n = e();
                    n.init(It, $c22e488d48123133$export$144901db2ea8e967), R[t] = n;
                }
                st("initPlugins");
            }(), function() {
                if (!H) return;
                const e = nt("classes") || {};
                (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(H, e.container);
                const n = nt("style");
                if (n && (0, $1e899da006e724cc$export$53b83ca8eaab0383)(n)) for (const [t, e] of Object.entries(n))H.style.setProperty(t, e);
                V = H.querySelector(`.${e.viewport}`), V || (V = document.createElement("div"), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(V, e.viewport), V.append(...(0, $9bfae0b36b942e6c$export$2b0209f2592da03b)(H, `.${e.slide}`)), H.insertAdjacentElement("afterbegin", V)), H.carousel = It, st("initLayout");
            }(), function() {
                if (!V) return;
                const t = nt("classes") || {};
                W = [], [
                    ...(0, $9bfae0b36b942e6c$export$2b0209f2592da03b)(V, `.${t.slide}`)
                ].forEach((t)=>{
                    if (t.parentElement) {
                        const e = yt(Object.assign({
                            el: t,
                            isVirtual: !1
                        }, t.dataset || {}));
                        st("createSlide", e), W.push(e);
                    }
                }), wt();
                for (const t of W)st("addSlide", t);
                bt(nt("slides"));
                for (const t of W){
                    const e = t.el;
                    (null == e ? void 0 : e.parentElement) === V && ((0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(e, O.classes.slide), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(e, t.class), Rt(t), st("attachSlideEl", t));
                }
                st("initSlides");
            }(), St(), P = 1, (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(H, (nt("classes") || {}).isEnabled || ""), Ct(), ut(), S = (0, $04c8ca71f19bc6bc$export$208a41d6b4e37b97)().on("start", ()=>{
                w && w.isPointerDown() || (dt(), Ct());
            }).on("step", (t)=>{
                const e = k;
                k = t.pos, k !== e && (N = !1, Ct());
            }).on("end", (t)=>{
                (null == w ? void 0 : w.isPointerDown()) || (k = t.pos, S && !q && (k < G || k > X) ? S.spring({
                    clamp: !0,
                    mass: 1,
                    tension: 200,
                    friction: 25,
                    velocity: 0,
                    restDelta: 1,
                    restSpeed: 1
                }).from({
                    pos: k
                }).to({
                    pos: (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(G, k, X)
                }).start() : N || (N = !0, st("settle")));
            }), at(), function() {
                if (!H || !V) return;
                H.addEventListener("click", Pt), document.addEventListener("mousemove", lt);
                const t = V.getBoundingClientRect();
                if (Z = t.height, tt = t.width, !j) {
                    let t = null;
                    j = new ResizeObserver(()=>{
                        t || (t = requestAnimationFrame(()=>{
                            !function() {
                                if (1 !== P || !V) return;
                                const t = U.length, e = V.getBoundingClientRect(), n = e.height, i = e.width;
                                t > 1 && (F && Math.abs(n - Z) < .5 || !F && Math.abs(i - tt) < .5) || (St(), at(), Z = n, tt = i, F && !Z || !F && !tt || H && V && (t === U.length && (null == w ? void 0 : w.isPointerDown()) || (nt("dragFree") && (q || k > G && k < X) ? (dt(), Ct()) : Ht(B, {
                                    transition: !1
                                }))));
                            }(), t = null;
                        }));
                    }), j.observe(V);
                }
            }(), st("ready"));
        }
    }
    function lt(t) {
        $c22e488d48123133$var$b = t;
    }
    function at() {
        !1 === nt("gestures") ? w && (w.destroy(), w = void 0) : w || function() {
            const t = nt("gestures");
            !w && !1 !== t && V && (w = (0, $d26b20f49452df26$export$1f911e2d31b2843e)(V, t).on("start", (t)=>{
                var e, n;
                if (!S) return;
                if (!1 === nt("gestures", t)) return;
                const { srcEvent: o } = t;
                F && (0, $d26b20f49452df26$export$c4dfce035d43d1e0)(o) && !(0, $ca2529f528ef56ef$export$e41e80160bed5714)(o.target) && $c22e488d48123133$var$m(o), S.pause(), S.getCurrentVelocities().pos = 0;
                const s = null === (e = U[B]) || void 0 === e ? void 0 : e.slides[0], r = null == s ? void 0 : s.el;
                s && K.has(s.index) && r && (k = s.offset || 0, k += (function(t) {
                    const e = window.getComputedStyle(t), n = new DOMMatrixReadOnly(e.transform);
                    return {
                        width: n.m41 || 0,
                        height: n.m42 || 0
                    };
                }(r)[z] || 0) * (I && !F ? 1 : -1)), At(), q || (k < G || k > X) && S.spring({
                    clamp: !0,
                    mass: 1,
                    tension: 500,
                    friction: 25,
                    velocity: (null === (n = S.getCurrentVelocities()) || void 0 === n ? void 0 : n.pos) || 0,
                    restDelta: 1,
                    restSpeed: 1
                }).from({
                    pos: k
                }).to({
                    pos: (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(G, k, X)
                }).start();
            }).on("move", (t)=>{
                var e, n;
                if (!1 === nt("gestures", t)) return;
                const { srcEvent: o, axis: s, deltaX: r, deltaY: l } = t;
                if ((0, $d26b20f49452df26$export$c4dfce035d43d1e0)(o) && (null === (e = o.touches) || void 0 === e ? void 0 : e.length) > 1) return;
                const a = o.target, c = (0, $ca2529f528ef56ef$export$e41e80160bed5714)(a), d = c ? c.scrollHeight > c.clientHeight ? "y" : "x" : void 0;
                if (c && c !== V && (!s || s === d)) return;
                if (!s) return $c22e488d48123133$var$m(o), o.stopPropagation(), void o.stopImmediatePropagation();
                if ("y" === s && !F || "x" === s && F) return;
                if ($c22e488d48123133$var$m(o), o.stopPropagation(), !S) return;
                const u = I && !F ? 1 : -1, f = F ? l : r;
                let v = (null == S ? void 0 : S.isRunning()) ? S.getEndValues().pos : k, g = 1;
                q || (v <= G && f * u < 0 ? (g = Math.max(.01, 1 - (Math.abs(1 / gt() * Math.abs(v - G)) || 0)), g *= .2) : v >= X && f * u > 0 && (g = Math.max(.01, 1 - (Math.abs(1 / gt() * Math.abs(v - X)) || 0)), g *= .2)), v += f * g * u, S.spring({
                    clamp: !0,
                    mass: 1,
                    tension: 700,
                    friction: 25,
                    velocity: (null === (n = S.getCurrentVelocities()) || void 0 === n ? void 0 : n.pos) || 0,
                    restDelta: 1,
                    restSpeed: 1
                }).from({
                    pos: k
                }).to({
                    pos: v
                }).start();
            }).on("panstart", (t)=>{
                !1 !== nt("gestures", t) && (null == t ? void 0 : t.axis) === (F ? "y" : "x") && (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(V, "is-dragging");
            }).on("panend", (t)=>{
                !1 !== nt("gestures", t) && (0, $a4c70e77d1c194a1$export$c2255604a80b4506)(V, "is-dragging");
            }).on("end", (t)=>{
                var e, n;
                if (!1 === nt("gestures", t)) return;
                const { srcEvent: o, axis: s, velocityX: r, velocityY: l, currentTouch: c } = t;
                if (c.length > 0 || !S) return;
                const d = o.target, u = (0, $ca2529f528ef56ef$export$e41e80160bed5714)(d), f = u ? u.scrollHeight > u.clientHeight ? "y" : "x" : void 0, v = u && (!s || s === f);
                F && (0, $d26b20f49452df26$export$c4dfce035d43d1e0)(o) && !s && Pt(o);
                const g = U.length, m = nt("dragFree");
                if (!g) return;
                let h = v ? 0 : nt("vertical") ? l : r;
                s !== (F ? "y" : "x") && (h = 0);
                let b = (null == S ? void 0 : S.isRunning()) ? S.getEndValues().pos : k;
                const y = I && !F ? 1 : -1;
                if (v || (b += h * (m ? 5 : 1) * y), !q && (h * y <= 0 && b < G || h * y >= 0 && b > X)) {
                    let t = 0;
                    return Math.abs(h) > 0 && (t = 2 * Math.abs(h), t = Math.min(.3 * gt(), t)), b = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(G + -1 * t, b, X + t), void S.spring({
                        clamp: !0,
                        mass: 1,
                        tension: 380,
                        friction: 25,
                        velocity: -1 * h,
                        restDelta: 1,
                        restSpeed: 1
                    }).from({
                        pos: k
                    }).to({
                        pos: b
                    }).start();
                }
                if (m || (null === (e = R.Autoscroll) || void 0 === e ? void 0 : e.isEnabled())) return void (Math.abs(h) > 10 ? S.spring({
                    clamp: !0,
                    mass: 1,
                    tension: 150,
                    friction: 25,
                    velocity: -1 * h,
                    restDelta: 1,
                    restSpeed: 1
                }).from({
                    pos: k
                }).to({
                    pos: b
                }).start() : S.isRunning() || N || (N = !0, st("settle")));
                if (!m && !(null === (n = R.Autoscroll) || void 0 === n ? void 0 : n.isEnabled()) && (!t.offsetX && !t.offsetY || "y" === s && !F || "x" === s && F)) return void Ht(B, {
                    transition: "tween"
                });
                let E = vt(b);
                Math.abs(h) > 10 && E === B && (E += h > 0 ? I && !F ? 1 : -1 : I && !F ? -1 : 1), Ht(E, {
                    transition: "tween",
                    tween: {
                        velocity: -1 * h
                    }
                });
            }).init());
        }(), (0, $98c82c03f7f08e20$export$4a80062ca50b57c7)(V, "is-draggable", !!w && U.length > 0);
    }
    function ct(t = "*") {
        var e;
        const n = [];
        for (const i of W)("*" === t || i.class && i.class.includes(t) || i.el && (null === (e = i.el) || void 0 === e ? void 0 : e.classList.contains(t))) && n.push(i);
        A = void 0, Y = t, J = [
            ...n
        ];
    }
    function dt() {
        if (!S) return;
        const t = vt((null == S ? void 0 : S.isRunning()) ? S.getEndValues().pos : k);
        t !== B && (A = B, B = t, Rt(), ut(), ft(), st("change", B, A));
    }
    function ut() {
        var t, e;
        if (!H) return;
        for (const t of H.querySelectorAll("[data-carousel-index]"))t.innerHTML = B + "";
        for (const t of H.querySelectorAll("[data-carousel-page]"))t.innerHTML = B + 1 + "";
        for (const t of H.querySelectorAll("[data-carousel-pages]"))t.innerHTML = U.length + "";
        for (const e of H.querySelectorAll("[data-carousel-go-to]"))parseInt((null === (t = e.dataset) || void 0 === t ? void 0 : t.carouselGoTo) || "-1", 10) === B ? e.setAttribute("aria-current", "true") : e.removeAttribute("aria-current");
        for (const t of H.querySelectorAll("[data-carousel-go-prev]"))t.toggleAttribute("aria-disabled", !$t()), $t() ? t.removeAttribute("tabindex") : t.setAttribute("tabindex", "-1");
        for (const t of H.querySelectorAll("[data-carousel-go-next]"))t.toggleAttribute("aria-disabled", !qt()), qt() ? t.removeAttribute("tabindex") : t.setAttribute("tabindex", "-1");
        let n = !1;
        const i = null === (e = U[B]) || void 0 === e ? void 0 : e.slides[0];
        i && (i.downloadSrc || "image" === i.type && i.src) && (n = !0);
        for (const t of H.querySelectorAll("[data-carousel-download]"))t.toggleAttribute("aria-disabled", !n);
    }
    function ft(t) {
        var e;
        t || (t = null === (e = U[B]) || void 0 === e ? void 0 : e.slides[0]);
        const n = null == t ? void 0 : t.el;
        if (n) for (const e of n.querySelectorAll("[data-slide-index]"))e.innerHTML = t.index + 1 + "";
    }
    function vt(t) {
        var e, n, i;
        if (!U.length) return 0;
        const o = mt();
        let s = t;
        q ? s -= Math.floor((t - (null === (e = U[0]) || void 0 === e ? void 0 : e.pos)) / o) * o || 0 : s = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(null === (n = U[0]) || void 0 === n ? void 0 : n.pos, t, null === (i = U[U.length - 1]) || void 0 === i ? void 0 : i.pos);
        const r = new Map;
        let l = 0;
        for (const t of U){
            const e = Math.abs(t.pos - s), n = Math.abs(t.pos - s - o), i = Math.abs(t.pos - s + o), a = Math.min(e, n, i);
            r.set(l, a), l++;
        }
        const c = r.size > 0 ? [
            ...r.entries()
        ].reduce((t, e)=>e[1] < t[1] ? e : t) : [
            B,
            0
        ];
        return parseInt(c[0]);
    }
    function pt() {
        return et;
    }
    function gt() {
        return C;
    }
    function mt(t = !0) {
        return J.length ? J.reduce((t, e)=>t + e.dim, 0) + (J.length - (q && t ? 0 : 1)) * et : 0;
    }
    function ht(t) {
        const e = mt(), n = gt();
        if (!e || !V || !n) return [];
        const i = [];
        t = void 0 === t ? k : t, q && (t -= Math.floor(t / e) * e || 0);
        let o = 0;
        for (let s of J){
            const r = (e = 0)=>{
                i.indexOf(s) > -1 || (s.pos = o - t + e || 0, s.offset + e > t - s.dim - D + .51 && s.offset + e < t + n + $ - .51 && i.push(s));
            };
            s.offset = o, q && (r(e), r(-1 * e)), r(), o += s.dim + et;
        }
        return i;
    }
    function bt(t, e) {
        const n = [];
        for (const e of Array.isArray(t) ? t : [
            t
        ]){
            const t = yt(Object.assign(Object.assign({}, e), {
                isVirtual: !0
            }));
            t.el || (t.el = document.createElement("div")), st("createSlide", t), n.push(t);
        }
        W.splice(void 0 === e ? W.length : e, 0, ...n), wt();
        for (const t of n)st("addSlide", t), Et(t);
        return ct(Y), n;
    }
    function yt(t) {
        return ((0, $c7ba36523489ae88$export$844ec244b1367d54)(t) || t instanceof HTMLElement) && (t = {
            html: t
        }), Object.assign({
            index: -1,
            el: void 0,
            class: "",
            isVirtual: !0,
            dim: 0,
            pos: 0,
            offset: 0,
            html: "",
            src: ""
        }, t);
    }
    function Et(t) {
        let e = t.el;
        if (!t || !e) return;
        const n = t.html ? t.html instanceof HTMLElement ? t.html : (0, $b8a64cd90ff0bd86$export$b368690db5627d91)(t.html) : void 0;
        n && ((0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(n, "f-html"), t.htmlEl = n, (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(e, "has-html"), e.append(n), st("contentReady", t));
    }
    function xt(t) {
        if (!V || !t) return;
        let e = t.el;
        if (e) {
            if (e.setAttribute("index", t.index + ""), e.parentElement !== V) {
                let n;
                (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(e, O.classes.slide), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(e, t.class), Rt(t);
                for (const e of W)if (e.index > t.index) {
                    n = e.el;
                    break;
                }
                V.insertBefore(e, n && V.contains(n) ? n : null), st("attachSlideEl", t);
            }
            return ft(t), e;
        }
    }
    function Mt(t) {
        const e = null == t ? void 0 : t.el;
        e && (e.remove(), jt(e), st("detachSlideEl", t));
    }
    function wt() {
        for(let t = 0; t < W.length; t++){
            const e = W[t], n = e.el;
            n && (e.index !== t && jt(n), n.setAttribute("index", `${t}`)), e.index = t;
        }
    }
    function St() {
        var t, n, i, o, s;
        if (!H || !V) return;
        I = nt("rtl"), F = nt("vertical"), z = F ? "height" : "width";
        const r = nt("classes");
        if ((0, $98c82c03f7f08e20$export$4a80062ca50b57c7)(H, r.isLTR, !I), (0, $98c82c03f7f08e20$export$4a80062ca50b57c7)(H, r.isRTL, I), (0, $98c82c03f7f08e20$export$4a80062ca50b57c7)(H, r.isHorizontal, !F), (0, $98c82c03f7f08e20$export$4a80062ca50b57c7)(H, r.isVertical, F), (0, $98c82c03f7f08e20$export$4a80062ca50b57c7)(H, r.hasAdaptiveHeight, nt("adaptiveHeight")), C = 0, D = 0, $ = 0, et = 0, V) {
            V.childElementCount || (V.style.display = "grid");
            const t = V.getBoundingClientRect();
            C = V.getBoundingClientRect()[z] || 0;
            const e = window.getComputedStyle(V);
            et = parseFloat(e.getPropertyValue("--f-carousel-gap")) || 0;
            "visible" === e.getPropertyValue("overflow-" + (F ? "y" : "x")) && (D = Math.abs(t[F ? "top" : "left"]), $ = Math.abs(window[F ? "innerHeight" : "innerWidth"] - t[F ? "bottom" : "right"])), V.style.display = "";
        }
        if (!C) return;
        const l = function() {
            let t = 0;
            if (V) {
                let e = document.createElement("div");
                e.style.display = "block", (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(e, O.classes.slide), V.appendChild(e), t = e.getBoundingClientRect()[z], e.remove(), e = void 0;
            }
            return t;
        }();
        for (const n of J){
            const i = n.el;
            let o = 0;
            if (!n.isVirtual && i && (0, $eb5b53ddd8b73bd7$export$8ee0fc9ee280b4ee)(i)) {
                let e = !1;
                i.parentElement && i.parentElement === V || (V.appendChild(i), e = !0), o = i.getBoundingClientRect()[z], e && (null === (t = i.parentElement) || void 0 === t || t.removeChild(i));
            } else o = l;
            n.dim = o;
        }
        if (q = !1, nt("infinite")) {
            q = !0;
            const t = mt();
            let e = C + D + $;
            for(let i = 0; i < J.length; i++){
                const o = (null === (n = J[i]) || void 0 === n ? void 0 : n.dim) + et;
                if (t - o < e && t - o - e < o) {
                    q = !1;
                    break;
                }
            }
        }
        !function() {
            var t;
            if (!H) return;
            const e = gt(), n = mt(!1);
            let i = nt("slidesPerPage");
            i = "auto" === i ? 1 / 0 : parseFloat(i + ""), U = [];
            let o = 0, s = 0;
            for (const n of J)(!U.length || o + n.dim - e > .05 || s >= i) && (U.push({
                index: U.length,
                slides: [],
                dim: 0,
                offset: 0,
                pos: 0
            }), o = 0, s = 0), null === (t = U[U.length - 1]) || void 0 === t || t.slides.push(n), o += n.dim + et, s++;
            const r = nt("center"), l = nt("fill");
            let c = 0;
            for (const t of U){
                t.dim = (t.slides.length - 1) * et;
                for (const e of t.slides)t.dim += e.dim;
                t.offset = c, t.pos = c, !1 !== r && (t.pos -= .5 * (e - t.dim)), l && !q && n > e && (t.pos = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(0, t.pos, n - e)), c += t.dim + et;
            }
            const d = [];
            let u;
            for (const t of U){
                const e = Object.assign({}, t);
                u && Math.abs(e.pos - u.pos) < .1 ? (u.dim += e.dim, u.slides = [
                    ...u.slides,
                    ...e.slides
                ]) : (u = e, e.index = d.length, d.push(e));
            }
            U = d, B = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(0, B, U.length - 1);
        }(), G = (null === (i = U[0]) || void 0 === i ? void 0 : i.pos) || 0, X = (null === (o = U[U.length - 1]) || void 0 === o ? void 0 : o.pos) || 0, 0 === P ? function() {
            var t;
            A = void 0, B = nt("initialPage");
            const e = nt("initialSlide") || void 0;
            void 0 !== e && (B = It.getPageIndex(e) || 0), B = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(0, B, U.length - 1), k = (null === (t = U[B]) || void 0 === t ? void 0 : t.pos) || 0, _ = k;
        }() : _ = (null === (s = U[B || 0]) || void 0 === s ? void 0 : s.pos) || 0, st("refresh"), ut();
    }
    function jt(t) {
        if (!t || !(0, $eb5b53ddd8b73bd7$export$8ee0fc9ee280b4ee)(t)) return;
        const n = parseInt(t.getAttribute("index") || "-1");
        let i = "";
        for (const e of Array.from(t.classList)){
            const t = e.match(/^f-(\w+)(Out|In)$/);
            t && t[1] && (i = t[1] + "");
        }
        if (!t || !i) return;
        const o = [
            `f-${i}Out`,
            `f-${i}In`,
            "to-prev",
            "to-next",
            "from-prev",
            "from-next"
        ];
        t.removeEventListener("animationend", Lt), (0, $a4c70e77d1c194a1$export$c2255604a80b4506)(t, o.join(" ")), K.delete(n);
    }
    function At() {
        if (!V) return;
        const t = K.size > 0;
        for (const t of J)jt(t.el);
        K.clear(), t && Ct();
    }
    function Lt(t) {
        var e;
        "f-" === (null === (e = t.animationName) || void 0 === e ? void 0 : e.substring(0, 2)) && (jt(t.target), K.size || ((0, $a4c70e77d1c194a1$export$c2255604a80b4506)(H, "in-transition"), !N && Math.abs(It.getPosition(!0) - _) < .5 && (N = !0, st("settle"))), Ct());
    }
    function Pt(t) {
        var e;
        if (t.defaultPrevented) return;
        const n = t.composedPath()[0];
        if (n.closest("[data-carousel-go-prev]")) return $c22e488d48123133$var$m(t), void It.prev();
        if (n.closest("[data-carousel-go-next]")) return $c22e488d48123133$var$m(t), void It.next();
        const i = n.closest("[data-carousel-go-to]");
        if (i) return $c22e488d48123133$var$m(t), void It.goTo(parseFloat(i.dataset.carouselGoTo || "") || 0);
        if (n.closest("[data-carousel-download]")) {
            $c22e488d48123133$var$m(t);
            const n = null === (e = U[B]) || void 0 === e ? void 0 : e.slides[0];
            if (n && (n.downloadSrc || "image" === n.type && n.src)) {
                const t = n.downloadFilename, e = document.createElement("a"), i = n.downloadSrc || n.src || "";
                e.href = i, e.target = "_blank", e.download = t || i, e.click();
            }
            return;
        }
        st("click", t);
    }
    function Tt(t) {
        var e;
        const n = t.el;
        n && (null === (e = n.querySelector(".f-spinner")) || void 0 === e || e.remove());
    }
    function Ot(t) {
        var e;
        const n = t.el;
        n && (null === (e = n.querySelector(".f-html.is-error")) || void 0 === e || e.remove(), (0, $a4c70e77d1c194a1$export$c2255604a80b4506)(n, "has-error"));
    }
    function Rt(t) {
        var e;
        t || (t = null === (e = U[B]) || void 0 === e ? void 0 : e.slides[0]);
        const i = null == t ? void 0 : t.el;
        if (!i) return;
        let o = nt("formatCaption", t);
        void 0 === o && (o = t.caption), o = o || "";
        const s = nt("captionEl");
        if (s && s instanceof HTMLElement) {
            if (t.index !== B) return;
            if ((0, $c7ba36523489ae88$export$844ec244b1367d54)(o) && (s.innerHTML = it(o + "")), o instanceof HTMLElement) {
                if (o.parentElement === s) return;
                s.innerHTML = "", o.parentElement && (o = o.cloneNode(!0)), s.append(o);
            }
            return;
        }
        if (!o) return;
        let r = t.captionEl || i.querySelector(".f-caption");
        !r && o instanceof HTMLElement && o.classList.contains("f-caption") && (r = o), r || (r = document.createElement("div"), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(r, "f-caption"), (0, $c7ba36523489ae88$export$844ec244b1367d54)(o) ? r.innerHTML = it(o + "") : o instanceof HTMLElement && (o.parentElement && (o = o.cloneNode(!0)), r.append(o)));
        const l = `f-caption-${$c22e488d48123133$var$y}_${t.index}`;
        r.setAttribute("id", l), r.dataset.selectable = "true", (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(i, "has-caption"), i.setAttribute("aria-labelledby", l), t.captionEl = r, i.insertAdjacentElement("beforeend", r);
    }
    function Ht(e, i = {}) {
        var o, r;
        let { transition: l, tween: u } = Object.assign({
            transition: O.transition,
            tween: O.tween
        }, i || {});
        if (!H || !S) return;
        const f = U.length;
        if (!f) return;
        if (function(t, e) {
            var i, o, s;
            if (!(H && C && S && e && (0, $c7ba36523489ae88$export$844ec244b1367d54)(e) && "tween" !== e)) return !1;
            for (const t of Q)if (C - t.dim > .5) return !1;
            if (D > .5 || $ > .5) return;
            const r = U.length;
            let l = t > B ? 1 : -1;
            t = q ? (t % r + r) % r : (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(0, t, r - 1), I && (l *= -1);
            const u = null === (i = U[B]) || void 0 === i ? void 0 : i.slides[0], f = null == u ? void 0 : u.index, v = null === (o = U[t]) || void 0 === o ? void 0 : o.slides[0], p = null == v ? void 0 : v.index, g = null === (s = U[t]) || void 0 === s ? void 0 : s.pos;
            if (void 0 === p || void 0 === f || f === p || k === g || Math.abs(C - ((null == v ? void 0 : v.dim) || 0)) > 1) return !1;
            N = !1, S.pause(), At(), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(H, "in-transition"), k = _ = g;
            const m = xt(u), h = xt(v);
            return dt(), m && (K.add(f), m.style.transform = "", m.addEventListener("animationend", Lt), (0, $a4c70e77d1c194a1$export$c2255604a80b4506)(m, O.classes.isSelected), m.inert = !1, (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(m, `f-${e}Out to-${l > 0 ? "next" : "prev"}`)), h && (K.add(p), h.style.transform = "", h.addEventListener("animationend", Lt), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(h, O.classes.isSelected), h.inert = !1, (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(h, `f-${e}In from-${l > 0 ? "prev" : "next"}`)), Ct(), !0;
        }(e, l)) return;
        e = q ? (e % f + f) % f : (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(0, e, f - 1);
        const v = (null === (o = U[e || 0]) || void 0 === o ? void 0 : o.pos) || 0;
        _ = v;
        const p = S.isRunning() ? S.getEndValues().pos : k;
        if (Math.abs(_ - p) < 1) return k = _, B !== e && (Rt(), A = B, B = e, ut(), ft(), st("change", B, A)), Ct(), void (N || (N = !0, st("settle")));
        if (S.pause(), At(), q) {
            const t = mt(), e = Math.floor((p - (null === (r = U[0]) || void 0 === r ? void 0 : r.pos)) / t) || 0, n = _ + e * t;
            _ = [
                n + t,
                n,
                n - t
            ].reduce(function(t, e) {
                return Math.abs(e - p) < Math.abs(t - p) ? e : t;
            });
        }
        !1 !== l && (0, $1e899da006e724cc$export$53b83ca8eaab0383)(u) ? S.spring((0, $1b7cd36eed9df61a$export$8b58be045bf06082)({}, O.tween, u)).from({
            pos: k
        }).to({
            pos: _
        }).start() : (k = _, dt(), Ct(), N || (N = !0, st("settle")));
    }
    function Vt(t) {
        var e;
        let n = k;
        if (q && !0 !== t) {
            const t = mt();
            n -= (Math.floor((k - (null === (e = U[0]) || void 0 === e ? void 0 : e.pos) || 0) / t) || 0) * t;
        }
        return n;
    }
    function Ct() {
        var t;
        if (!H || !V) return;
        Q = ht();
        const e = new Set, n = [], i = U[B], s = O.setTransform;
        let l;
        for (const o of J){
            const s = K.has(o.index), r = Q.indexOf(o) > -1, a = (null === (t = null == i ? void 0 : i.slides) || void 0 === t ? void 0 : t.indexOf(o)) > -1;
            if (o.isVirtual && !s && !r) continue;
            let c = xt(o);
            if (c && (n.push(o), a && e.add(c), nt("adaptiveHeight") && a)) {
                const t = (c.lastElementChild || c).getBoundingClientRect().height;
                l = null == l ? t : Math.max(l, t);
            }
        }
        V && l && (V.style.height = `${l}px`), [
            ...(0, $9bfae0b36b942e6c$export$2b0209f2592da03b)(V, `.${O.classes.slide}`)
        ].forEach((t)=>{
            (0, $98c82c03f7f08e20$export$4a80062ca50b57c7)(t, O.classes.isSelected, e.has(t));
            const n = W[parseInt(t.getAttribute("index") || "-1")];
            if (!n) return t.remove(), void jt(t);
            const i = K.has(n.index), o = Q.indexOf(n) > -1;
            if (n.isVirtual && !i && !o) return void Mt(n);
            if (t.inert = !o, !1 === s) return;
            let l = n.pos ? Math.round(1e4 * n.pos) / 1e4 : 0, a = 0, c = 0, d = 0, f = 0;
            i || (a = F ? 0 : I ? -1 * l : l, c = F ? l : 0, d = (0, $fa17a272154af804$export$871de8747c9eaa88)(a, 0, n.dim, 0, 100), f = (0, $fa17a272154af804$export$871de8747c9eaa88)(c, 0, n.dim, 0, 100)), s instanceof Function && !i ? s(It, n, {
                x: a,
                y: c,
                xPercent: d,
                yPercent: f
            }) : t.style.transform = a || c ? `translate3d(${d}%, ${f}%,0)` : "";
        }), st("render", n);
    }
    function Dt() {
        null == H || H.removeEventListener("click", Pt), document.removeEventListener("mousemove", lt), K.clear(), null == j || j.disconnect(), j = void 0;
        for (const t of W){
            let n = t.el;
            n && (0, $eb5b53ddd8b73bd7$export$8ee0fc9ee280b4ee)(n) && (t.state = void 0, Tt(t), Ot(t), t.isVirtual ? (Mt(t), t.el = void 0) : (jt(n), n.style.transform = "", V && !V.contains(n) && V.appendChild(n)));
        }
        for (const t of Object.values(R))null == t || t.destroy();
        R = {}, null == w || w.destroy(), w = void 0, null == S || S.destroy(), S = void 0;
        for (const [t, e] of Object.entries(O.classes || {}))"container" !== t && (0, $a4c70e77d1c194a1$export$c2255604a80b4506)(H, e);
        (0, $a4c70e77d1c194a1$export$c2255604a80b4506)(V, "is-draggable");
    }
    function $t() {
        return q || B > 0;
    }
    function qt() {
        return q || B < U.length - 1;
    }
    const It = {
        add: function(t, e) {
            var n;
            let i = k;
            const o = B, s = mt(), r = (null == S ? void 0 : S.isRunning()) ? S.getEndValues().pos : k, l = s && Math.floor((r - ((null === (n = U[0]) || void 0 === n ? void 0 : n.pos) || 0)) / s) || 0;
            return bt(t, e), ct(Y), St(), S && s && (o === B && (i -= l * s), i === _ ? k = _ : S.spring({
                clamp: !0,
                mass: 1,
                tension: 300,
                friction: 25,
                restDelta: 1,
                restSpeed: 1
            }).from({
                pos: i
            }).to({
                pos: _
            }).start()), Ct(), It;
        },
        canGoPrev: $t,
        canGoNext: qt,
        destroy: function() {
            return st("destroy"), window.removeEventListener("resize", rt), Dt(), ot.clear(), H = null, U = [], W = [], O = Object.assign({}, $c22e488d48123133$var$h), R = {}, J = [], L = void 0, Y = "*", P = 2, It;
        },
        emit: st,
        filter: function(t = "*") {
            return ct(t), St(), k = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(G, k, X), Ct(), st("filter", t), It;
        },
        getContainer: function() {
            return H;
        },
        getGapDim: pt,
        getGestures: function() {
            return w;
        },
        getLastMouseMove: function() {
            return $c22e488d48123133$var$b;
        },
        getOption: function(t) {
            return nt(t);
        },
        getOptions: function() {
            return O;
        },
        getPage: function() {
            return U[B];
        },
        getPageIndex: function(t) {
            if (void 0 !== t) {
                for (const e of U || [])for (const n of e.slides)if (n.index === t) return e.index;
                return -1;
            }
            return B;
        },
        getPageIndexFromPosition: vt,
        getPageProgress: function(t, e) {
            var n;
            void 0 === t && (t = B);
            const i = U[t];
            if (!i) return t > B ? -1 : 1;
            const o = mt(), s = pt();
            let r = i.pos, l = Vt();
            if (q && !0 !== e) {
                const t = Math.floor((l - (null === (n = U[0]) || void 0 === n ? void 0 : n.pos)) / o) || 0;
                l -= t * o, r = [
                    r + o,
                    r,
                    r - o
                ].reduce(function(t, e) {
                    return Math.abs(e - l) < Math.abs(t - l) ? e : t;
                });
            }
            return (l - r) / (i.dim + s) || 0;
        },
        getPageVisibility: function(t) {
            var e;
            void 0 === t && (t = B);
            const n = U[t];
            if (!n) return t > B ? -1 : 1;
            const i = Vt(), o = gt();
            let s = n.pos;
            if (q) {
                const t = mt(), n = s + (Math.floor((i - (null === (e = U[0]) || void 0 === e ? void 0 : e.pos)) / t) || 0) * t;
                s = [
                    n + t,
                    n,
                    n - t
                ].reduce(function(t, e) {
                    return Math.abs(e - i) < Math.abs(t - i) ? e : t;
                });
            }
            return s > i && s + n.dim < i + o ? 1 : s < i ? (s + n.dim - i) / n.dim || 0 : s + n.dim > i + o && (i + o - s) / n.dim || 0;
        },
        getPages: function() {
            return U;
        },
        getPlugins: function() {
            return R;
        },
        getPosition: Vt,
        getSlides: function() {
            return W;
        },
        getState: function() {
            return P;
        },
        getTotalSlideDim: mt,
        getTween: function() {
            return S;
        },
        getViewport: function() {
            return V;
        },
        getViewportDim: gt,
        getVisibleSlides: function(t) {
            return void 0 === t ? Q : ht(t);
        },
        goTo: Ht,
        hasNavigated: function() {
            return void 0 !== A;
        },
        hideError: Ot,
        hideLoading: Tt,
        init: function() {
            if (!g || !(0, $eb5b53ddd8b73bd7$export$8ee0fc9ee280b4ee)(g)) throw new Error("No Element found");
            return 0 !== P && (Dt(), P = 0), H = g, T = x, window.removeEventListener("resize", rt), T.breakpoints && window.addEventListener("resize", rt), rt(), It;
        },
        isInfinite: function() {
            return q;
        },
        isInTransition: function() {
            return K.size > 0;
        },
        isRTL: function() {
            return I;
        },
        isSettled: function() {
            return N;
        },
        isVertical: function() {
            return F;
        },
        localize: it,
        next: function(t = {}) {
            return Ht(B + 1, t), It;
        },
        off: function(t, e) {
            for (const n of t instanceof Array ? t : [
                t
            ])ot.has(n) && ot.set(n, ot.get(n).filter((t)=>t !== e));
            return It;
        },
        on: function(t, e) {
            for (const n of t instanceof Array ? t : [
                t
            ])ot.set(n, [
                ...ot.get(n) || [],
                e
            ]);
            return It;
        },
        prev: function(t = {}) {
            return Ht(B - 1, t), It;
        },
        reInit: function(e = {}, n) {
            return Dt(), P = 0, L = void 0, Y = "*", x = e, T = e, (0, $1e899da006e724cc$export$53b83ca8eaab0383)(n) && (M = n), rt(), It;
        },
        remove: function(t) {
            void 0 === t && (t = W.length - 1);
            const e = W[t];
            return e && (st("removeSlide", e), e.el && (jt(e.el), e.el.remove(), e.el = void 0), W.splice(t, 1), ct(Y), St(), k = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(G, k, X), Ct()), It;
        },
        setPosition: function(t) {
            k = t, dt(), Ct();
        },
        showError: function(t, e) {
            if (1 === P) {
                Tt(t), Ot(t);
                const n = t.el;
                if (n) {
                    const i = document.createElement("div");
                    (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(i, "f-html"), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(i, "is-error"), i.innerHTML = it(e || "<p>{{ERROR}}</p>"), t.htmlEl = i, (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(n, "has-html has-error"), n.insertAdjacentElement("afterbegin", i), st("contentReady", t);
                }
            }
            return It;
        },
        showLoading: function(t) {
            const e = t.el, n = null == e ? void 0 : e.querySelector(".f-spinner");
            if (!e || n) return It;
            const i = nt("spinnerTpl"), o = (0, $b8a64cd90ff0bd86$export$b368690db5627d91)(i);
            return o && ((0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(o, "f-spinner"), e.insertAdjacentElement("beforeend", o)), It;
        },
        version: "6.1.13"
    };
    return It;
};
$c22e488d48123133$export$144901db2ea8e967.l10n = {
    en_EN: (0, $af8c7da03e8ae19f$export$30568d076ec2f42)
}, $c22e488d48123133$export$144901db2ea8e967.getDefaults = ()=>$c22e488d48123133$var$h;


/*! License details at fancyapps.com/license */ 




/*! License details at fancyapps.com/license */ const $936b4faccea0b3c7$export$b539ed14f4f9e78 = (t = !0, e = "--f-scrollbar-compensate", s = "--f-body-margin", o = "hide-scrollbar")=>{
    const n = document, r = n.body, l = n.documentElement;
    if (t) {
        if (r.classList.contains(o)) return;
        let t = window.innerWidth - l.getBoundingClientRect().width;
        t < 0 && (t = 0), l.style.setProperty(e, `${t}px`);
        const n = parseFloat(window.getComputedStyle(r).marginRight);
        n && r.style.setProperty(s, `${n}px`), r.classList.add(o);
    } else r.classList.remove(o), r.style.setProperty(s, ""), n.documentElement.style.setProperty(e, "");
};



/*! License details at fancyapps.com/license */ function $a36657fcc43bb96f$export$71594e8a50f746f4() {
    return !("undefined" == typeof window || !window.document || !window.document.createElement);
}










/*! License details at fancyapps.com/license */ 

/*! License details at fancyapps.com/license */ const $c9e1e2074c21be77$export$b8b3234b4edfc4c2 = function(n = "", t = "", o = "") {
    return n.split(t).join(o);
};



const $f36d452514839cae$var$a = {
    tpl: (t)=>`<img class="f-panzoom__content" \n    ${t.srcset ? 'data-lazy-srcset="{{srcset}}"' : ""} \n    ${t.sizes ? 'data-lazy-sizes="{{sizes}}"' : ""} \n    data-lazy-src="{{src}}" alt="{{alt}}" />`
}, $f36d452514839cae$export$b7fc409e12a7dcec = ()=>{
    let s;
    function l(e, o) {
        const n = null == s ? void 0 : s.getOptions().Zoomable;
        let i = ((0, $1e899da006e724cc$export$53b83ca8eaab0383)(n) ? Object.assign(Object.assign({}, $f36d452514839cae$var$a), n) : $f36d452514839cae$var$a)[e];
        return i && "function" == typeof i && o ? i(o) : i;
    }
    function c() {
        s && !1 !== s.getOptions().Zoomable && (s.on("addSlide", f), s.on("removeSlide", u), s.on("attachSlideEl", g), s.on("click", d), s.on("change", r), s.on("ready", r));
    }
    function r() {
        m();
        const t = (null == s ? void 0 : s.getVisibleSlides()) || [];
        if (t.length > 1 || "slide" === (null == s ? void 0 : s.getOption("transition"))) for (const e of t){
            const t = e.panzoomRef;
            t && ((null == s ? void 0 : s.getPage().slides) || []).indexOf(e) < 0 && t.execute((0, $de7268de96c5ce00$export$9520bccbaf78266).ZoomTo, Object.assign({}, t.getStartPosition()));
        }
    }
    function d(t, e) {
        const o = e.target;
        o && !e.defaultPrevented && o.dataset.panzoomAction && p(o.dataset.panzoomAction);
    }
    function f(t, i) {
        const a = i.el;
        if (!s || !a || i.panzoomRef) return;
        const c = i.src || i.lazySrc || "", r = i.alt || i.caption || `Image #${i.index}`, d = i.srcset || i.lazySrcset || "", f = i.sizes || i.lazySizes || "";
        if (c && (0, $c7ba36523489ae88$export$844ec244b1367d54)(c) && !i.html && (!i.type || "image" === i.type)) {
            i.type = "image", i.thumbSrc = i.thumbSrc || c;
            let t = l("tpl", i);
            t = (0, $c9e1e2074c21be77$export$b8b3234b4edfc4c2)(t, "{{src}}", c + ""), t = (0, $c9e1e2074c21be77$export$b8b3234b4edfc4c2)(t, "{{srcset}}", d + ""), t = (0, $c9e1e2074c21be77$export$b8b3234b4edfc4c2)(t, "{{sizes}}", f + ""), a.insertAdjacentHTML("afterbegin", t);
        }
        const u = a.querySelector(".f-panzoom__content");
        if (!u) return;
        u.setAttribute("alt", r + "");
        const g = i.width && "auto" !== i.width ? parseFloat(i.width + "") : "auto", p = i.height && "auto" !== i.height ? parseFloat(i.height + "") : "auto", z = (0, $de7268de96c5ce00$export$b704d075ddd20210)(a, Object.assign({
            width: g,
            height: p,
            classes: {
                container: "f-zoomable"
            },
            event: ()=>null == s ? void 0 : s.getLastMouseMove(),
            spinnerTpl: ()=>(null == s ? void 0 : s.getOption("spinnerTpl")) || ""
        }, l("Panzoom")));
        z.on("*", (t, e, ...o)=>{
            s && ("loading" === e && (i.state = 0), "loaded" === e && (i.state = 1), "error" === e && (i.state = 2, null == s || s.showError(i, "{{IMAGE_ERROR}}")), s.emit(`panzoom:${e}`, i, ...o), "loading" === e && s.emit("contentLoading", i), "ready" === e && s.emit("contentReady", i), i.index === (null == s ? void 0 : s.getPageIndex()) && m());
        }), i.panzoomRef = z;
    }
    function u(t, e) {
        e.panzoomRef && (e.panzoomRef.destroy(), e.panzoomRef = void 0);
    }
    function g(t, e) {
        const o = e.panzoomRef;
        if (o) switch(o.getState()){
            case 0:
                o.init();
                break;
            case 3:
                o.execute((0, $de7268de96c5ce00$export$9520bccbaf78266).ZoomTo, Object.assign(Object.assign({}, o.getStartPosition()), {
                    velocity: 0
                }));
        }
    }
    function m() {
        var t, e;
        const o = (null == s ? void 0 : s.getContainer()) || void 0, n = null === (e = null === (t = null == s ? void 0 : s.getPage()) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.panzoomRef;
        if (o) {
            if (n) n.updateControls(o);
            else for (const t of o.querySelectorAll("[data-panzoom-action]") || [])t.setAttribute("aria-disabled", ""), t.setAttribute("tabindex", "-1");
        }
    }
    function p(t, ...e) {
        var o;
        null === (o = null == s ? void 0 : s.getPage().slides[0].panzoomRef) || void 0 === o || o.execute(t, ...e);
    }
    return {
        init: function(t) {
            s = t, s.on("initPlugins", c);
        },
        destroy: function() {
            if (s) {
                s.off("initPlugins", c), s.off("addSlide", f), s.off("removeSlide", u), s.off("attachSlideEl", g), s.off("click", d), s.off("change", r), s.off("ready", r);
                for (const t of s.getSlides())u(0, t);
            }
            s = void 0;
        },
        execute: p
    };
};


/*! License details at fancyapps.com/license */ 
const $17ba7889db7bb96a$var$e = {
    syncOnChange: !1,
    syncOnClick: !0,
    syncOnHover: !1
}, $17ba7889db7bb96a$export$2ae15352e0a80063 = ()=>{
    let i, t;
    function o() {
        const t = null == i ? void 0 : i.getOptions().Sync;
        return (0, $1e899da006e724cc$export$53b83ca8eaab0383)(t) ? Object.assign(Object.assign({}, $17ba7889db7bb96a$var$e), t) : $17ba7889db7bb96a$var$e;
    }
    function s(n) {
        var e, s, l;
        i && n && (t = n, i.getOptions().classes = Object.assign(Object.assign({}, i.getOptions().classes), {
            isSelected: ""
        }), i.getOptions().initialSlide = (null === (s = null === (e = t.getPage()) || void 0 === e ? void 0 : e.slides[0]) || void 0 === s ? void 0 : s.index) || 0, o().syncOnChange && i.on("change", c), o().syncOnClick && i.on("click", g), o().syncOnHover && (null === (l = i.getViewport()) || void 0 === l || l.addEventListener("mouseover", u)), function() {
            if (!i || !t) return;
            i.on("ready", d), i.on("refresh", a), t.on("change", r), t.on("filter", f);
        }());
    }
    function l() {
        const n = o().target;
        i && n && s(n);
    }
    function d() {
        v();
    }
    function c() {
        var n;
        if (i && t) {
            const e = (null === (n = i.getPage()) || void 0 === n ? void 0 : n.slides) || [], o = t.getPageIndex(e[0].index || 0);
            o > -1 && t.goTo(o, i.hasNavigated() ? void 0 : {
                tween: !1,
                transition: !1
            }), v();
        }
    }
    function r() {
        var n;
        if (i && t) {
            const e = i.getPageIndex((null === (n = t.getPage()) || void 0 === n ? void 0 : n.slides[0].index) || 0);
            e > -1 && i.goTo(e, t.hasNavigated() ? void 0 : {
                tween: !1,
                transition: !1
            }), v();
        }
    }
    function g(n, e) {
        var o;
        if (!i || !t) return;
        if (null === (o = i.getTween()) || void 0 === o ? void 0 : o.isRunning()) return;
        const s = null == i ? void 0 : i.getOptions().classes.slide;
        if (!s) return;
        const l = s ? e.target.closest(`.${s}`) : null;
        if (l) {
            const n = parseInt(l.getAttribute("index") || "") || 0, e = t.getPageIndex(n);
            t.goTo(e);
        }
    }
    function u(n) {
        i && g(0, n);
    }
    function a() {
        var n;
        if (i && t) {
            const e = i.getPageIndex((null === (n = t.getPage()) || void 0 === n ? void 0 : n.slides[0].index) || 0);
            e > -1 && i.goTo(e, {
                tween: !1,
                transition: !1
            }), v();
        }
    }
    function f(n, e) {
        i && t && (i.filter(e), r());
    }
    function v() {
        var n, e, o;
        if (!t) return;
        const s = (null === (e = null === (n = t.getPage()) || void 0 === n ? void 0 : n.slides[0]) || void 0 === e ? void 0 : e.index) || 0;
        for (const n of (null == i ? void 0 : i.getSlides()) || [])null === (o = n.el) || void 0 === o || o.classList.toggle("is-selected", n.index === s);
    }
    return {
        init: function(n) {
            i = n, i.on("initSlides", l);
        },
        destroy: function() {
            var n;
            null == i || i.off("ready", d), null == i || i.off("refresh", a), null == i || i.off("change", c), null == i || i.off("click", g), null === (n = null == i ? void 0 : i.getViewport()) || void 0 === n || n.removeEventListener("mouseover", u), null == t || t.off("change", r), null == t || t.off("filter", f), t = void 0, null == i || i.off("initSlides", l), i = void 0;
        },
        getTarget: function() {
            return t;
        }
    };
};


/*! License details at fancyapps.com/license */ 


const $b65fefa3c8c7a2c8$var$s = {
    showLoading: !0,
    preload: 1
}, $b65fefa3c8c7a2c8$var$n = "is-lazyloading", $b65fefa3c8c7a2c8$var$o = "is-lazyloaded", $b65fefa3c8c7a2c8$var$l = "has-lazyerror", $b65fefa3c8c7a2c8$export$6f539aaa4f74fdd1 = ()=>{
    let i;
    function d() {
        const e = null == i ? void 0 : i.getOptions().Lazyload;
        return (0, $1e899da006e724cc$export$53b83ca8eaab0383)(e) ? Object.assign(Object.assign({}, $b65fefa3c8c7a2c8$var$s), e) : $b65fefa3c8c7a2c8$var$s;
    }
    function r(t) {
        var s;
        const r = t.el;
        if (!r) return;
        const c = "[data-lazy-src],[data-lazy-srcset],[data-lazy-bg]", u = Array.from(r.querySelectorAll(c));
        r.matches(c) && u.push(r);
        for (const r of u){
            const c = r.dataset.lazySrc, u = r.dataset.lazySrcset, f = r.dataset.lazySizes, m = r.dataset.lazyBg, y = (r instanceof HTMLImageElement || r instanceof HTMLSourceElement) && (c || u), z = r instanceof HTMLElement && m;
            if (!y && !z) continue;
            const g = c || u || m;
            if (g) {
                if (y && g) {
                    const m = null === (s = r.parentElement) || void 0 === s ? void 0 : s.classList.contains("f-panzoom__wrapper");
                    d().showLoading && (null == i || i.showLoading(t)), r.addEventListener("load", ()=>{
                        null == i || i.hideLoading(t), (0, $a4c70e77d1c194a1$export$c2255604a80b4506)(r, $b65fefa3c8c7a2c8$var$l), r instanceof HTMLImageElement ? r.decode().then(()=>{
                            (0, $a4c70e77d1c194a1$export$c2255604a80b4506)(r, $b65fefa3c8c7a2c8$var$n), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(r, $b65fefa3c8c7a2c8$var$o);
                        }).catch(()=>{
                            (0, $a4c70e77d1c194a1$export$c2255604a80b4506)(r, $b65fefa3c8c7a2c8$var$n), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(r, $b65fefa3c8c7a2c8$var$o);
                        }) : ((0, $a4c70e77d1c194a1$export$c2255604a80b4506)(r, $b65fefa3c8c7a2c8$var$n), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(r, $b65fefa3c8c7a2c8$var$o)), m || null == i || i.emit("lazyLoad:loaded", t, r, g);
                    }), r.addEventListener("error", ()=>{
                        null == i || i.hideLoading(t), (0, $a4c70e77d1c194a1$export$c2255604a80b4506)(r, $b65fefa3c8c7a2c8$var$n), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(r, $b65fefa3c8c7a2c8$var$l), m || null == i || i.emit("lazyLoad:error", t, r, g);
                    }), r.classList.add("f-lazyload"), r.classList.add($b65fefa3c8c7a2c8$var$n), m || null == i || i.emit("lazyLoad:load", t, r, g), c && (r.src = c), u && (r.srcset = u), f && (r.sizes = f);
                } else if (z) {
                    if (!document.body.contains(r)) document.createElement("img").src = m;
                    r.style.backgroundImage = `url('${m}')`;
                }
                delete r.dataset.lazySrc, delete r.dataset.lazySrcset, delete r.dataset.lazySizes, delete r.dataset.lazyBg;
            }
        }
    }
    function c() {
        if (!i) return;
        const e = [
            ...i.getVisibleSlides()
        ], t = d().preload;
        if (t > 0) {
            const a = i.getPosition(), s = i.getViewportDim();
            e.push(...i.getVisibleSlides(a + s * t), ...i.getVisibleSlides(a - s * t));
        }
        for (const t of e)r(t);
    }
    return {
        init: function(e) {
            i = e, i.on("render", c);
        },
        destroy: function() {
            null == i || i.off("render", c), i = void 0;
        }
    };
};


/*! License details at fancyapps.com/license */ 



const $f99c1e5e8827838d$var$r = '<svg width="24" height="24" viewBox="0 0 24 24" tabindex="-1">', $f99c1e5e8827838d$var$i = "</svg>", $f99c1e5e8827838d$var$s = {
    prevTpl: $f99c1e5e8827838d$var$r + '<path d="M15 3l-9 9 9 9"></path>' + $f99c1e5e8827838d$var$i,
    nextTpl: $f99c1e5e8827838d$var$r + '<path d="M9 3l9 9-9 9"></path>' + $f99c1e5e8827838d$var$i
}, $f99c1e5e8827838d$export$b6e350ab9915297a = ()=>{
    let r, i, l;
    function a() {
        const t = null == r ? void 0 : r.getOptions().Arrows;
        return (0, $1e899da006e724cc$export$53b83ca8eaab0383)(t) ? Object.assign(Object.assign({}, $f99c1e5e8827838d$var$s), t) : $f99c1e5e8827838d$var$s;
    }
    function u(e) {
        if (!r) return;
        const o = `<button data-carousel-go-${e} tabindex="0" class="f-button is-arrow is-${e}" title="{{${e.toUpperCase()}}}">` + a()[`${e}Tpl`] + "</button", i = (0, $b8a64cd90ff0bd86$export$b368690db5627d91)(r.localize(o)) || void 0;
        return i && (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(i, a()[`${e}Class`]), i;
    }
    function c() {
        var t;
        null == i || i.remove(), i = void 0, null == l || l.remove(), l = void 0, null === (t = null == r ? void 0 : r.getContainer()) || void 0 === t || t.classList.remove("has-arrows");
    }
    function d() {
        r && !1 !== r.getOptions().Arrows && r.getPages().length > 1 ? (!function() {
            if (!r) return;
            const t = r.getViewport();
            t && (i || (i = u("prev"), i && t.insertAdjacentElement("beforebegin", i)), l || (l = u("next"), l && t.insertAdjacentElement("afterend", l)), (0, $98c82c03f7f08e20$export$4a80062ca50b57c7)(r.getContainer(), "has-arrows", !(!i && !l)));
        }(), r && (null == i || i.toggleAttribute("aria-disabled", !r.canGoPrev()), null == l || l.toggleAttribute("aria-disabled", !r.canGoNext()))) : c();
    }
    return {
        init: function(t) {
            r = t.on([
                "change",
                "refresh"
            ], d);
        },
        destroy: function() {
            c(), null == r || r.off([
                "change",
                "refresh"
            ], d), r = void 0;
        }
    };
};


/*! License details at fancyapps.com/license */ 


/*! License details at fancyapps.com/license */ const $9496f14bf13beb4f$var$t = '<circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/>', $9496f14bf13beb4f$var$M = '<g><line x1="11" y1="8" x2="11" y2="14"></line></g>' + $9496f14bf13beb4f$var$t, $9496f14bf13beb4f$var$o = {
    moveLeft: [
        "moveLeft",
        "MOVE_LEFT",
        '<path d="M5 12h14M5 12l6 6M5 12l6-6"/>'
    ],
    moveRight: [
        "moveRight",
        "MOVE_RIGHT",
        '<path d="M5 12h14M13 18l6-6M13 6l6 6"/>'
    ],
    moveUp: [
        "moveUp",
        "MOVE_UP",
        '<path d="M12 5v14M18 11l-6-6M6 11l6-6"/>'
    ],
    moveDown: [
        "moveDown",
        "MOVE_DOWN",
        '<path d="M12 5v14M18 13l-6 6M6 13l6 6"/>'
    ],
    zoomOut: [
        "zoomOut",
        "ZOOM_OUT",
        $9496f14bf13beb4f$var$t
    ],
    zoomIn: [
        "zoomIn",
        "ZOOM_IN",
        $9496f14bf13beb4f$var$M
    ],
    toggleFull: [
        "toggleFull",
        "TOGGLE_FULL",
        $9496f14bf13beb4f$var$M
    ],
    iterateZoom: [
        "iterateZoom",
        "ITERATE_ZOOM",
        $9496f14bf13beb4f$var$M
    ],
    toggle1to1: [
        "toggleFull",
        "TOGGLE_FULL",
        '<path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/>'
    ],
    rotateCCW: [
        "rotateCCW",
        "ROTATE_CCW",
        '<path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/>'
    ],
    rotateCW: [
        "rotateCW",
        "ROTATE_CW",
        '<path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/>'
    ],
    flipX: [
        "flipX",
        "FLIP_X",
        '<path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/>'
    ],
    flipY: [
        "flipY",
        "FLIP_Y",
        '<path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/>'
    ],
    reset: [
        "reset",
        "RESET",
        '<path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/>'
    ],
    toggleFS: [
        "toggleFS",
        "TOGGLE_FS",
        '<g><path d="M14.5 9.5 21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"/></g><g><path d="m14 10 7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"/></g>'
    ]
}, $9496f14bf13beb4f$export$1a5903fe7331d64a = {};
for (const [t, M] of Object.entries($9496f14bf13beb4f$var$o))$9496f14bf13beb4f$export$1a5903fe7331d64a[t] = {
    tpl: `<button data-panzoom-action="${M[0]}" class="f-button" title="{{${M[1]}}}"><svg>${M[2]}</svg></button>`
};





var $85165c1eb0f0af40$export$68ae38b485887054;
!function(t) {
    t.Left = "left", t.middle = "middle", t.right = "right";
}($85165c1eb0f0af40$export$68ae38b485887054 || ($85165c1eb0f0af40$export$68ae38b485887054 = {}));
const $85165c1eb0f0af40$var$r = Object.assign({
    counter: {
        tpl: '<div class="f-counter"><span data-carousel-page></span>/<span data-carousel-pages></span></div>'
    },
    download: {
        tpl: '<button data-carousel-download class="f-button" title="{{DOWNLOAD}}"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></button>'
    },
    autoplay: {
        tpl: '<button data-autoplay-action="toggle" class="f-button" title="{{TOGGLE_AUTOPLAY}}"><svg><g><path d="M5 3.5 19 12 5 20.5Z"/></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>'
    },
    thumbs: {
        tpl: '<button data-thumbs-action="toggle" class="f-button" title="{{TOGGLE_THUMBS}}"><svg><rect width="18" height="14" x="3" y="3" rx="2"/><path d="M4 21h1M9 21h1M14 21h1M19 21h1"/></svg></button>'
    }
}, (0, $9496f14bf13beb4f$export$1a5903fe7331d64a)), $85165c1eb0f0af40$var$u = {
    absolute: !1,
    display: {
        left: [],
        middle: [
            "zoomIn",
            "zoomOut",
            "toggle1to1",
            "rotateCCW",
            "rotateCW",
            "flipX",
            "flipY",
            "reset"
        ],
        right: []
    },
    enabled: "auto",
    items: {}
}, $85165c1eb0f0af40$export$4c260019440d418f = ()=>{
    let a, c;
    function d(e) {
        const o = null == a ? void 0 : a.getOptions().Toolbar;
        let n = ((0, $1e899da006e724cc$export$53b83ca8eaab0383)(o) ? Object.assign(Object.assign({}, $85165c1eb0f0af40$var$u), o) : $85165c1eb0f0af40$var$u)[e];
        return n && "function" == typeof n && a ? n(a) : n;
    }
    function f() {
        var s;
        if (!(null == a ? void 0 : a.getOptions().Toolbar)) return;
        if (!a || c) return;
        const u = a.getContainer();
        if (!u) return;
        let f = d("enabled");
        if (!f) return;
        const p = d("absolute"), g = a.getSlides().length > 1;
        let b = !1, m = !1;
        for (const t of a.getSlides())t.panzoomRef && (b = !0), (t.downloadSrc || "image" === t.type && t.src) && (m = !0);
        const v = (null === (s = a.getPlugins().Thumbs) || void 0 === s ? void 0 : s.isEnabled()) || !1, h = g && a.getPlugins().Autoplay || !1, j = a.getPlugins().Fullscreen && (document.fullscreenEnabled || document.webkitFullscreenEnabled);
        if ("auto" === f && (f = b), !f) return;
        c = u.querySelector(".f-carousel__toolbar") || void 0, c || (c = document.createElement("div"), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(c, "f-carousel__toolbar"));
        const E = d("display"), y = (0, $1b7cd36eed9df61a$export$8b58be045bf06082)({}, $85165c1eb0f0af40$var$r, d("items"));
        for (const l of [
            "left",
            "middle",
            "right"
        ]){
            const s = E[l] || [], r = document.createElement("div");
            (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(r, `f-carousel__toolbar__column is-${l}`);
            for (const l of s){
                let i;
                if ((0, $c7ba36523489ae88$export$844ec244b1367d54)(l)) {
                    if ("counter" === l && !g) continue;
                    if ("autoplay" === l && !h) continue;
                    if ((0, $9496f14bf13beb4f$export$1a5903fe7331d64a)[l] && !b) continue;
                    if ("fullscreen" === l && !j) continue;
                    if ("thumbs" === l && !v) continue;
                    if ("download" === l && !m) continue;
                    i = y[l];
                }
                if ((0, $1e899da006e724cc$export$53b83ca8eaab0383)(l) && (i = l), i && i.tpl) {
                    let t = a.localize(i.tpl);
                    t = t.split("<svg>").join('<svg tabindex="-1" width="24" height="24" viewBox="0 0 24 24">');
                    const e = (0, $b8a64cd90ff0bd86$export$b368690db5627d91)(t);
                    e && ("function" == typeof i.click && a && e.addEventListener("click", (t)=>{
                        t.preventDefault(), t.stopPropagation(), "function" == typeof i.click && a && i.click(a, t);
                    }), r.append(e));
                }
            }
            c.append(r);
        }
        if (c.childElementCount) {
            if (p && (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(c, "is-absolute"), !c.parentElement) {
                const t = d("parentEl");
                t ? t.insertAdjacentElement("afterbegin", c) : u.insertAdjacentElement("afterbegin", c);
            }
            u.contains(c) && ((0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(u, "has-toolbar"), p && (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(u, "has-absolute-toolbar"));
        }
    }
    return {
        init: function(t) {
            a = t, null == a || a.on("initSlides", f);
        },
        destroy: function() {
            null == a || a.off("initSlides", f), (0, $a4c70e77d1c194a1$export$c2255604a80b4506)(null == a ? void 0 : a.getContainer(), "has-toolbar has-absolute-toolbar"), null == c || c.remove(), c = void 0;
        },
        add: function(t, e) {
            $85165c1eb0f0af40$var$r[t] = e;
        },
        isEnabled: function() {
            return !!c;
        }
    };
};


/*! License details at fancyapps.com/license */ 

const $f034ed8d818e362d$var$n = {
    autoStart: !0,
    pauseOnHover: !0,
    showProgressbar: !0,
    timeout: 2e3
}, $f034ed8d818e362d$export$6c96167f46662e38 = ()=>{
    let o, i, a = !1, s = !1, l = !1, r = null;
    function u(e) {
        const i = null == o ? void 0 : o.getOptions().Autoplay;
        let a = ((0, $1e899da006e724cc$export$53b83ca8eaab0383)(i) ? Object.assign(Object.assign({}, $f034ed8d818e362d$var$n), i) : $f034ed8d818e362d$var$n)[e];
        return a && "function" == typeof a && o ? a(o) : a;
    }
    function f() {
        clearTimeout(i), i = void 0;
    }
    function g() {
        if (!o || !a || l || s || i || !o.isSettled() || function() {
            var t;
            const e = (null === (t = null == o ? void 0 : o.getPage()) || void 0 === t ? void 0 : t.slides) || [];
            for (const t of e)if (0 === t.state) return !0;
            return !1;
        }()) return;
        !function() {
            var t, n, i, a;
            if (!o) return;
            if (v(), !u("showProgressbar")) return;
            let s = u("progressbarParentEl");
            !s && (null === (t = o.getPlugins().Toolbar) || void 0 === t ? void 0 : t.isEnabled()) && (s = o.getContainer());
            if (!s && !0 !== (null === (n = o.getPlugins().Toolbar) || void 0 === n ? void 0 : n.isEnabled())) {
                const t = (null === (i = o.getPages()[0]) || void 0 === i ? void 0 : i.slides) || [], e = (null === (a = o.getPage()) || void 0 === a ? void 0 : a.slides) || [];
                1 === t.length && 1 === e.length && (s = e[0].el);
            }
            s || (s = o.getViewport());
            if (!s) return;
            r = document.createElement("div"), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(r, "f-progressbar"), s.prepend(r);
            const l = u("timeout") || 1e3;
            r.style.animationDuration = `${l}ms`;
        }();
        const t = u("timeout");
        i = setTimeout(()=>{
            o && a && !s && (o.isInfinite() || o.getPageIndex() !== o.getPages().length - 1 ? o.next() : o.goTo(0));
        }, t);
    }
    function c() {
        var t;
        if (!o || o.getPages().length < 2 || !1 === o.getOptions().Autoplay) return;
        if (a) return;
        a = !0, o.emit("autoplay:start", u("timeout")), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(o.getContainer(), "has-autoplay"), null === (t = o.getTween()) || void 0 === t || t.on("start", b);
        const n = null == o ? void 0 : o.getContainer();
        n && u("pauseOnHover") && matchMedia("(hover: hover)").matches && (n.addEventListener("mouseenter", E, !1), n.addEventListener("mouseleave", w, !1)), o.on("change", P), o.on("settle", y), o.on("contentReady", p), o.on("panzoom:touchStart", d), o.on("panzoom:wheel", d), o.isSettled() && g();
    }
    function d() {
        var t;
        if (f(), v(), o) {
            if (a) {
                o.emit("autoplay:end"), null === (t = o.getTween()) || void 0 === t || t.off("start", b);
                const e = o.getContainer();
                e && (e.classList.remove("has-autoplay"), e.removeEventListener("mouseenter", E, !1), e.removeEventListener("mouseleave", w, !1));
            }
            o.off("change", P), o.off("settle", y), o.off("contentReady", p), o.off("panzoom:touchStart", d), o.off("panzoom:wheel", d);
        }
        a = !1, s = !1;
    }
    function v() {
        r && (r.remove(), r = null);
    }
    function m() {
        o && o.getPages().length > 1 && u("autoStart") && c();
    }
    function p() {
        g();
    }
    function h(t, e) {
        const n = e.target;
        n && !e.defaultPrevented && "toggle" === n.dataset.autoplayAction && O.toggle();
    }
    function P() {
        !o || !(null == o ? void 0 : o.isInfinite()) && o.getPageIndex() === o.getPages().length - 1 ? d() : (v(), f());
    }
    function y() {
        g();
    }
    function b() {
        f(), v();
    }
    function E() {
        l = !0, a && (v(), f());
    }
    function w() {
        l = !1, a && !s && (null == o ? void 0 : o.isSettled()) && g();
    }
    const O = {
        init: function(t) {
            o = t, o.on("ready", m), o.on("click", h);
        },
        destroy: function() {
            d(), null == o || o.off("ready", m), null == o || o.off("click", h), o = void 0;
        },
        isEnabled: ()=>a,
        pause: function() {
            s = !0, f();
        },
        resume: function() {
            s = !1, a && !l && g();
        },
        start () {
            c();
        },
        stop () {
            d();
        },
        toggle () {
            a ? d() : c();
        }
    };
    return O;
};


/*! License details at fancyapps.com/license */ 







const $5a3448b7872fed9e$var$u = {
    Carousel: {
        Lazyload: {
            showLoading: !1
        }
    },
    minCount: 2,
    showOnStart: !0,
    thumbTpl: '<button aria-label="Slide to #{{page}}"><img draggable="false" alt="{{alt}}" data-lazy-src="{{src}}" /></button>',
    type: "modern"
};
let $5a3448b7872fed9e$var$a;
const $5a3448b7872fed9e$export$73e055b807a6709 = ()=>{
    let c, d, f, m, g, h = 0, v = 0, p = !0;
    function b(e) {
        const n = null == c ? void 0 : c.getOptions().Thumbs;
        let o = ((0, $1e899da006e724cc$export$53b83ca8eaab0383)(n) ? Object.assign(Object.assign({}, $5a3448b7872fed9e$var$u), n) : $5a3448b7872fed9e$var$u)[e];
        return o && "function" == typeof o && c ? o(c) : o;
    }
    function y() {
        if (!c) return !1;
        if (!1 === (null == c ? void 0 : c.getOptions().Thumbs)) return !1;
        let t = 0;
        for (const e of c.getSlides())e.thumbSrc && t++;
        return t >= b("minCount");
    }
    function x() {
        return "modern" === b("type");
    }
    function S() {
        return "scrollable" === b("type");
    }
    function C() {
        const t = [], e = (null == c ? void 0 : c.getSlides()) || [];
        for (const n of e)t.push({
            index: n.index,
            class: n.thumbClass,
            html: T(n)
        });
        return t;
    }
    function T(t) {
        const e = t.thumb ? t.thumb instanceof HTMLImageElement ? t.thumb.src : t.thumb : t.thumbSrc || void 0, o = void 0 === t.thumbAlt ? `Thumbnail #${(t.index || 0) + 1}` : t.thumbAlt + "";
        let i = b("thumbTpl");
        return i = (0, $c9e1e2074c21be77$export$b8b3234b4edfc4c2)(i, "{{alt}}", o), i = (0, $c9e1e2074c21be77$export$b8b3234b4edfc4c2)(i, "{{src}}", e + ""), i = (0, $c9e1e2074c21be77$export$b8b3234b4edfc4c2)(i, "{{index}}", `${t.index || 0}`), i = (0, $c9e1e2074c21be77$export$b8b3234b4edfc4c2)(i, "{{page}}", `${(t.index || 0) + 1}`), i;
    }
    function L(t) {
        return `<div index="${t.index || 0}" class="f-thumbs__slide ${t.class || ""}">${t.html || ""}</div>`;
    }
    function E(t = !1) {
        var e;
        const n = null == c ? void 0 : c.getContainer();
        if (!c || !n || f || !y()) return;
        const o = (null === (e = b("Carousel")) || void 0 === e ? void 0 : e.classes) || {};
        if (o.container = o.container || "f-thumbs", !f) {
            const t = n.nextElementSibling;
            (null == t ? void 0 : t.classList.contains(o.container)) && (f = t);
        }
        if (!f) {
            f = document.createElement("div");
            const t = b("parentEl");
            t ? t.insertAdjacentElement("beforeend", f) : n.insertAdjacentElement("afterend", f);
        }
        (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(f, o.container), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(f, "f-thumbs"), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(f, `is-${b("type")}`), t && (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(f, "is-hidden");
    }
    function P() {
        if (!f || !S()) return;
        m = document.createElement("div"), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(m, "f-thumbs__viewport");
        let t = "";
        for (const e of C())"string" == typeof (e.html || "") && (t += L(e));
        m.innerHTML = t, f.append(m), f.addEventListener("click", (t)=>{
            t.preventDefault();
            const e = t.target.closest("[index]"), n = parseInt((null == e ? void 0 : e.getAttribute("index")) || "-1");
            c && n > -1 && c.goTo(n);
        }), g = new IntersectionObserver((t)=>{
            t.forEach((t)=>{
                t.isIntersecting && t.target instanceof HTMLImageElement && (t.target.src = t.target.getAttribute("data-lazy-src") + "", t.target.removeAttribute("data-lazy-src"), null == g || g.unobserve(t.target));
            });
        }, {
            root: m,
            rootMargin: "100px"
        }), f.querySelectorAll("[data-lazy-src]").forEach((t)=>{
            null == g || g.observe(t);
        }), null == c || c.emit("thumbs:ready");
    }
    function w() {
        var t;
        if (!$5a3448b7872fed9e$var$a || !c || !f || S() || d) return;
        const n = C();
        if (!n.length) return;
        const o = (0, $1b7cd36eed9df61a$export$8b58be045bf06082)({}, {
            Sync: {
                target: c
            },
            Lazyload: {
                preload: 1
            },
            slides: n,
            classes: {
                container: "f-thumbs",
                viewport: "f-thumbs__viewport",
                slide: "f-thumbs__slide"
            },
            center: !0,
            fill: !x(),
            infinite: !1,
            dragFree: !0,
            rtl: c.getOptions().rtl || !1,
            slidesPerPage: (t)=>{
                let e = 0;
                return x() && (!function() {
                    if (!x()) return;
                    if (!f) return;
                    const t = (t)=>f && parseFloat(getComputedStyle(f).getPropertyValue("--f-thumb-" + t)) || 0;
                    h = t("width"), v = t("clip-width");
                }(), e = 4 * (h - v)), t && t.getTotalSlideDim() <= t.getViewportDim() - e ? 1 / 0 : 1;
            }
        }, $5a3448b7872fed9e$var$u.Carousel || {}, b("Carousel") || {});
        d = $5a3448b7872fed9e$var$a(f, o, {
            Sync: (0, $17ba7889db7bb96a$export$2ae15352e0a80063),
            Lazyload: (0, $b65fefa3c8c7a2c8$export$6f539aaa4f74fdd1)
        }), d.on("ready", ()=>{
            (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(f, "is-syncing"), null == c || c.emit("thumbs:ready"), x() && (null == c || c.on("render", $));
        }), d.on("destroy", ()=>{
            null == c || c.emit("thumbs:destroy");
        }), d.init(), null === (t = d.getGestures()) || void 0 === t || t.on("start", ()=>{
            p = !1;
        }), d.on("click", (t, e)=>{
            const n = e.target;
            if (n) {
                const t = n.matches("button") ? n : n.firstElementChild;
                t && t.matches("button") && (e.preventDefault(), t.focus({
                    preventScroll: !0
                }));
            }
        }), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(c.getContainer(), "has-thumbs"), R();
    }
    function j() {
        y() && b("showOnStart") && (E(), P());
    }
    function A() {
        var t;
        y() && (w(), null == c || c.on("addSlide", z), null == c || c.on("removeSlide", _), null == c || c.on("click", I), null == c || c.on("refresh", q), null === (t = null == c ? void 0 : c.getGestures()) || void 0 === t || t.on("start", M), D(!0));
    }
    function M() {
        var t, e;
        p = !0;
        (null === (t = document.activeElement) || void 0 === t ? void 0 : t.closest(".f-thumbs")) && (null === (e = document.activeElement) || void 0 === e || e.blur());
    }
    function $() {
        var t, e;
        null == f || f.classList.toggle("is-syncing", !1 === (null == c ? void 0 : c.hasNavigated()) || (null === (t = null == c ? void 0 : c.getTween()) || void 0 === t ? void 0 : t.isRunning())), R(), (null === (e = null == c ? void 0 : c.getGestures()) || void 0 === e ? void 0 : e.isPointerDown()) && function() {
            if (!x()) return;
            if (!c || !d) return;
            if (!p) return;
            const t = d.getTween(), e = d.getPages(), n = c.getPageIndex() || 0, i = c.getPageProgress() || 0;
            if (!(c && e && e[n] && t)) return;
            const l = t.isRunning() ? t.getCurrentValues().pos : d.getPosition();
            if (void 0 === l) return;
            let r = e[n].pos + i * (h - v);
            r = (0, $c6eb984b6f19ff0a$export$7d15b64cf5a3a4c4)(e[0].pos, r, e[e.length - 1].pos), t.from({
                pos: l
            }).to({
                pos: r
            }).start();
        }();
    }
    function O() {
        p = !0, D();
    }
    function z(t, e) {
        const n = {
            html: T(e)
        };
        if (d) d.add(n, e.index);
        else if (m) {
            const t = (0, $b8a64cd90ff0bd86$export$b368690db5627d91)(L(n));
            if (t) {
                m.append(t);
                const e = t.querySelector("img");
                e && (null == g || g.observe(e));
            }
        }
    }
    function _(t, e) {
        var n;
        d ? d.remove(e.index) : m && (null === (n = m.querySelector(`[index="${e.index}"]`)) || void 0 === n || n.remove());
    }
    function I(t, e) {
        var n;
        const o = e.target;
        e.defaultPrevented || "toggle" !== (null === (n = null == o ? void 0 : o.dataset) || void 0 === n ? void 0 : n.thumbsAction) || (f || (E(!0), P(), w()), f && f.classList.toggle("is-hidden"));
    }
    function q() {
        D();
    }
    function D(t = !1) {
        if (!c || !m || !S()) return;
        const e = c.getPageIndex();
        m.querySelectorAll(".is-selected").forEach((t)=>{
            t.classList.remove("is-selected");
        });
        const n = m.querySelector(`[index="${e}"]`);
        if (n) {
            n.classList.add("is-selected");
            const e = m.getBoundingClientRect(), o = n.getBoundingClientRect(), i = n.offsetTop - m.offsetTop - .5 * e.height + .5 * o.height, l = n.scrollLeft - m.scrollLeft - .5 * e.width + .5 * o.width;
            m.scrollTo({
                top: i,
                left: l,
                behavior: t ? "instant" : "smooth"
            });
        }
    }
    function R() {
        if (!x()) return;
        if (!c || !d) return;
        const t = (null == d ? void 0 : d.getSlides()) || [];
        let e = -0.5 * h;
        for (const n of t){
            const t = n.el;
            if (!t) continue;
            let o = c.getPageProgress(n.index) || 0;
            o = Math.max(-1, Math.min(1, o)), o > -1 && o < 1 && (e += .5 * h * (1 - Math.abs(o))), o = Math.round(1e4 * o) / 1e4, e = Math.round(1e4 * e) / 1e4, t.style.setProperty("--progress", `${Math.abs(o)}`), t.style.setProperty("--shift", `${(null == c ? void 0 : c.isRTL()) ? -1 * e : e}px`), o > -1 && o < 1 && (e += .5 * h * (1 - Math.abs(o)));
        }
    }
    return {
        init: function(t, e) {
            $5a3448b7872fed9e$var$a = e, c = t, c.on("ready", A), c.on("initSlides", j), c.on("change", O);
        },
        destroy: function() {
            var t, e;
            S() && (null == c || c.emit("thumbs:destroy")), null == c || c.off("ready", A), null == c || c.off("initSlides", j), null == c || c.off("change", O), null == c || c.off("render", $), null == c || c.off("addSlide", z), null == c || c.off("click", I), null == c || c.off("refresh", q), null === (t = null == c ? void 0 : c.getGestures()) || void 0 === t || t.off("start", M), null === (e = null == c ? void 0 : c.getContainer()) || void 0 === e || e.classList.remove("has-thumbs"), c = void 0, null == d || d.destroy(), d = void 0, null == f || f.remove(), f = void 0;
        },
        getCarousel: function() {
            return d;
        },
        getContainer: function() {
            return f;
        },
        getType: function() {
            return b("type");
        },
        isEnabled: y
    };
};


/*! License details at fancyapps.com/license */ 



const $1cf0fa01ca4e501c$var$o = {
    autosize: !1,
    iframeAttr: {
        allow: "autoplay; fullscreen",
        scrolling: "auto"
    },
    preload: !1
}, $1cf0fa01ca4e501c$export$13f9d3c4397c4713 = ()=>{
    let l;
    function n() {
        const e = null == l ? void 0 : l.getOptions().Html;
        return (0, $1e899da006e724cc$export$53b83ca8eaab0383)(e) ? Object.assign(Object.assign({}, $1cf0fa01ca4e501c$var$o), e) : $1cf0fa01ca4e501c$var$o;
    }
    function s(t, e) {
        let i = t[e];
        return void 0 === i && (i = n()[e]), "true" === i || "false" !== i && i;
    }
    function r(t, i) {
        let a = i.type, o = i.src;
        if (!a && (0, $c7ba36523489ae88$export$844ec244b1367d54)(o)) {
            if ("#" === o.charAt(0) ? a = "inline" : o.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.((a)?png|avif|gif|jp(g|eg)|pjp(eg)?|jfif|svg|webp|bmp|ico|tif(f)?)((\?|#).*)?$)/i) ? a = "image" : o.match(/\.(pdf)((\?|#).*)?$/i) ? a = "pdf" : o.match(/\.(html|php)((\?|#).*)?$/i) && (a = "iframe"), !a) {
                const t = o.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i);
                t && (o = `https://maps.google.${t[1]}/?ll=${(t[2] ? t[2] + "&z=" + Math.floor(parseFloat(t[3])) + (t[4] ? t[4].replace(/^\//, "&") : "") : t[4] + "").replace(/\?/, "&")}&output=${t[4] && t[4].indexOf("layer=c") > 0 ? "svembed" : "embed"}`, a = "gmap");
            }
            if (!a) {
                const t = o.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i);
                t && (o = `https://maps.google.${t[1]}/maps?q=${t[2].replace("query=", "q=").replace("api=1", "")}&output=embed`, a = "gmap");
            }
            a && (i.src = o, i.type = a);
        }
    }
    function d(t, e) {
        "iframe" !== e.type && "pdf" !== e.type && "gmap" !== e.type || function(t) {
            const e = t.el, o = t.src;
            if (!l || !e || !o) return;
            const r = document.createElement("iframe");
            (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(r, "f-iframe");
            for (const [t, e] of Object.entries(n().iframeAttr || {}))r.setAttribute(t, e);
            r.onerror = ()=>{
                t.state = 2, null == l || l.showError(t, "{{IFRAME_ERROR}}");
            };
            const d = document.createElement("div");
            if ((0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(d, "f-html"), d.append(r), t.width) {
                let e = `${t.width}`;
                e.match(/^\d+$/) && (e += "px"), d.style.maxWidth = `${e}`;
            }
            if (t.height) {
                let e = `${t.height}`;
                e.match(/^\d+$/) && (e += "px"), d.style.maxHeight = `${e}`;
            }
            if (t.aspectRatio) {
                const i = e.getBoundingClientRect();
                d.style.aspectRatio = `${t.aspectRatio}`, d.style[i.width > i.height ? "width" : "height"] = "auto", d.style[i.width > i.height ? "maxWidth" : "maxHeight"] = "none";
            }
            t.htmlEl = d, t.contentEl = r, (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(e, `has-html has-iframe has-${t.type}`), e.prepend(d);
            const c = s(t, "preload"), p = s(t, "autosize");
            "iframe" === t.type && (c || p) ? (t.state = 0, l.showLoading(t), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(e, "is-loading"), r.onload = ()=>{
                if (!l || 1 !== l.getState() || !r.src.length) return;
                t.state = 1;
                const i = "true" !== r.dataset.ready;
                r.dataset.ready = "true", function(t) {
                    const e = t.contentEl, i = null == e ? void 0 : e.parentElement, a = null == i ? void 0 : i.style;
                    let o = s(t, "autosize"), l = t.width || 0, n = t.height || 0;
                    l && n && (o = !1);
                    if (!(e && i && a && o)) return;
                    try {
                        const t = window.getComputedStyle(i), o = parseFloat(t.paddingLeft) + parseFloat(t.paddingRight), s = parseFloat(t.paddingTop) + parseFloat(t.paddingBottom), r = e.contentWindow;
                        if (r) {
                            const t = r.document, e = t.getElementsByTagName("html")[0], i = t.body;
                            a.width = "";
                            const d = window.getComputedStyle(i), c = parseFloat(d.marginLeft) + parseFloat(d.marginRight), p = i.style.overflow || "";
                            i.style.overflow = "hidden", l = l || i.scrollWidth + c + o, a.flex = "0 0 auto", a.width = `${l}px`, a.height = `${i.scrollHeight}px`, i.style.overflow = p;
                            n = Math.max(e.scrollHeight, Math.ceil(e.getBoundingClientRect().height)) + s;
                        }
                    } catch (t) {}
                    if (l || n) {
                        const t = {
                            flex: "0 1 auto",
                            width: "",
                            height: ""
                        };
                        l && "auto" !== l && (t.width = `${l}px`), n && "auto" !== n && (t.height = `${n}px`), Object.assign(a, t);
                    }
                }(t), l.hideLoading(t), i && l.emit("contentReady", t), (0, $a4c70e77d1c194a1$export$c2255604a80b4506)(e, "is-loading");
            }, r.src = `${o}`) : (r.src = `${o}`, l.emit("contentReady", t));
        }(e);
    }
    function c(t, e) {
        var i, a;
        "iframe" !== e.type && "pdf" !== e.type && "gmap" !== e.type || (null == l || l.hideError(e), null === (i = e.contentEl) || void 0 === i || i.remove(), e.contentEl = void 0, null === (a = e.htmlEl) || void 0 === a || a.remove(), e.htmlEl = void 0);
    }
    return {
        init: function(t) {
            l = t, l.on("addSlide", r), l.on("attachSlideEl", d), l.on("detachSlideEl", c);
        },
        destroy: function() {
            null == l || l.off("addSlide", r), null == l || l.off("attachSlideEl", d), null == l || l.off("detachSlideEl", c), l = void 0;
        }
    };
};


/*! License details at fancyapps.com/license */ 



const $49aae305af93c6a5$var$i = (t, e = {})=>{
    const o = new URL(t), n = new URLSearchParams(o.search), i = new URLSearchParams;
    for (const [t, o] of [
        ...n,
        ...Object.entries(e)
    ]){
        let e = o + "";
        if ("t" === t) {
            let t = e.match(/((\d*)m)?(\d*)s?/);
            t && i.set("start", 60 * parseInt(t[2] || "0") + parseInt(t[3] || "0") + "");
        } else i.set(t, e);
    }
    let l = i + "", s = t.match(/#t=((.*)?\d+s)/);
    return s && (l += `#t=${s[1]}`), l;
}, $49aae305af93c6a5$var$l = {
    autoplay: !1,
    html5videoTpl: '<video class="f-html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n    <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
    iframeAttr: {
        allow: "autoplay; fullscreen",
        scrolling: "no",
        referrerPolicy: "strict-origin-when-cross-origin",
        credentialless: ""
    },
    vimeo: {
        byline: 1,
        color: "00adef",
        controls: 1,
        dnt: 1,
        muted: 0
    },
    youtube: {
        controls: 1,
        enablejsapi: 1,
        nocookie: 1,
        rel: 0,
        fs: 1
    }
}, $49aae305af93c6a5$export$ae01dedf5c052bb = ()=>{
    let s, r = !1;
    function c() {
        const t = null == s ? void 0 : s.getOptions().Video;
        return (0, $1e899da006e724cc$export$53b83ca8eaab0383)(t) ? Object.assign(Object.assign({}, $49aae305af93c6a5$var$l), t) : $49aae305af93c6a5$var$l;
    }
    function a() {
        var t;
        return null === (t = null == s ? void 0 : s.getPage()) || void 0 === t ? void 0 : t.slides[0];
    }
    const d = (t)=>{
        var e;
        try {
            let o = JSON.parse(t.data);
            if ("https://player.vimeo.com" === t.origin) {
                if ("ready" === o.event) for (let o of Array.from((null === (e = null == s ? void 0 : s.getContainer()) || void 0 === e ? void 0 : e.getElementsByClassName("f-iframe")) || []))o instanceof HTMLIFrameElement && o.contentWindow === t.source && (o.dataset.ready = "true");
            } else if (t.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && "onReady" === o.event) {
                const t = document.getElementById(o.id);
                t && (t.dataset.ready = "true");
            }
        } catch (t) {}
    };
    function m(t, e) {
        const n = e.src;
        if (!(0, $c7ba36523489ae88$export$844ec244b1367d54)(n)) return;
        let l = e.type;
        if (!l || "html5video" === l) {
            const t = n.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i);
            t && (l = "html5video", e.html5videoFormat = e.html5videoFormat || "video/" + ("ogv" === t[1] ? "ogg" : t[1]));
        }
        if (!l || "youtube" === l) {
            const t = n.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i);
            if (t) {
                const o = Object.assign(Object.assign({}, c().youtube), e.youtube || {}), s = `www.youtube${o.nocookie ? "-nocookie" : ""}.com`, r = $49aae305af93c6a5$var$i(n, o), a = encodeURIComponent(t[2]);
                e.videoId = a, e.src = `https://${s}/embed/${a}?${r}`, e.thumb = e.thumb || `https://i.ytimg.com/vi/${a}/mqdefault.jpg`, l = "youtube";
            }
        }
        if (!l || "vimeo" === l) {
            const t = n.match(/^.+vimeo.com\/(?:\/)?(video\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/);
            if (t) {
                const o = Object.assign(Object.assign({}, c().vimeo), e.vimeo || {}), s = $49aae305af93c6a5$var$i(n, o), r = encodeURIComponent(t[2]), a = t[5] || "";
                e.videoId = r, e.src = `https://player.vimeo.com/video/${r}?${a ? `h=${a}${s ? "&" : ""}` : ""}${s}`, l = "vimeo";
            }
        }
        e.type = l;
    }
    function u(e, i) {
        "html5video" === i.type && function(e) {
            const i = e.el, l = e.src;
            if (!s || !i || !l) return;
            const r = e.html5videoTpl || c().html5videoTpl, a = e.html5videoFormat || c().html5videoFormat;
            if (!r) return;
            const d = e.poster || (e.thumb && (0, $c7ba36523489ae88$export$844ec244b1367d54)(e.thumb) ? e.thumb : ""), m = (0, $b8a64cd90ff0bd86$export$b368690db5627d91)(r.replace(/\{\{src\}\}/gi, l + "").replace(/\{\{format\}\}/gi, a || "").replace(/\{\{poster\}\}/gi, d + ""));
            if (!m) return;
            const u = document.createElement("div");
            (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(u, "f-html"), u.append(m), e.contentEl = m, e.htmlEl = u, (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(i, `has-${e.type}`), i.prepend(u), v(e), s.emit("contentReady", e);
        }(i), "youtube" !== i.type && "vimeo" !== i.type || function(e) {
            const o = e.el, n = e.src;
            if (!s || !o || !n) return;
            const i = document.createElement("iframe");
            (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(i, "f-iframe"), i.setAttribute("id", `f-iframe_${e.videoId}`);
            for (const [t, e] of Object.entries(c().iframeAttr || {}))i.setAttribute(t, e);
            "youtube" === e.type && (i.onload = ()=>{
                var t;
                1 === (null == s ? void 0 : s.getState()) && (null === (t = i.contentWindow) || void 0 === t || t.postMessage(JSON.stringify({
                    event: "listening",
                    id: i.getAttribute("id")
                }), "*"));
            }), i.onerror = ()=>{
                null == s || s.showError(e, "{{IFRAME_ERROR}}");
            };
            const l = document.createElement("div");
            (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(l, "f-html"), l.append(i), e.contentEl = i, e.htmlEl = l, (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(o, `has-html has-iframe has-${e.type}`), i.src = `${e.src}`, o.prepend(l), v(e), s.emit("contentReady", e);
        }(i);
    }
    function f(t, e) {
        var o, n;
        "html5video" !== e.type && "youtube" !== e.type && "vimeo" !== e.type || (null === (o = e.contentEl) || void 0 === o || o.remove(), e.contentEl = void 0, null === (n = e.htmlEl) || void 0 === n || n.remove(), e.htmlEl = void 0), e.poller && clearTimeout(e.poller);
    }
    function p() {
        r = !1;
    }
    function h() {
        if (r) return;
        r = !0;
        const t = a();
        (t && void 0 !== t.autoplay ? t.autoplay : c().autoplay) && (function() {
            var t;
            const e = a(), o = null == e ? void 0 : e.el;
            if (o && "html5video" === (null == e ? void 0 : e.type)) try {
                const t = o.querySelector("video");
                if (t) {
                    const e = t.play();
                    void 0 !== e && e.then(()=>{}).catch((e)=>{
                        t.muted = !0, t.play();
                    });
                }
            } catch (t) {}
            const n = null == e ? void 0 : e.htmlEl;
            n instanceof HTMLIFrameElement && (null === (t = n.contentWindow) || void 0 === t || t.postMessage('{"event":"command","func":"stopVideo","args":""}', "*"));
        }(), function() {
            const t = a(), e = null == t ? void 0 : t.type;
            if (!(null == t ? void 0 : t.el) || "youtube" !== e && "vimeo" !== e) return;
            const o = ()=>{
                if (t.contentEl && t.contentEl instanceof HTMLIFrameElement && t.contentEl.contentWindow) {
                    let e;
                    if ("true" === t.contentEl.dataset.ready) return e = "youtube" === t.type ? {
                        event: "command",
                        func: "playVideo"
                    } : {
                        method: "play",
                        value: "true"
                    }, e && t.contentEl.contentWindow.postMessage(JSON.stringify(e), "*"), void (t.poller = void 0);
                    "youtube" === t.type && (e = {
                        event: "listening",
                        id: t.contentEl.getAttribute("id")
                    }, t.contentEl.contentWindow.postMessage(JSON.stringify(e), "*"));
                }
                t.poller = setTimeout(o, 250);
            };
            o();
        }());
    }
    function v(t) {
        const e = null == t ? void 0 : t.htmlEl;
        if (t && e && ("html5video" === t.type || "youtube" === t.type || "vimeo" === t.type)) {
            if (e.style.aspectRatio = "", e.style.width = "", e.style.height = "", e.style.maxWidth = "", e.style.maxHeight = "", t.width) {
                let o = `${t.width}`;
                o.match(/^\d+$/) && (o += "px"), e.style.maxWidth = `${o}`;
            }
            if (t.height) {
                let o = `${t.height}`;
                o.match(/^\d+$/) && (o += "px"), e.style.maxHeight = `${o}`;
            }
            if (t.aspectRatio) {
                const o = t.aspectRatio.split("/"), n = parseFloat(o[0].trim()), i = o[1] ? parseFloat(o[1].trim()) : 0, l = n && i ? n / i : n;
                e.offsetHeight;
                const s = e.getBoundingClientRect(), r = l < (s.width || 1) / (s.height || 1);
                e.style.aspectRatio = `${t.aspectRatio}`, e.style.width = r ? "auto" : "", e.style.height = r ? "" : "auto";
            }
        }
    }
    function y() {
        v(a());
    }
    return {
        init: function(t) {
            s = t, s.on("addSlide", m), s.on("attachSlideEl", u), s.on("detachSlideEl", f), s.on("ready", h), s.on("change", p), s.on("settle", h), s.on("refresh", y), window.addEventListener("message", d);
        },
        destroy: function() {
            null == s || s.off("addSlide", m), null == s || s.off("attachSlideEl", u), null == s || s.off("detachSlideEl", f), null == s || s.off("ready", h), null == s || s.off("change", p), null == s || s.off("settle", h), null == s || s.off("refresh", y), window.removeEventListener("message", d), s = void 0;
        }
    };
};


/*! License details at fancyapps.com/license */ 
const $c1bc0394b6fc8770$var$n = {
    autoStart: !1,
    btnTpl: '<button data-fullscreen-action="toggle" class="f-button" title="{{TOGGLE_FULLSCREEN}}"><svg><g><path d="M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M16 21h3a2 2 0 0 0 2-2v-3"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>'
}, $c1bc0394b6fc8770$var$t = "in-fullscreen-mode", $c1bc0394b6fc8770$export$159cd03be7087f39 = ()=>{
    let l;
    function u(t) {
        const u = null == l ? void 0 : l.getOptions().Fullscreen;
        let o = ((0, $1e899da006e724cc$export$53b83ca8eaab0383)(u) ? Object.assign(Object.assign({}, $c1bc0394b6fc8770$var$n), u) : $c1bc0394b6fc8770$var$n)[t];
        return o && "function" == typeof o && l ? o(l) : o;
    }
    function o() {
        var e;
        null === (e = null == l ? void 0 : l.getPlugins().Toolbar) || void 0 === e || e.add("fullscreen", {
            tpl: u("btnTpl")
        });
    }
    function c() {
        if (u("autoStart")) {
            const e = s();
            e && a(e);
        }
    }
    function i(e, n) {
        const t = n.target;
        t && !n.defaultPrevented && "toggle" === t.dataset.fullscreenAction && d();
    }
    function s() {
        return u("el") || (null == l ? void 0 : l.getContainer()) || void 0;
    }
    function r() {
        const e = document;
        return e.fullscreenEnabled ? !!e.fullscreenElement : !!e.webkitFullscreenEnabled && !!e.webkitFullscreenElement;
    }
    function a(e) {
        const n = document;
        let l;
        return e || (e = n.documentElement), n.fullscreenEnabled ? l = e.requestFullscreen() : n.webkitFullscreenEnabled && (l = e.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)), l && l.then(()=>{
            e.classList.add($c1bc0394b6fc8770$var$t);
        }), l;
    }
    function f() {
        const e = document;
        let n;
        return e.fullscreenEnabled ? n = e.fullscreenElement && e.exitFullscreen() : e.webkitFullscreenEnabled && (n = e.webkitFullscreenElement && e.webkitExitFullscreen()), n && n.then(()=>{
            var e;
            null === (e = s()) || void 0 === e || e.classList.remove($c1bc0394b6fc8770$var$t);
        }), n;
    }
    function d() {
        if (r()) f();
        else {
            const e = s();
            e && a(e);
        }
    }
    return {
        init: function(e) {
            l = e, l.on("initPlugins", o), l.on("ready", c), l.on("click", i);
        },
        destroy: function() {
            null == l || l.off("initPlugins", o), null == l || l.off("ready", c), null == l || l.off("click", i);
        },
        exit: f,
        inFullscreen: r,
        request: a,
        toggle: d
    };
};


/*! License details at fancyapps.com/license */ 

let $c785bc10e3466be8$var$n, $c785bc10e3466be8$var$o, $c785bc10e3466be8$var$r = !1, $c785bc10e3466be8$var$i = !1, $c785bc10e3466be8$var$l = !1, $c785bc10e3466be8$var$s = !1;
const $c785bc10e3466be8$var$a = ()=>{
    const t = new URL(document.URL).hash, e = t.slice(1).split("-"), n = e[e.length - 1], o = n && /^\+?\d+$/.test(n) && parseInt(e.pop() || "1", 10) || 1;
    return {
        urlHash: t,
        urlSlug: e.join("-"),
        urlIndex: o
    };
}, $c785bc10e3466be8$var$u = ()=>{
    const t = null == $c785bc10e3466be8$var$n ? void 0 : $c785bc10e3466be8$var$n.getInstance(), e = null == t ? void 0 : t.getState();
    return !(!t || 0 !== e && 1 !== e);
}, $c785bc10e3466be8$var$c = ()=>{
    if (!$c785bc10e3466be8$var$n) return;
    if ($c785bc10e3466be8$var$u()) return;
    const { urlSlug: t, urlIndex: e } = $c785bc10e3466be8$var$a();
    if (!t) return;
    let o = document.querySelector(`[data-slug="${t}"]`);
    o && $c785bc10e3466be8$var$n.fromTriggerEl(o), $c785bc10e3466be8$var$u() || (o = document.querySelectorAll(`[data-fancybox="${t}"]`)[e - 1], o && $c785bc10e3466be8$var$n.fromTriggerEl(o, {
        startIndex: e - 1
    })), $c785bc10e3466be8$var$u() && o && !o.closest("[inert]") && o.scrollIntoView({
        behavior: "instant",
        block: "center",
        inline: "center"
    });
}, $c785bc10e3466be8$var$d = (t)=>{
    const n = t.getOptions().Hash, o = t.getSlide();
    return o && (o.slug || o.fancybox || ((0, $1e899da006e724cc$export$53b83ca8eaab0383)(n) ? n.slug : "")) || "";
}, $c785bc10e3466be8$var$g = (t)=>{
    var e, n;
    const o = $c785bc10e3466be8$var$d(t), r = t.getSlide();
    if (!r || !o) return "";
    let i = parseInt(r.index + "", 10) + 1, l = r.slug ? `#${r.slug}` : `#${o}-${i}`;
    return ((null === (n = null === (e = t.getCarousel()) || void 0 === e ? void 0 : e.getPages()) || void 0 === n ? void 0 : n.length) || 0) < 2 && (l = `#${o}`), l;
}, $c785bc10e3466be8$var$f = ()=>{
    if (!$c785bc10e3466be8$var$n) return;
    if ($c785bc10e3466be8$var$l) return;
    const t = null == $c785bc10e3466be8$var$n ? void 0 : $c785bc10e3466be8$var$n.getInstance(), o = null == t ? void 0 : t.getCarousel(), { urlSlug: r, urlIndex: u } = $c785bc10e3466be8$var$a(), d = null == t ? void 0 : t.getOptions().Hash;
    if (!1 !== d) {
        if (t && 1 === t.getState() && o) {
            const n = o.getSlides();
            for (const t of n || [])if (t.slug === r || (t.fancybox === r || (0, $1e899da006e724cc$export$53b83ca8eaab0383)(d) && d.slug === r) && t.index === u - 1) return $c785bc10e3466be8$var$i = !1, void o.goTo(t.index);
            $c785bc10e3466be8$var$s = !0, t.close(), $c785bc10e3466be8$var$s = !1;
        }
        $c785bc10e3466be8$var$c();
    }
}, $c785bc10e3466be8$var$h = ()=>{
    $c785bc10e3466be8$var$n && ($c785bc10e3466be8$var$o = setTimeout(()=>{
        $c785bc10e3466be8$var$r = !0, $c785bc10e3466be8$var$c(), $c785bc10e3466be8$var$r = !1;
    }, 300), window.addEventListener("hashchange", $c785bc10e3466be8$var$f, !1));
};
let $c785bc10e3466be8$var$w;
function $c785bc10e3466be8$var$v() {
    history.scrollRestoration && $c785bc10e3466be8$var$w && (history.scrollRestoration = $c785bc10e3466be8$var$w, $c785bc10e3466be8$var$w = void 0);
}
const $c785bc10e3466be8$export$ab85ecd77ce6a5cd = ()=>{
    let t, e = "";
    function u() {
        var n;
        if (!t || !t.isTopMost() || !1 === t.getOptions().Hash) return;
        if ($c785bc10e3466be8$var$r) {
            const e = t.getOptions().sync;
            e && e.goTo((null === (n = null == t ? void 0 : t.getCarousel()) || void 0 === n ? void 0 : n.getPageIndex()) || 0, {
                transition: !1,
                tween: !1
            });
        }
        const o = t.getCarousel();
        if (!o) return;
        if (!t.getSlide()) return;
        const l = $c785bc10e3466be8$var$d(t);
        if (!l) return;
        const { urlHash: s, urlSlug: u } = $c785bc10e3466be8$var$a(), f = $c785bc10e3466be8$var$g(t);
        s !== f && (e = s), history.scrollRestoration && !$c785bc10e3466be8$var$w && ($c785bc10e3466be8$var$w = history.scrollRestoration, history.scrollRestoration = "manual", window.addEventListener("beforeunload", $c785bc10e3466be8$var$v)), o.on("change", c);
        const h = l !== u;
        try {
            window.history[h ? "pushState" : "replaceState"]({}, document.title, window.location.pathname + window.location.search + f), h && ($c785bc10e3466be8$var$i = !0);
        } catch (t) {}
    }
    function c() {
        if (!t || !t.isTopMost() || !1 === t.getOptions().Hash) return;
        if (!t.getSlide()) return;
        if (!$c785bc10e3466be8$var$d(t)) return;
        const e = $c785bc10e3466be8$var$g(t);
        $c785bc10e3466be8$var$l = !0;
        try {
            window.history.replaceState({}, document.title, window.location.pathname + window.location.search + e);
        } catch (t) {}
        $c785bc10e3466be8$var$l = !1;
    }
    function f() {
        var n;
        if (!t || !t.isTopMost() || !1 === t.getOptions().Hash || $c785bc10e3466be8$var$s) return;
        if ($c785bc10e3466be8$var$d(t)) {
            $c785bc10e3466be8$var$l = !0;
            try {
                $c785bc10e3466be8$var$i && !function() {
                    if (window.parent === window) return !1;
                    try {
                        var t = window.frameElement;
                    } catch (e) {
                        t = null;
                    }
                    return null === t ? "data:" === location.protocol : t.hasAttribute("sandbox");
                }() && "IFRAME" !== (null === (n = document.activeElement) || void 0 === n ? void 0 : n.nodeName) ? window.history.back() : window.history.replaceState({}, document.title, window.location.pathname + window.location.search + e);
            } catch (t) {}
            $c785bc10e3466be8$var$l = !1;
        }
    }
    return {
        init: function(e) {
            clearTimeout($c785bc10e3466be8$var$o), t = e, t.on("ready", u), t.on("close", f);
        },
        destroy: function() {
            null == t || t.off("ready", u), null == t || t.off("close", f);
            const e = null == t ? void 0 : t.getCarousel();
            e && e.off("change", c), t = void 0, (null == $c785bc10e3466be8$var$n ? void 0 : $c785bc10e3466be8$var$n.getInstance()) || ($c785bc10e3466be8$var$v(), window.removeEventListener("beforeunload", $c785bc10e3466be8$var$v));
        }
    };
};
$c785bc10e3466be8$export$ab85ecd77ce6a5cd.getInfoFromURL = $c785bc10e3466be8$var$a, $c785bc10e3466be8$export$ab85ecd77ce6a5cd.startFromUrl = $c785bc10e3466be8$var$c, $c785bc10e3466be8$export$ab85ecd77ce6a5cd.setup = function(e) {
    $c785bc10e3466be8$var$n || ($c785bc10e3466be8$var$n = e, (0, $a36657fcc43bb96f$export$71594e8a50f746f4)() && (/complete|interactive|loaded/.test(document.readyState) ? $c785bc10e3466be8$var$h() : document.addEventListener("DOMContentLoaded", $c785bc10e3466be8$var$h)));
};


/*! License details at fancyapps.com/license */ 
const $5539d3ae7a9213f3$export$30568d076ec2f42 = Object.assign(Object.assign({}, (0, $af8c7da03e8ae19f$export$30568d076ec2f42)), {
    CLOSE: "Close",
    NEXT: "Next",
    PREV: "Previous",
    MODAL: "You can close this modal content with the ESC key",
    ELEMENT_NOT_FOUND: "HTML Element Not Found",
    IFRAME_ERROR: "Error Loading Page",
    NO_CAPTION: "No Caption",
    TOGGLE_SIDEBAR: "Toggle sidebar"
});


const $8574823a93f98937$var$A = '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg tabindex="-1" width="24" height="24" viewBox="0 0 24 24"><path d="M19.286 4.714 4.714 19.286M4.714 4.714l14.572 14.572" /></svg></button>';
(0, $85165c1eb0f0af40$export$4c260019440d418f)().add("close", {
    tpl: $8574823a93f98937$var$A
});
const $8574823a93f98937$var$k = (e)=>{
    e.cancelable && e.preventDefault();
};
const $8574823a93f98937$var$R = (e = null, t = "", n)=>{
    if (!e || !e.parentElement || !t) return void (n && n());
    $8574823a93f98937$var$O(e);
    const o = (i)=>{
        i.target === e && e.dataset.animationName && (e.removeEventListener("animationend", o), delete e.dataset.animationName, n && n(), e.classList.remove(t));
    };
    e.dataset.animationName = t, e.addEventListener("animationend", o), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(e, t);
}, $8574823a93f98937$var$O = (e)=>{
    e && e.dispatchEvent(new CustomEvent("animationend", {
        bubbles: !1,
        cancelable: !0,
        currentTarget: e
    }));
};
var $8574823a93f98937$export$b3af8f1b99ca9976;
!function(e) {
    e[e.Init = 0] = "Init", e[e.Ready = 1] = "Ready", e[e.Closing = 2] = "Closing", e[e.Destroyed = 3] = "Destroyed";
}($8574823a93f98937$export$b3af8f1b99ca9976 || ($8574823a93f98937$export$b3af8f1b99ca9976 = {}));
const $8574823a93f98937$var$I = {
    ajax: null,
    backdropClick: "close",
    Carousel: {},
    closeButton: "auto",
    closeButtonTpl: $8574823a93f98937$var$A,
    closeExisting: !1,
    delegateEl: void 0,
    dragToClose: !0,
    fadeEffect: !0,
    groupAll: !1,
    groupAttr: "data-fancybox",
    hideClass: "f-fadeOut",
    hideScrollbar: !0,
    id: void 0,
    idle: !1,
    keyboard: {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: "next",
        PageDown: "prev",
        ArrowUp: "prev",
        ArrowDown: "next",
        ArrowRight: "next",
        ArrowLeft: "prev"
    },
    l10n: (0, $5539d3ae7a9213f3$export$30568d076ec2f42),
    mainClass: "",
    mainStyle: {},
    mainTpl: '<dialog class="fancybox__dialog">\n    <div class="fancybox__container" tabindex="0" aria-label="{{MODAL}}">\n      <div class="fancybox__backdrop"></div>\n      <div class="fancybox__carousel"></div>\n    </div>\n  </dialog>',
    modal: !0,
    on: {},
    parentEl: void 0,
    placeFocusBack: !0,
    showClass: "f-zoomInUp",
    startIndex: 0,
    sync: void 0,
    theme: "dark",
    triggerEl: void 0,
    triggerEvent: void 0,
    zoomEffect: !0
}, $8574823a93f98937$var$z = new Map;
let $8574823a93f98937$var$H = 0;
const $8574823a93f98937$var$B = "with-fancybox", $8574823a93f98937$var$D = ()=>{
    let r, C, M, A, D, q, N, V = $8574823a93f98937$export$b3af8f1b99ca9976.Init, W = Object.assign({}, $8574823a93f98937$var$I), $ = -1, K = {}, U = [], X = !1, G = !0, Y = 0;
    function Z(e, ...t) {
        let n = W[e];
        return n && "function" == typeof n ? n(Re, ...t) : n;
    }
    function J(e, t = []) {
        const n = Z("l10n") || {};
        e = String(e).replace(/\{\{(\w+)\}\}/g, (e, t)=>n[t] || e);
        for(let n = 0; n < t.length; n++)e = e.split(t[n][0]).join(t[n][1]);
        return e = e.replace(/\{\{(.*?)\}\}/g, (e, t)=>t);
    }
    const Q = new Map;
    function ee(e, ...t) {
        const n = [
            ...Q.get(e) || []
        ];
        for (const [t, o] of Object.entries(W.on || {}))(t === e || t.split(" ").indexOf(e) > -1) && n.push(o);
        for (const e of n)e && "function" == typeof e && e(Re, ...t);
        "*" !== e && ee("*", e, ...t);
    }
    function te() {
        (0, $a4c70e77d1c194a1$export$c2255604a80b4506)(C, "is-revealing");
        try {
            if (document.activeElement === r) ((null == C ? void 0 : C.querySelector("[autofocus]")) || C).focus();
        } catch (e) {}
    }
    function ne(e, n) {
        var o;
        ve(n), de(), null === (o = n.el) || void 0 === o || o.addEventListener("click", ie), "inline" !== n.type && "clone" !== n.type || function(e) {
            if (!A || !e || !e.el) return;
            let n = null;
            if ((0, $c7ba36523489ae88$export$844ec244b1367d54)(e.src)) {
                const t = e.src.split("#", 2).pop();
                n = t ? document.getElementById(t) : null;
            }
            if (n) {
                if ((0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(n, "f-html"), "clone" === e.type || n.closest(".fancybox__carousel")) {
                    n = n.cloneNode(!0);
                    const t = n.dataset.animationName;
                    t && (n.classList.remove(t), delete n.dataset.animationName);
                    let o = n.getAttribute("id");
                    o = o ? `${o}--clone` : `clone-${$}-${e.index}`, n.setAttribute("id", o);
                } else if (n.parentNode) {
                    const t = document.createElement("div");
                    t.inert = !0, n.parentNode.insertBefore(t, n), e.placeholderEl = t;
                }
                e.htmlEl = n, (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(e.el, "has-html"), e.el.prepend(n), n.classList.remove("hidden"), "none" === n.style.display && (n.style.display = ""), "none" === getComputedStyle(n).getPropertyValue("display") && (n.style.display = n.dataset.display || "flex"), null == A || A.emit("contentReady", e);
            } else null == A || A.showError(e, "{{ELEMENT_NOT_FOUND}}");
        }(n), "ajax" === n.type && function(e) {
            const t = e.el;
            if (!t) return;
            if (e.htmlEl || e.xhr) return;
            null == A || A.showLoading(e), e.state = 0;
            const n = new XMLHttpRequest;
            n.onreadystatechange = function() {
                if (n.readyState === XMLHttpRequest.DONE && V === $8574823a93f98937$export$b3af8f1b99ca9976.Ready) {
                    if (null == A || A.hideLoading(e), e.state = 1, 200 === n.status) {
                        let o = n.responseText + "", i = null, s = null;
                        if (e.filter) {
                            const t = document.createElement("div");
                            t.innerHTML = o, s = t.querySelector(e.filter + "");
                        }
                        s && s instanceof HTMLElement ? i = s : (i = document.createElement("div"), i.innerHTML = o), i.classList.add("f-html"), e.htmlEl = i, t.classList.add("has-html"), t.classList.add("has-ajax"), t.prepend(i), null == A || A.emit("contentReady", e);
                    } else null == A || A.showError(e);
                }
            };
            const o = Z("ajax") || null;
            n.open(o ? "POST" : "GET", e.src + ""), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), n.setRequestHeader("X-Requested-With", "XMLHttpRequest"), n.send(o), e.xhr = n;
        }(n);
    }
    function oe(e, t) {
        var n;
        ye(t), null === (n = t.el) || void 0 === n || n.removeEventListener("click", ie), "inline" !== t.type && "clone" !== t.type || function(e) {
            const t = e.htmlEl, n = e.placeholderEl;
            t && ("none" !== getComputedStyle(t).getPropertyValue("display") && (t.style.display = "none"), t.offsetHeight);
            n && (t && n.parentNode && n.parentNode.insertBefore(t, n), n.remove());
            e.htmlEl = void 0, e.placeholderEl = void 0;
        }(t), t.xhr && (t.xhr.abort(), t.xhr = void 0);
    }
    function ie(e) {
        if (!be()) return;
        if (V !== $8574823a93f98937$export$b3af8f1b99ca9976.Ready) return $8574823a93f98937$var$k(e), void e.stopPropagation();
        if (e.defaultPrevented) return;
        if (!(0, $d26b20f49452df26$export$1f911e2d31b2843e).isClickAllowed()) return;
        const t = e.composedPath()[0];
        t.closest(".fancybox__carousel") && t.classList.contains("fancybox__slide") && fe(e);
    }
    function se() {
        G = !1, C && A && C.classList.remove("is-revealing"), de();
        const e = Z("sync");
        if (A && e) {
            const t = e.getPageIndex(A.getPageIndex()) || 0;
            e.goTo(t, {
                transition: !1,
                tween: !1
            });
        }
    }
    function le() {
        var e;
        !function() {
            const e = null == A ? void 0 : A.getViewport();
            if (!Z("dragToClose") || !A || !e) return;
            if (D = (0, $d26b20f49452df26$export$1f911e2d31b2843e)(e).init(), !D) return;
            let t = !1, n = 0, o = 0, s = {}, l = 1;
            function r() {
                var e, t;
                null == q || q.spring({
                    clamp: !0,
                    mass: 1,
                    tension: 0 === o ? 140 : 960,
                    friction: 17,
                    restDelta: .1,
                    restSpeed: .1,
                    maxSpeed: 1 / 0
                }).from({
                    y: n
                }).to({
                    y: o
                }).start();
                const i = (null === (e = null == A ? void 0 : A.getViewport()) || void 0 === e ? void 0 : e.getBoundingClientRect().height) || 0, s = null === (t = Ee()) || void 0 === t ? void 0 : t.panzoomRef;
                if (i && s) {
                    if (0 === o) s.execute((0, $de7268de96c5ce00$export$9520bccbaf78266).Reset);
                    else {
                        const e = (0, $fa17a272154af804$export$871de8747c9eaa88)(Math.abs(n), 0, .33 * i, l, .77 * l, !1);
                        s.execute((0, $de7268de96c5ce00$export$9520bccbaf78266).ZoomTo, {
                            scale: e
                        });
                    }
                }
            }
            const c = (e)=>{
                var t;
                const n = e.srcEvent, o = n.target;
                return A && !((0, $d26b20f49452df26$export$c4dfce035d43d1e0)(n) && (null === (t = n.touches) || void 0 === t ? void 0 : t.length) > 1) && o && !(0, $ca2529f528ef56ef$export$e41e80160bed5714)(o);
            };
            q = (0, $04c8ca71f19bc6bc$export$208a41d6b4e37b97)().on("step", (t)=>{
                if (C && e && V === $8574823a93f98937$export$b3af8f1b99ca9976.Ready) {
                    const o = e.getBoundingClientRect().height;
                    n = Math.min(o, Math.max(-1 * o, t.y));
                    const i = (0, $fa17a272154af804$export$871de8747c9eaa88)(Math.abs(n), 0, .65 * o, 1, .2, !0);
                    C.style.setProperty("--f-drag-opacity", i + ""), C.style.setProperty("--f-drag-offset", n + "px");
                }
            }), D.on("start", function() {
                t || (null == q || q.pause(), o = n);
            }).on("panstart", (e)=>{
                var n, o;
                if (!t && c(e) && "y" === e.axis) {
                    $8574823a93f98937$var$k(e.srcEvent), t = !0, Ce(), null === (n = null == A ? void 0 : A.getViewport()) || void 0 === n || n.classList.add("is-dragging");
                    const i = null === (o = Ee()) || void 0 === o ? void 0 : o.panzoomRef;
                    if (i) {
                        l = i.getTransform().scale || 1;
                        const e = i.getOptions();
                        s = Object.assign({}, e), e.bounds = !1, e.gestures = !1;
                    }
                } else t = !1;
            }).on("pan", function(e) {
                t && c(e) && ($8574823a93f98937$var$k(e.srcEvent), e.srcEvent.stopPropagation(), "y" === e.axis && (o += e.deltaY, r()));
            }).on("end", (e)=>{
                var i, l, a;
                if (null === (i = null == A ? void 0 : A.getViewport()) || void 0 === i || i.classList.remove("is-dragging"), t) {
                    const t = null === (l = Ee()) || void 0 === l ? void 0 : l.panzoomRef;
                    if (t) {
                        null === (a = t.getTween()) || void 0 === a || a.end();
                        const e = t.getOptions();
                        e.bounds = s.bounds || !1, e.gestures = s.gestures || !1;
                    }
                    c(e) && "y" === e.axis && (Math.abs(e.velocityY) > 5 || Math.abs(n) > 50) && Me(e.srcEvent, "f-throwOut" + (e.velocityY > 0 ? "Down" : "Up"));
                }
                t = !1, V === $8574823a93f98937$export$b3af8f1b99ca9976.Ready && 0 !== n && (o = 0, r());
            });
        }(), document.body.addEventListener("click", pe), document.body.addEventListener("keydown", ge, {
            passive: !1,
            capture: !0
        }), de(), je();
        const t = Z("sync");
        A && t && (null === (e = t.getTween()) || void 0 === e || e.start()), he(Ee());
    }
    function re() {
        (null == A ? void 0 : A.canGoNext()) ? je() : Te();
    }
    function ae(e, t) {
        ve(t);
    }
    function ce(e, t) {
        ve(t), he(t);
    }
    function ue() {
        var e;
        const t = null == A ? void 0 : A.getPlugins().Thumbs;
        (0, $98c82c03f7f08e20$export$4a80062ca50b57c7)(C, "has-thumbs", (null == t ? void 0 : t.isEnabled()) || !1), (0, $98c82c03f7f08e20$export$4a80062ca50b57c7)(C, "has-vertical-thumbs", !!t && ("scrollable" === t.getType() || !0 === (null === (e = t.getCarousel()) || void 0 === e ? void 0 : e.isVertical())));
    }
    function de() {
        if (C) {
            const e = (null == A ? void 0 : A.getPages()) || [], t = (null == A ? void 0 : A.getPageIndex()) || 0;
            for (const e of C.querySelectorAll("[data-fancybox-index]"))e.innerHTML = t + "";
            for (const e of C.querySelectorAll("[data-fancybox-page]"))e.innerHTML = t + 1 + "";
            for (const t of C.querySelectorAll("[data-fancybox-pages]"))t.innerHTML = e.length + "";
        }
    }
    function fe(e) {
        if (!!e.composedPath()[0].closest("[data-fancybox-close]")) return void Me(e);
        if (ee("backdropClick", e), e.defaultPrevented) return;
        Z("backdropClick") && Me(e);
    }
    function me() {
        Pe();
    }
    function ge(e) {
        if (!be()) return;
        if (V !== $8574823a93f98937$export$b3af8f1b99ca9976.Ready) return;
        const t = e.key, o = Z("keyboard");
        if (!o) return;
        if (e.ctrlKey || e.altKey || e.shiftKey) return;
        const i = e.composedPath()[0];
        if (!(0, $eb5b53ddd8b73bd7$export$8ee0fc9ee280b4ee)(i)) return;
        if ("Escape" !== t && ((e)=>{
            const t = [
                "input",
                "textarea",
                "select",
                "option",
                "video",
                "iframe",
                "[contenteditable]",
                "[data-selectable]",
                "[data-draggable]"
            ].join(",");
            return e.matches(t) || e.closest(t);
        })(i)) return;
        if (ee("keydown", e), e.defaultPrevented) return;
        const s = o[t];
        if (s) switch(s){
            case "close":
                Me(e);
                break;
            case "next":
                $8574823a93f98937$var$k(e), null == A || A.next();
                break;
            case "prev":
                $8574823a93f98937$var$k(e), null == A || A.prev();
        }
    }
    function pe(e) {
        if (!be()) return;
        if (V !== $8574823a93f98937$export$b3af8f1b99ca9976.Ready) return;
        if (Pe(), e.defaultPrevented) return;
        const t = e.composedPath()[0], n = !!t.closest("[data-fancybox-close]"), o = t.classList.contains("fancybox__backdrop");
        (n || o) && fe(e);
    }
    function ve(e) {
        var t;
        const { el: n, htmlEl: i, panzoomRef: s, closeButtonEl: l } = e, r = s ? s.getWrapper() : i;
        if (!n || !n.parentElement || !r) return;
        let a = Z("closeButton");
        if ("auto" === a && (a = !0 !== (null === (t = null == A ? void 0 : A.getPlugins().Toolbar) || void 0 === t ? void 0 : t.isEnabled())), a) {
            if (!l) {
                const t = (0, $b8a64cd90ff0bd86$export$b368690db5627d91)(J(Z("closeButtonTpl")));
                t && ((0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(t, "is-close-button"), e.closeButtonEl = r.insertAdjacentElement("afterbegin", t), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(n, "has-close-btn"));
            }
        } else ye(e);
    }
    function ye(e) {
        e.closeButtonEl && (e.closeButtonEl.remove(), e.closeButtonEl = void 0), (0, $a4c70e77d1c194a1$export$c2255604a80b4506)(e.el, "has-close-btn");
    }
    function he(e) {
        if (!(G && A && 1 === A.getState() && e && e.index === A.getOptions().initialPage && e.el && e.el.parentElement)) return;
        if (void 0 !== e.state && 1 !== e.state) return;
        G = !1;
        const t = e.panzoomRef, n = null == t ? void 0 : t.getTween(), o = Z("zoomEffect") && n ? we(e) : void 0;
        if (t && n && o) {
            const { x: e, y: i, scale: s } = t.getStartPosition();
            return void n.spring({
                tension: 215,
                friction: 25,
                restDelta: .001,
                restSpeed: .001,
                maxSpeed: 1 / 0
            }).from(o).to({
                x: e,
                y: i,
                scale: s
            }).start();
        }
        const i = (null == t ? void 0 : t.getContent()) || e.htmlEl;
        i && $8574823a93f98937$var$R(i, Z("showClass", e));
    }
    function be() {
        var e;
        return (null === (e = $8574823a93f98937$export$cb45b08d97cdc4fd.getInstance()) || void 0 === e ? void 0 : e.getId()) === $;
    }
    function Ee() {
        var e;
        return null === (e = null == A ? void 0 : A.getPage()) || void 0 === e ? void 0 : e.slides[0];
    }
    function xe() {
        const e = Ee();
        return e ? e.triggerEl || Z("triggerEl") : void 0;
    }
    function we(e) {
        var t, n;
        const o = e.thumbEl;
        if (!o || !((e)=>{
            const t = e.getBoundingClientRect(), n = e.closest("[style]"), o = null == n ? void 0 : n.parentElement;
            if (n && n.style.transform && o) {
                const e = o.getBoundingClientRect();
                if (t.left < e.left || t.left > e.left + e.width - t.width) return !1;
                if (t.top < e.top || t.top > e.top + e.height - t.height) return !1;
            }
            const i = Math.max(document.documentElement.clientHeight, window.innerHeight), s = Math.max(document.documentElement.clientWidth, window.innerWidth);
            return !(t.bottom < 0 || t.top - i >= 0 || t.right < 0 || t.left - s >= 0);
        })(o)) return;
        const i = null === (n = null === (t = e.panzoomRef) || void 0 === t ? void 0 : t.getWrapper()) || void 0 === n ? void 0 : n.getBoundingClientRect(), s = null == i ? void 0 : i.width, l = null == i ? void 0 : i.height;
        if (!s || !l) return;
        const r = o.getBoundingClientRect();
        let a = r.width, c = r.height, u = r.left, d = r.top;
        if (!r || !a || !c) return;
        if (o instanceof HTMLImageElement) {
            const e = window.getComputedStyle(o).getPropertyValue("object-fit");
            if ("contain" === e || "scale-down" === e) {
                const { width: t, height: n } = ((e, t, n, o, i = "contain")=>{
                    if ("contain" === i || e > n || t > o) {
                        const i = n / e, s = o / t, l = Math.min(i, s);
                        e *= l, t *= l;
                    }
                    return {
                        width: e,
                        height: t
                    };
                })(o.naturalWidth, o.naturalHeight, a, c, e);
                u += .5 * (a - t), d += .5 * (c - n), a = t, c = n;
            }
        }
        if (Math.abs(s / l - a / c) > .1) return;
        return {
            x: u + .5 * a - (i.left + .5 * s),
            y: d + .5 * c - (i.top + .5 * l),
            scale: a / s
        };
    }
    function Le() {
        N && clearTimeout(N), N = void 0, document.removeEventListener("mousemove", me);
    }
    function je() {
        if (X) return;
        if (N) return;
        const e = Z("idle");
        e && (N = setTimeout(Se, e));
    }
    function Se() {
        C && (Le(), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(C, "is-idle"), document.addEventListener("mousemove", me), X = !0);
    }
    function Pe() {
        X && (Te(), je());
    }
    function Te() {
        Le(), null == C || C.classList.remove("is-idle"), X = !1;
    }
    function Ce() {
        const e = xe();
        var t;
        !e || (t = e.getBoundingClientRect()).bottom > 0 && t.right > 0 && t.left < (window.innerWidth || document.documentElement.clientWidth) && t.top < (window.innerHeight || document.documentElement.clientHeight) || e.closest("[inert]") || e.scrollIntoView({
            behavior: "instant",
            block: "center",
            inline: "center"
        });
    }
    function Me(e, t) {
        var n, o, i, s, r;
        if (V === $8574823a93f98937$export$b3af8f1b99ca9976.Closing || V === $8574823a93f98937$export$b3af8f1b99ca9976.Destroyed) return;
        const a = new Event("shouldClose", {
            bubbles: !0,
            cancelable: !0
        });
        if (ee("shouldClose", a, e), a.defaultPrevented) return;
        if (Le(), e) {
            if (e.defaultPrevented) return;
            $8574823a93f98937$var$k(e), e.stopPropagation(), e.stopImmediatePropagation();
        }
        if (V = $8574823a93f98937$export$b3af8f1b99ca9976.Closing, null == q || q.pause(), null == D || D.destroy(), A) {
            null === (n = A.getGestures()) || void 0 === n || n.destroy(), null === (o = A.getTween()) || void 0 === o || o.pause();
            for (const e of A.getSlides()){
                const t = e.panzoomRef;
                t && ((0, $1b7cd36eed9df61a$export$8b58be045bf06082)(t.getOptions(), {
                    clickAction: !1,
                    dblClickAction: !1,
                    wheelAction: !1,
                    bounds: !1,
                    minScale: 0,
                    maxScale: 1 / 0
                }), null === (i = t.getGestures()) || void 0 === i || i.destroy(), null === (s = t.getTween()) || void 0 === s || s.pause());
            }
        }
        const c = null == A ? void 0 : A.getPlugins();
        null === (r = null == c ? void 0 : c.Autoplay) || void 0 === r || r.stop();
        const u = null == c ? void 0 : c.Fullscreen;
        u && u.inFullscreen() ? Promise.resolve(u.exit()).then(()=>{
            setTimeout(()=>{
                Ae(e, t);
            }, 150);
        }) : Ae(e, t);
    }
    function Ae(e, t) {
        var n, o;
        if (V !== $8574823a93f98937$export$b3af8f1b99ca9976.Closing) return;
        ee("close", e), G = !1, document.body.removeEventListener("click", pe), document.body.removeEventListener("keydown", ge, {
            passive: !1,
            capture: !0
        }), Z("placeFocusBack") && Ce();
        const i = document.activeElement;
        i && (null == r ? void 0 : r.contains(i)) && i.blur(), Z("fadeEffect") && (null == C || C.classList.remove("is-ready"), null == C || C.classList.add("is-hiding")), null == C || C.classList.add("is-closing");
        const s = Ee(), l = null == s ? void 0 : s.el, a = null == s ? void 0 : s.panzoomRef, c = null === (n = null == s ? void 0 : s.panzoomRef) || void 0 === n ? void 0 : n.getTween(), u = t || Z("hideClass");
        let d = !1, m = !1;
        if (A && s && l && a && c) {
            let e;
            if (Z("zoomEffect") && 1 === s.state && (e = we(s)), e) {
                d = !0;
                const t = ()=>{
                    e = we(s), e ? c.to(Object.assign(Object.assign({}, (0, $de7268de96c5ce00$export$15463f5204f2871f)), e)) : ke();
                };
                a.on("refresh", ()=>{
                    t();
                }), c.easing((0, $04c8ca71f19bc6bc$export$208a41d6b4e37b97).Easings.EaseOut).duration(350).from(Object.assign({}, a.getTransform())).to(Object.assign(Object.assign({}, (0, $de7268de96c5ce00$export$15463f5204f2871f)), e)).start(), (null == l ? void 0 : l.getAnimations()) && (l.style.animationPlayState = "paused", requestAnimationFrame(()=>{
                    t();
                }));
            }
        }
        const g = (null == s ? void 0 : s.htmlEl) || (null === (o = null == s ? void 0 : s.panzoomRef) || void 0 === o ? void 0 : o.getWrapper());
        g && $8574823a93f98937$var$O(g), !d && u && g && (m = !0, $8574823a93f98937$var$R(g, u, ()=>{
            ke();
        })), d || m ? setTimeout(()=>{
            ke();
        }, 350) : ke();
    }
    function ke() {
        var e, t, n, o, i;
        if (V === $8574823a93f98937$export$b3af8f1b99ca9976.Destroyed) return;
        V = $8574823a93f98937$export$b3af8f1b99ca9976.Destroyed;
        const l = xe();
        ee("destroy"), null === (t = null === (e = Z("sync")) || void 0 === e ? void 0 : e.getPlugins().Autoplay) || void 0 === t || t.resume(), null === (o = null === (n = Z("sync")) || void 0 === n ? void 0 : n.getPlugins().Autoscroll) || void 0 === o || o.resume(), r instanceof HTMLDialogElement && r.close(), null === (i = null == A ? void 0 : A.getContainer()) || void 0 === i || i.classList.remove("is-idle"), null == A || A.destroy();
        for (const e of Object.values(K))null == e || e.destroy();
        if (K = {}, null == r || r.remove(), r = void 0, C = void 0, A = void 0, $8574823a93f98937$var$z.delete($), !$8574823a93f98937$var$z.size && ((0, $936b4faccea0b3c7$export$b539ed14f4f9e78)(!1), document.documentElement.classList.remove($8574823a93f98937$var$B), Z("placeFocusBack") && l && !l.closest("[inert]"))) try {
            null == l || l.focus({
                preventScroll: !0
            });
        } catch (e) {}
    }
    const Re = {
        close: Me,
        destroy: ke,
        getCarousel: function() {
            return A;
        },
        getContainer: function() {
            return C;
        },
        getId: function() {
            return $;
        },
        getOptions: function() {
            return W;
        },
        getPlugins: function() {
            return K;
        },
        getSlide: function() {
            return Ee();
        },
        getState: function() {
            return V;
        },
        init: function(t = [], n = {}) {
            V !== $8574823a93f98937$export$b3af8f1b99ca9976.Init && (Re.destroy(), V = $8574823a93f98937$export$b3af8f1b99ca9976.Init), W = (0, $1b7cd36eed9df61a$export$8b58be045bf06082)({}, $8574823a93f98937$var$I, n), $ = Z("id") || "fancybox-" + ++$8574823a93f98937$var$H;
            const a = $8574823a93f98937$var$z.get($);
            if (a && a.destroy(), $8574823a93f98937$var$z.set($, Re), ee("init"), function() {
                for (const [e, t] of Object.entries(Object.assign(Object.assign({}, $8574823a93f98937$export$cb45b08d97cdc4fd.Plugins), W.plugins || {})))if (e && !K[e] && t instanceof Function) {
                    const n = t();
                    n.init(Re), K[e] = n;
                }
                ee("initPlugins");
            }(), function(e = []) {
                ee("initSlides", e), U = [
                    ...e
                ];
            }(t), function() {
                const t = Z("parentEl") || document.body;
                if (!(t && t instanceof HTMLElement)) return;
                const n = J(Z("mainTpl") || "");
                if (r = (0, $b8a64cd90ff0bd86$export$b368690db5627d91)(n) || void 0, !r) return;
                if (C = r.querySelector(".fancybox__container"), !(C && C instanceof HTMLElement)) return;
                const l = Z("mainClass");
                l && (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(C, l);
                const a = Z("mainStyle");
                if (a && (0, $1e899da006e724cc$export$53b83ca8eaab0383)(a)) for (const [e, t] of Object.entries(a))C.style.setProperty(e, t);
                const u = Z("theme"), d = "auto" === u ? window.matchMedia("(prefers-color-scheme:light)").matches : "light" === u;
                C.setAttribute("theme", d ? "light" : "dark"), r.setAttribute("id", `${$}`), r.addEventListener("keydown", (e)=>{
                    "Escape" === e.key && $8574823a93f98937$var$k(e);
                }), r.addEventListener("wheel", (e)=>{
                    const t = e.target;
                    let n = Z("wheel", e);
                    t.closest(".f-thumbs") && (n = "slide");
                    const o = "slide" === n, s = [
                        -e.deltaX || 0,
                        -e.deltaY || 0,
                        -e.detail || 0
                    ].reduce(function(e, t) {
                        return Math.abs(t) > Math.abs(e) ? t : e;
                    }), l = Math.max(-1, Math.min(1, s)), r = Date.now();
                    Y && r - Y < 300 ? o && $8574823a93f98937$var$k(e) : (Y = r, ee("wheel", e, l), e.defaultPrevented || ("close" === n ? Me(e) : "slide" === n && A && !(0, $ca2529f528ef56ef$export$e41e80160bed5714)(t) && ($8574823a93f98937$var$k(e), A[l > 0 ? "prev" : "next"]())));
                }, {
                    capture: !0,
                    passive: !1
                }), r.addEventListener("cancel", (e)=>{
                    Me(e);
                }), t.append(r), 1 === $8574823a93f98937$var$z.size && (Z("hideScrollbar") && (0, $936b4faccea0b3c7$export$b539ed14f4f9e78)(!0), document.documentElement.classList.add($8574823a93f98937$var$B));
                ee("initLayout"), r instanceof HTMLDialogElement && (Z("modal") ? r.showModal() : r.show());
            }(), function() {
                if (M = (null == r ? void 0 : r.querySelector(".fancybox__carousel")) || void 0, !M) return;
                M.fancybox = Re;
                const e = (0, $1b7cd36eed9df61a$export$8b58be045bf06082)({}, {
                    Autoplay: {
                        autoStart: !1,
                        pauseOnHover: !1,
                        progressbarParentEl: (e)=>{
                            const t = e.getContainer();
                            return (null == t ? void 0 : t.querySelector(".f-carousel__toolbar [data-autoplay-action]")) || t;
                        }
                    },
                    Fullscreen: {
                        el: C
                    },
                    Toolbar: {
                        absolute: !0,
                        items: {
                            counter: {
                                tpl: '<div class="f-counter"><span data-fancybox-page></span>/<span data-fancybox-pages></span></div>'
                            }
                        },
                        display: {
                            left: [
                                "counter"
                            ],
                            right: [
                                "toggleFull",
                                "autoplay",
                                "fullscreen",
                                "thumbs",
                                "close"
                            ]
                        }
                    },
                    Video: {
                        autoplay: !0
                    },
                    Thumbs: {
                        minCount: 2,
                        Carousel: {
                            classes: {
                                container: "fancybox__thumbs"
                            }
                        }
                    },
                    classes: {
                        container: "fancybox__carousel",
                        viewport: "fancybox__viewport",
                        slide: "fancybox__slide"
                    },
                    spinnerTpl: '<div class="f-spinner" data-fancybox-close></div>',
                    dragFree: !1,
                    slidesPerPage: 1,
                    plugins: {
                        Sync: (0, $17ba7889db7bb96a$export$2ae15352e0a80063),
                        Arrows: (0, $f99c1e5e8827838d$export$b6e350ab9915297a),
                        Lazyload: (0, $b65fefa3c8c7a2c8$export$6f539aaa4f74fdd1),
                        Zoomable: (0, $f36d452514839cae$export$b7fc409e12a7dcec),
                        Html: (0, $1cf0fa01ca4e501c$export$13f9d3c4397c4713),
                        Video: (0, $49aae305af93c6a5$export$ae01dedf5c052bb),
                        Autoplay: (0, $f034ed8d818e362d$export$6c96167f46662e38),
                        Fullscreen: (0, $c1bc0394b6fc8770$export$159cd03be7087f39),
                        Thumbs: (0, $5a3448b7872fed9e$export$73e055b807a6709),
                        Toolbar: (0, $85165c1eb0f0af40$export$4c260019440d418f)
                    }
                }, Z("Carousel") || {}, {
                    slides: U,
                    enabled: !0,
                    initialPage: Z("startIndex") || 0,
                    l10n: Z("l10n")
                });
                A = (0, $c22e488d48123133$export$144901db2ea8e967)(M, e), ee("initCarousel", A), A.on("*", (e, t, ...n)=>{
                    ee(`Carousel.${t}`, e, ...n);
                }), A.on("attachSlideEl", ne), A.on("detachSlideEl", oe), A.on("contentLoading", ae), A.on("contentReady", ce), A.on("ready", le), A.on("change", se), A.on("settle", re), A.on("thumbs:ready", ue), A.on("thumbs:destroy", ue), A.init();
            }(), r && C) {
                if (Z("closeExisting")) for (const [e, t] of $8574823a93f98937$var$z.entries())e !== $ && t.close();
                Z("fadeEffect") ? (setTimeout(()=>{
                    te();
                }, 500), (0, $388a9fa95929b219$export$d2cf6cd1dc7067d3)(C, "is-revealing")) : te(), C.classList.add("is-ready"), V = $8574823a93f98937$export$b3af8f1b99ca9976.Ready, ee("ready");
            }
        },
        isCurrentSlide: function(e) {
            const t = Ee();
            return !(!e || !t) && t.index === e.index;
        },
        isTopMost: function() {
            return be();
        },
        localize: J,
        off: function(e, t) {
            return Q.has(e) && Q.set(e, Q.get(e).filter((e)=>e !== t)), Re;
        },
        on: function(e, t) {
            return Q.set(e, [
                ...Q.get(e) || [],
                t
            ]), Re;
        },
        toggleIdle (e) {
            (X || !0 === e) && Se(), X && !1 !== e || Te();
        }
    };
    return Re;
};
function $8574823a93f98937$var$q() {
    for (const e of Object.values($8574823a93f98937$export$cb45b08d97cdc4fd.Plugins)){
        const t = e.setup;
        "function" == typeof t && t($8574823a93f98937$export$cb45b08d97cdc4fd);
    }
}
function $8574823a93f98937$var$N(e, t = {}) {
    var n, o, i;
    if (!(e && e instanceof Element)) return;
    let s, r, a, c, u = {};
    for (const [t, n] of $8574823a93f98937$export$cb45b08d97cdc4fd.openers)if (t.contains(e)) for (const [o, i] of n){
        let n;
        if (o) {
            for (const i of t.querySelectorAll(o))if (i.contains(e)) {
                n = i;
                break;
            }
            if (!n) continue;
        }
        for (const [o, d] of i){
            let i = null;
            try {
                i = e.closest(o);
            } catch (e) {}
            i && (r = t, a = n, s = i, c = o, (0, $1b7cd36eed9df61a$export$8b58be045bf06082)(u, d || {}));
        }
    }
    if (!r || !c || !s) return;
    const d = (0, $1b7cd36eed9df61a$export$8b58be045bf06082)({}, $8574823a93f98937$var$I, t, u, {
        triggerEl: s
    });
    let f = [].slice.call((a || r).querySelectorAll(c));
    const m = s.closest(".f-carousel"), g = null == m ? void 0 : m.carousel;
    if (g && (!a || !m.contains(a))) {
        const e = [];
        for (const t of null == g ? void 0 : g.getSlides()){
            const n = t.el;
            n && (n.matches(c) ? e.push(n) : e.push(...[].slice.call(n.querySelectorAll(c))));
        }
        e.length && (f = [
            ...e
        ], null === (n = g.getPlugins().Autoplay) || void 0 === n || n.pause(), null === (o = g.getPlugins().Autoscroll) || void 0 === o || o.pause(), d.sync = g);
    }
    if (!1 === d.groupAll) {
        const e = d.groupAttr, t = e && s ? s.getAttribute(`${e}`) : "";
        f = e && t ? f.filter((n)=>n.getAttribute(`${e}`) === t) : [
            s
        ];
    }
    if (!f.length) return;
    null === (i = d.triggerEvent) || void 0 === i || i.preventDefault();
    const p = $8574823a93f98937$export$cb45b08d97cdc4fd.getInstance(), v = null == p ? void 0 : p.getState();
    if (p && (v === $8574823a93f98937$export$b3af8f1b99ca9976.Init || v === $8574823a93f98937$export$b3af8f1b99ca9976.Ready)) {
        const e = p.getOptions().triggerEl;
        if (e && f.indexOf(e) > -1) return;
    }
    return Object.assign({}, d.Carousel || {}).rtl && (f = f.reverse()), s && void 0 === t.startIndex && (d.startIndex = f.indexOf(s)), $8574823a93f98937$export$cb45b08d97cdc4fd.fromNodes(f, d);
}
const $8574823a93f98937$export$cb45b08d97cdc4fd = {
    Plugins: {
        Hash: (0, $c785bc10e3466be8$export$ab85ecd77ce6a5cd)
    },
    version: "6.1.13",
    openers: new Map,
    bind: function(e, n, o, i) {
        if (!(0, $a36657fcc43bb96f$export$71594e8a50f746f4)()) return;
        let s = document.body, l = null, a = "[data-fancybox]", c = {};
        e instanceof Element && (s = e), (0, $c7ba36523489ae88$export$844ec244b1367d54)(e) && (0, $c7ba36523489ae88$export$844ec244b1367d54)(n) ? (l = e, a = n) : (0, $c7ba36523489ae88$export$844ec244b1367d54)(n) && (0, $c7ba36523489ae88$export$844ec244b1367d54)(o) ? (l = n, a = o) : (0, $c7ba36523489ae88$export$844ec244b1367d54)(n) ? a = n : (0, $c7ba36523489ae88$export$844ec244b1367d54)(e) && (a = e), "object" == typeof n && (c = n || {}), "object" == typeof o && (c = o || {}), "object" == typeof i && (c = i || {}), function(e, t, n, o = {}) {
            if (!(e && e instanceof Element && n)) return;
            const i = $8574823a93f98937$export$cb45b08d97cdc4fd.openers.get(e) || new Map, s = i.get(t) || new Map;
            s.set(n, o), i.set(t, s), $8574823a93f98937$export$cb45b08d97cdc4fd.openers.set(e, i), 1 === i.size && e.addEventListener("click", $8574823a93f98937$export$cb45b08d97cdc4fd.fromEvent), $8574823a93f98937$var$q();
        }(s, l, a, c);
    },
    close: function(e = !0, ...t) {
        if (e) for (const e of $8574823a93f98937$var$z.values())e.close(...t);
        else {
            const e = $8574823a93f98937$export$cb45b08d97cdc4fd.getInstance();
            e && e.close(...t);
        }
    },
    destroy: function() {
        let e;
        for(; e = $8574823a93f98937$export$cb45b08d97cdc4fd.getInstance();)e.destroy();
        for (const e of $8574823a93f98937$export$cb45b08d97cdc4fd.openers.keys())e.removeEventListener("click", $8574823a93f98937$export$cb45b08d97cdc4fd.fromEvent);
        $8574823a93f98937$export$cb45b08d97cdc4fd.openers.clear();
    },
    fromEvent: function(e) {
        if (e.defaultPrevented) return;
        if (e.button && 0 !== e.button) return;
        if (e.ctrlKey || e.metaKey || e.shiftKey) return;
        let t = e.composedPath()[0];
        const n = {
            triggerEvent: e
        };
        if (t.closest(".fancybox__container.is-hiding")) return $8574823a93f98937$var$k(e), void e.stopPropagation();
        const o = t.closest("[data-fancybox-delegate]") || void 0;
        if (o) {
            const e = o.dataset.fancyboxDelegate || "", i = document.querySelectorAll(`[data-fancybox="${e}"]`), s = parseInt(o.dataset.fancyboxIndex || "", 10) || 0;
            t = i[s] || i[0], (0, $1b7cd36eed9df61a$export$8b58be045bf06082)(n, {
                delegateEl: o,
                startIndex: s
            });
        }
        return $8574823a93f98937$var$N(t, n);
    },
    fromNodes: function(e, t) {
        t = (0, $1b7cd36eed9df61a$export$8b58be045bf06082)({}, $8574823a93f98937$var$I, t || {});
        const n = [], o = (e)=>e instanceof HTMLImageElement ? e : e instanceof HTMLElement ? e.querySelector("img:not([aria-hidden])") : void 0;
        for (const i of e){
            const s = i.dataset || {}, l = t.delegateEl && e.indexOf(i) === t.startIndex ? t.delegateEl : void 0, r = o(l) || o(i) || void 0, a = s.src || i.getAttribute("href") || i.getAttribute("currentSrc") || i.getAttribute("src") || void 0, c = s.thumb || s.thumbSrc || (null == r ? void 0 : r.getAttribute("currentSrc")) || (null == r ? void 0 : r.getAttribute("src")) || (null == r ? void 0 : r.dataset.lazySrc) || void 0, u = {
                src: a,
                alt: s.alt || (null == r ? void 0 : r.getAttribute("alt")) || void 0,
                thumbSrc: c,
                thumbEl: r,
                triggerEl: i,
                delegateEl: l
            };
            for(const e in s){
                let t = s[e] + "";
                t = "false" !== t && ("true" === t || t), u[e] = t;
            }
            n.push(u);
        }
        return $8574823a93f98937$export$cb45b08d97cdc4fd.show(n, t);
    },
    fromSelector: function(e, n, o, i) {
        if (!(0, $a36657fcc43bb96f$export$71594e8a50f746f4)()) return;
        let s = document.body, l = null, a = "[data-fancybox]", c = {};
        e instanceof Element && (s = e), (0, $c7ba36523489ae88$export$844ec244b1367d54)(e) && (0, $c7ba36523489ae88$export$844ec244b1367d54)(n) ? (l = e, a = n) : (0, $c7ba36523489ae88$export$844ec244b1367d54)(n) && (0, $c7ba36523489ae88$export$844ec244b1367d54)(o) ? (l = n, a = o) : (0, $c7ba36523489ae88$export$844ec244b1367d54)(n) ? a = n : (0, $c7ba36523489ae88$export$844ec244b1367d54)(e) && (a = e), "object" == typeof n && (c = n || {}), "object" == typeof o && (c = o || {}), "object" == typeof i && (c = i || {});
        for (const [e, t] of $8574823a93f98937$export$cb45b08d97cdc4fd.openers)for (const [n, o] of t)for (const [t, i] of o)if (e === s && n === l) {
            const e = s.querySelector((n ? `${n} ` : "") + a);
            if (e && e.matches(t)) return $8574823a93f98937$export$cb45b08d97cdc4fd.fromTriggerEl(e, c);
        }
    },
    fromTriggerEl: $8574823a93f98937$var$N,
    getCarousel: function() {
        var e;
        return (null === (e = $8574823a93f98937$export$cb45b08d97cdc4fd.getInstance()) || void 0 === e ? void 0 : e.getCarousel()) || void 0;
    },
    getDefaults: function() {
        return $8574823a93f98937$var$I;
    },
    getInstance: function(e) {
        if (e) {
            const t = $8574823a93f98937$var$z.get(e);
            return t && t.getState() !== $8574823a93f98937$export$b3af8f1b99ca9976.Destroyed ? t : void 0;
        }
        return Array.from($8574823a93f98937$var$z.values()).reverse().find((e)=>{
            if (e.getState() !== $8574823a93f98937$export$b3af8f1b99ca9976.Destroyed) return e;
        }) || void 0;
    },
    getSlide: function() {
        var e;
        return (null === (e = $8574823a93f98937$export$cb45b08d97cdc4fd.getInstance()) || void 0 === e ? void 0 : e.getSlide()) || void 0;
    },
    show: function(e = [], t = {}) {
        return $8574823a93f98937$var$q(), $8574823a93f98937$var$D().init(e, t);
    },
    unbind: function(e, n, o) {
        if (!(0, $a36657fcc43bb96f$export$71594e8a50f746f4)()) return;
        let i = document.body, s = null, l = "[data-fancybox]";
        e instanceof Element && (i = e), (0, $c7ba36523489ae88$export$844ec244b1367d54)(e) && (0, $c7ba36523489ae88$export$844ec244b1367d54)(n) ? (s = e, l = n) : (0, $c7ba36523489ae88$export$844ec244b1367d54)(n) && (0, $c7ba36523489ae88$export$844ec244b1367d54)(o) ? (s = n, l = o) : (0, $c7ba36523489ae88$export$844ec244b1367d54)(n) ? l = n : (0, $c7ba36523489ae88$export$844ec244b1367d54)(e) && (l = e), function(e, t, n) {
            if (!(e && e instanceof Element && n)) return;
            const o = $8574823a93f98937$export$cb45b08d97cdc4fd.openers.get(e) || new Map, i = o.get(t) || new Map;
            i && n && i.delete(n), i.size && n || o.delete(t), o.size || ($8574823a93f98937$export$cb45b08d97cdc4fd.openers.delete(e), e.removeEventListener("click", $8574823a93f98937$export$cb45b08d97cdc4fd.fromEvent));
        }(i, s, l);
    }
};














function $236187f1ee4c1e65$var$toRomanNumeral(year) {
    const vals = [
        [
            1000,
            'M'
        ],
        [
            900,
            'CM'
        ],
        [
            500,
            'D'
        ],
        [
            400,
            'CD'
        ],
        [
            100,
            'C'
        ],
        [
            90,
            'XC'
        ],
        [
            50,
            'L'
        ],
        [
            40,
            'XL'
        ],
        [
            10,
            'X'
        ],
        [
            9,
            'IX'
        ],
        [
            5,
            'V'
        ],
        [
            4,
            'IV'
        ],
        [
            1,
            'I'
        ]
    ];
    let result = '';
    for (const [value, numeral] of vals)while(year >= value){
        result += numeral;
        year -= value;
    }
    return result;
}
const $236187f1ee4c1e65$var$yearEl = document.querySelector('.year');
if ($236187f1ee4c1e65$var$yearEl) $236187f1ee4c1e65$var$yearEl.textContent = $236187f1ee4c1e65$var$toRomanNumeral(new Date().getFullYear());
document.addEventListener('DOMContentLoaded', function() {
    (0, $8574823a93f98937$export$cb45b08d97cdc4fd).bind("[data-fancybox]", {
        Carousel: {
            infinite: false,
            Thumbs: false,
            Toolbar: {
                display: {
                    left: [],
                    middle: [],
                    right: [
                        'close'
                    ]
                }
            },
            Zoomable: {
                Panzoom: {
                    clickAction: false
                }
            }
        },
        placeFocusBack: false
    });
});


//# sourceMappingURL=matthew-anderson.06a00a54.js.map
